export default {
  translation: {
    Automation_flow_templates: "Flow-Vorlagen",
    Automation_ai_templates: "KI-Vorlagen",
    Automation_sample: "Beispiel",
    Automation_sample_notice: "Sie können vorgefertigte Vorlagen verwenden und anpassen",
    Automation_template_number: "Vorlage Nr. {{number}}",
    Automation_beginner: "Anfänger",
    Automation_intermediate: "Fortgeschritten",
    Automation_advanced: "Experte",
    Automation_trending: "Im Trend",
    Automation_sample_cart: "Warenkorb wiederherstellen",
    Automation_sample_cart_description: "Beispielidee: Kunden zum Warenkorb zurückführen und Kauffragen beantworten.",
    Automation_sample_language: "Mehrsprachige Gespräche",
    Automation_sample_language_description:
      "Beispielidee: Besucher zu einem Gespräch in ihrer bevorzugten Sprache führen.",
    Automation_sample_support: "Kundensupport-Assistent",
    Automation_sample_support_description:
      "Beispielidee: Häufige Fragen beantworten und Kunden zum nächsten Schritt führen.",
    Automation_sample_welcome: "Neue Kunden begrüßen",
    Automation_sample_welcome_description:
      "Beispielidee: Besucher begrüßen und Ihre Produkte und Leistungen vorstellen.",
    Automation_flow_history: "Flow-Verlauf",
    Automation_ai_history: "KI-Verlauf",
    Automation_loaded_count: "Geladene Einträge; + zeigt weitere verfügbare Einträge an.",
    Automation_sort_newest: " neueste zuerst",
    Automation_sort_oldest: " älteste zuerst",
    Automation_sort_title: " nach Titel",
    Automation_connected_posts: "Verknüpfte Beiträge",
    Automation_not_connected: "Mit keinem Beitrag verknüpft.",
    Automation_connections_access:
      "Kommentarberechtigung und Zugriff auf Automatisierung/Kommentare sind erforderlich.",
    Automation_checking_connections: "Beitragsverknüpfungen werden geprüft...",
    Automation_connections_retry: "Nicht alle Verknüpfungen konnten geprüft werden. Erneut versuchen.",
    aiSuggestedPrompts_title: "Vorgeschlagene Prompts",
    aiSuggestedPrompts_openImage: "Bild im Vollbild öffnen",
    aiSuggestedPrompts_explain: "Wählen Sie einen Prompt als Ausgangspunkt.",
    aiSuggestedPrompts_category: "Prompt-Kategorie",
    aiSuggestedPrompts_subCategory: "Unterkategorie",
    aiSuggestedPrompts_allCategories: "Alle Kategorien",
    aiSuggestedPrompts_loading: "Wird geladen...",
    aiSuggestedPrompts_empty: "Keine vorgeschlagenen Prompts gefunden.",
    aiSuggestedPrompts_loadMore: "Mehr laden",
    aiSuggestedPrompts_prompt: "Prompt",
    aiSuggestedPrompts_copy: "Prompt kopieren",
    aiSuggestedPrompts_showMore: "Mehr anzeigen",
    aiSuggestedPrompts_showLess: "Weniger anzeigen",
    unpin: "Lösen",
    pin: "Anheften",
    usethisPrompt: "Im Prompt verwenden",
    AudienceTooltip:
      "Für eine genauere Messung Ihrer aktuellen Interaktionen basieren die Statistiken auf Ihrer Leistung der letzten 30 Tage; Instagram-Statistiken beziehen sich auf den gesamten Aktivitätszeitraum des Kontos und können von diesen Daten abweichen",
    toggleShowAll: "Alles anzeigen",
    toggleShowmonthly: "Monatlich anzeigen",
    Nodetutorial: "Blockbeschreibung",
    Dublicate: "Duplizieren",
    zoomout: "Verkleinern",
    fitscreen: "An Bildschirm anpassen",
    zoomin: "Vergrößern",
    shortcuts: "Tastenkombinationen",
    Workflow_Statistics: "Workflow-Statistiken",
    Nodes: "Knoten",
    History_saved: "Gespeicherte Verläufe",
    Data_Management_explain:
      "Sie können Ihren Workflow speichern und bei Bedarf Workflows von anderen Plattformen importieren.",
    flow_shortcuts_explain:
      "Tastenkombinationen zur Erhöhung der Geschwindigkeit und Effizienz bei der Verwaltung von Workflows.",
    Connections: "Verbindungen",
    Last_Auto_saved: "Zuletzt automatisch gespeichert",
    Canvas_Behavior: "Canvas-Verhalten",
    Canvas_Behavior_explain: "Richten Sie das Raster-Snapping und die Schwenkgrenzen für bessere Kontrolle ein",
    Data_Management: "Datenverwaltung",
    importJSON_success: "Datei erfolgreich importiert",
    importJSON_error: "Fehler beim Importieren der Datei",
    exportJSON: "JSON exportieren",
    importJSON: "JSON importieren",

    quantity: "Menge",
    allquantity: "Gesamtmenge",
    remainingquantity: "Verbleibende Menge",
    Connecting: "Verbinde",
    Connected: "Verbunden",
    EmailNotification: "E-Mail-Benachrichtigungen",
    EmailNotificationExplain: "Systembenachrichtigungen werden an diese E-Mail-Adresse gesendet.",
    MobileNotification: "Mobile Benachrichtigungen",
    MobileNotificationExplain: "Systembenachrichtigungen werden an diese Handynummer gesendet.",
    Responded: "Beantwortet",
    notimelimit: "Ohne Zeitlimit",
    loading: "Wird geladen...",
    Beginner: "Anfänger",
    Basic: "Basis",
    Growing: "Wachsende",
    Advanced: "Fortgeschritten",
    Professional: "Professionell",
    Special: "Besonders",
    Unavailable: "Nicht verfügbar",
    menu: "Menü",
    level: "Stufe",
    usersettingexplain:
      "Instagram-Kontoinformationen können nur in Instagram geändert werden und werden hier automatisch aktualisiert.",
    bestposts: "Beste Beiträge",
    unselect: "Auswahl aufheben",
    daysAgo: "Vor ein paar Tagen",
    hoursAgo: "Vor ein paar Stunden",
    minutesAgo: "Vor ein paar Minuten",
    justNow: "Gerade eben",
    upgradeyouraccount: "Aktualisieren Sie Ihr Konto",
    featureNotAvailable: "Diese Funktion ist nicht verfügbar",
    featureNotAvailableDesc: "Upgraden Sie Ihr Konto, um diese Funktion zu nutzen.",
    likeaprouser: "Starten Sie ein echtes Geschäft",
    followerrate: "Wachstumsrate der Follower",
    shoppertitle: "Alles bereit zum Verkauf 👌",
    advertisertitle: "Alles bereit für Werbung 👌",
    shopperdescription: "Verfolgen Sie Ihre Verkaufsleistung genau.",
    advertiserdescription: "Verfolgen Sie Ihre Werbeleistung genau.",
    syncingAccountTitle: "Informationen werden abgerufen",
    syncingAccountDescription: "Ihre Instagram-Informationen werden in Brancy aktualisiert",
    syncingAccountDescriptiontooltip:
      "Einige Ihrer Informationen werden innerhalb der nächsten 24 Stunden aktualisiert.",
    subscriptionExpiringTitle: "Ihr Abonnement läuft bald ab",
    subscriptionExpiringDescription:
      "Verlängern Sie Ihr Abonnement, um die verfügbaren Funktionen weiterhin nutzen zu können.",
    subscriptionDaysRemaining: "{{days}} Tage verbleibend",
    priceHistory: "Preisverlauf",
    // #region landing page
    shopper: "Verkäufer",
    onlinestore: "Online-Shop",
    onlinestoreExplain: "Alles, was Sie für mehr Verkäufe brauchen – an einem Ort.",
    influencerExplain: "Alle Tools für Werbetreibende und Influencer – professionell vereint",
    advertiser: "Werbetreibender",
    influencer: "Influencer",
    skip: "Überspringen",
    skipfornow: "Jetzt überspringen",
    freedays: "40 Tage",
    freedaysExplain:
      "Wenn Sie eine aktive und wachsende Instagram-Seite haben, ist dieser Plan genau für Sie gemacht. Voller Zugriff auf Tools, Statistiken, Inhalts-, Nachrichten- und Kommentarverwaltung sowie Erstellung von Team-Admins in Brancy ist aktiviert.",
    instagramerplanactive: "Ihr Instagram-Plan ist aktiv",
    influencerplanactive: "Ihr Influencer-Plan ist aktiv",
    onlinestoreplanactive: "Ihr Online-Shop-Plan ist aktiv",

    SwitchtoUserpanel: "Zum Benutzerbereich wechseln",
    chooselanguage: "Sprache wählen",
    chooselanguageExplain: "Wählen Sie Ihre bevorzugte Sprache aus",
    chooseTheme: "Thema wählen",
    chooseThemeExplain: "Wählen Sie Ihr Lieblingsthema",
    chooseCalendar: "Kalender wählen",
    chooseCalendarExplain: "Wählen Sie den gewünschten Kalendertyp",
    setupchooseexplain: "Diese Einstellungen können später unter Einstellungen geändert werden",

    Lottery: "Lotterie",
    services: "Funktionen",
    markets: "Plattformen",
    pricing: "Preisgestaltung",
    page1_text1: "Instagram Business Management",
    page1_text2: "Mit der nächsten Generation von",
    page1_StartNow: "Ein kostenloser Start mit Zugang zu professionellen Werkzeugen",
    page1_services: "Dienste",
    page1_analytics: "Analysen",
    page1_transportation: "Transport",
    page1_financial_solutions: "Finanzlösungen",
    page1_customer_communication: "Kundekommunikation",
    page1_content_management: "Inhaltsverwaltung",
    page1_artificial_intelligence: "Künstliche Intelligenz",
    page1_tools: "Werkzeuge",
    page1_advertises: "Werbung verwalten",
    page2_text1: "Die umfassendsten Geschäftsleistungen und -lösungen",
    page2_text2:
      "Brancy ist ein leistungsstarkes Tool zur Verwaltung Ihres Instagram-Kontos und bietet Ihnen die Werkzeuge, die Sie für den Erfolg benötigen.",
    page2_ads_statistics_title: "Statistiken",
    page2_ads_statistics_description: "Fortschrittliches Performance-Analyse-Tool",
    page2_ads_statistics_servicedescription:
      "Überwachen Sie alle wichtigen Werbeleistungskennzahlen Ihrer Seite präzise, in Echtzeit und analytisch. Erhalten Sie professionelle Einblicke zur Optimierung Ihrer Kampagnen.",
    page2_ads_calendar_title: "Arbeitskalender",
    page2_ads_calendar_description: "Praktischste Anzeigenverwaltung",
    page2_ads_calendar_servicedescription:
      "Verwalten Sie alle Ihre Anzeigen – sowohl genehmigt als auch von KI vorgeschlagen – in einem smarten Kalender mit fortschrittlichem, organisiertem Zeitplan. Schnelle, fehlerfreie Planung.",
    page2_ads_adlist_title: "Anzeigenliste",
    page2_ads_adlist_description: "Anzeige-Warteschlange zur Genehmigung anzeigen",
    page2_ads_adlist_servicedescription:
      "Sehen Sie eine klare, kategorisierte Liste der ausstehenden Anzeigen und genehmigen oder lehnen Sie diese mit einem Klick ab. Vereinfachen Sie Ihre Anzeigenverwaltung professionell.",
    page2_store_addproduct_title: "Produkt hinzufügen",
    page2_store_addproduct_description: "Alle Produkte Ihrer Seite erkennen",
    page2_store_addproduct_servicedescription:
      "Unser intelligentes System erkennt alle Produkte in Ihren Beiträgen und bereitet sie automatisch zum Hinzufügen vor. Erhöht Ihre Geschwindigkeit und minimiert Fehler.",
    page2_store_productlist_title: "Produktliste",
    page2_store_productlist_description: "Lager- und Produktverwaltung",
    page2_store_productlist_servicedescription:
      "Verwalten Sie Produkte und Lager professionell, präzise und sorgenfrei. Alles intelligent und mit vollständigen Berichten verfügbar.",
    page2_store_orders_title: "Bestellungen",
    page2_store_orders_description: "Bestell-, Rechnungs- und Versandmanagement",
    page2_store_orders_servicedescription:
      "Alle Schritte von Bestellung bis Rechnung und Sendungsverfolgung sind automatisiert und nahtlos. Garantiert schnelle, genaue und fehlerfreie Kundenerfahrung.",
    page2_store_statistics_title: "Statistiken",
    page2_store_statistics_description: "Fortschrittliches Analyse-Tool",
    page2_store_statistics_servicedescription:
      "Verfolgen Sie Umsatz, Einnahmen und Wachstumstrends aus verschiedenen Blickwinkeln und treffen Sie smarte datenbasierte Entscheidungen.",
    page2_delivery_smartshipping_title: "Intelligente Versandkosten",
    page2_delivery_smartshipping_description: "Kosten nach Herkunft, Ziel, Größe und Gewicht",
    page2_delivery_smartshipping_servicedescription:
      "Versandkosten werden präzise und automatisch basierend auf Herkunft, Ziel, Abmessungen und Gewicht berechnet. Bietet genaue Gebühren ohne menschliche Fehler.",
    page2_delivery_postalservice_title: "Postdienst",
    page2_delivery_postalservice_description: "Paketsammlung und Versand",
    page2_delivery_postalservice_servicedescription:
      "Ihre Pakete werden intelligent im Laden gesammelt und ohne manuelle Nachverfolgung zum Ziel gesendet. Eine reibungslose, schnelle und organisierte Logistik.",
    page2_delivery_tracking_title: "Paketverfolgung",
    page2_delivery_tracking_description: "Automatische Anzeige und Verfolgung von Paketen",
    page2_delivery_tracking_servicedescription:
      "Automatische Verfolgung mit genauer Echtzeit-Statusanzeige für Kunden, die volle Transparenz und Vertrauen bietet.",
    page2_jobs_subadmin_title: "Sub-Admin",
    page2_jobs_subadmin_description: "Möglichkeit, Sub-Admins hinzuzufügen",
    page2_jobs_subadmin_servicedescription:
      "Fügen Sie Sub-Admins sicher hinzu, ohne Passwörter zu teilen, und passen Sie Zugriffe individuell an. Volle Kontrolle und garantierte Sicherheit.",
    page2_ids_store_title: "ID-Shop",
    page2_ids_store_description: "Kauf und Verkauf von Instagram-IDs",
    page2_ids_store_servicedescription:
      "Kaufen und verkaufen Sie Instagram-Konten sicher mit Authentifizierung. Detaillierte Analyse, intelligente Preisgestaltung, Auktionen und Seitenstatistikprüfung—all in one place.",
    page2_publish_contentmanagement_title: "Content-Management",
    page2_publish_contentmanagement_description: "Verwaltung von Posts und Stories",
    page2_publish_contentmanagement_servicedescription:
      "Verwalten Sie alle Posts und Stories auf einer fortschrittlichen, intelligenten Plattform mit Planung, Kategorisierung und schnellem Publishing für eine stressfreie Social-Media-Steuerung.",
    page2_publish_contentpublishing_title: "Content-Veröffentlichung",
    page2_publish_contentpublishing_description: "Geplante Veröffentlichung von Posts und Stories",
    page2_publish_contentpublishing_servicedescription:
      "Veröffentlichen Sie Posts und Stories intelligent und zeitgesteuert. Das System schlägt basierend auf Follower-Analyse die beste Zeit vor.",
    page2_publish_analytics_title: "Post- & Story-Analyse",
    page2_publish_analytics_description: "Umfassende Inhaltsanalyse",
    page2_publish_analytics_servicedescription:
      "Erhalten Sie tiefe Einblicke in die Leistung veröffentlichter Inhalte und das Feedback der Zielgruppe, um Ihre Content-Strategie zu optimieren.",
    page2_publish_statistics_title: "Statistiken",
    page2_publish_statistics_description: "Fortschrittliches Performance-Analyse-Tool",
    page2_publish_statistics_servicedescription:
      "Das fortschrittlichste Tool zur Inhaltsanalyse mit vollständigen Details zur Performance von Posts und Stories, Diagrammen und präzisen Analysen für bessere Entscheidungen.",
    page2_extension_biolink_title: "Bio Link",
    page2_extension_biolink_description: "Mehr als ein einfacher Bio-Link",
    page2_extension_biolink_servicedescription:
      "Eine dedizierte, schöne Seite zur Präsentation all Ihrer wichtigen Links mit responsivem Design und voller Anpassung – mehr als nur ein einfacher Link.",
    page2_extension_paymentgateway_title: "Zahlungs-Gateway",
    page2_extension_paymentgateway_description: "Dediziertes Zahlungs-Gateway",
    page2_extension_paymentgateway_servicedescription:
      "Ein sicheres, dediziertes Zahlungs-Gateway ohne technische Kenntnisse, mit detaillierten Berichten und Transaktionsverwaltung in benutzerfreundlicher Umgebung.",
    page2_extension_customwebsite_title: "Eigene Webseite",
    page2_extension_customwebsite_description: "Eigene Webseite passend zu Ihrer Seite",
    page2_extension_customwebsite_servicedescription:
      "Eine individuelle Webseite, abgestimmt auf Ihre visuelle Identität, ohne Programmierkenntnisse. Präsentieren Sie Ihre Produkte und Dienstleistungen professionell und schön.",
    page4_menu_instagram_management: "Instagram Seitenverwaltung",
    page4_menu_admin_subadmin: "Admin & Sub-Admin",
    page4_menu_store_shipping: "Shop & Versand",
    page4_menu_advertising: "Werbung",
    page4_menu_hashtag_management: "Hashtag-Verwaltung",
    page4_menu_ai_analysis: "Intelligente KI-Analyse",
    page4_menu_ad_scheduling: "Werbeplanung",
    page4_menu_financial_wallet: "Finanzen & Wallet",
    page4_menu_page_statistics: "Seitenstatistiken",
    page4_menu_professional_messaging: "Professionelle Nachrichten",

    page4_content_instagram_management_text:
      "Verwalten Sie alle Bereiche Ihrer Seite – von der Veröffentlichung bis zur Antwort auf Kommentare und Directs – integriert und professionell, ohne mehrere Apps!",
    page4_content_admin_subadmin_text:
      "Bauen Sie Ihr Team auf! Weisen Sie spezifische Rollen zu, beschränken Sie Zugriffe und überwachen Sie Aktivitäten ohne Sorge vor menschlichen Fehlern.",
    page4_content_store_shipping_text:
      "Ein echter Instagram-Shop! Verwalten Sie Lager, Bestellungen, Rechnungen und Versandverfolgung alles in einem Panel. Online-Verkauf war nie einfacher!",
    page4_content_advertising_text:
      "Gestalten, starten und analysieren Sie Instagram-Werbung mit wenigen Klicks! Ziehen Sie Ihre Zielgruppe an, messen Sie den ROI und verschwenden Sie kein Budget mehr.",
    page4_content_hashtag_management_text:
      "Wählen Sie Ihre Hashtags clever aus! Analysieren Sie die besten verwandten Hashtags, speichern und kategorisieren Sie sie und erhalten Sie intelligente Vorschläge für jeden Post für maximale Reichweite.",
    page4_content_ai_analysis_text:
      "Untersuchen Sie das Verhalten Ihrer Follower genau! Entdecken Sie Muster, Interessen und Spitzenzeiten mit fortschrittlicher KI-Analyse und gewinnen Sie mit Ihrer Strategie.",
    page4_content_ad_scheduling_text:
      "Lassen Sie Ihre Anzeigen auch im Schlaf laufen! Planen Sie Kampagnen, legen Sie Start- und Endzeiten fest und wachsen Sie sorgenfrei.",
    page4_content_financial_wallet_text:
      "Behalten Sie alle Transaktionen im Griff! Verfolgen Sie Einnahmen, Ausgaben, Wallet-Guthaben und erhalten Sie umfassende Finanzberichte zur besseren Kapitalverwaltung.",
    page4_content_page_statistics_text:
      "Genauere, echte Statistiken zum Seitenwachstum: Engagement-Rate, Follower-Wachstum, Beitragsleistung, Aufrufe und viele Daten für intelligente Entscheidungen.",
    page4_content_professional_messaging_text:
      "Erleben Sie echtes Direct Marketing! Senden Sie Gruppennachrichten, richten Sie automatische Antworten ein und verwalten Sie professionelle Unterhaltungen mit Followern ohne Verwirrung.",

    shipping: "Versand",
    jobs: "Jobs",
    IDstore: "ID-Shop",
    page3_text1: "Die Lösung für alle Ihre Geschäftsanforderungen",
    page5_whyBrancy: "Warum Brancy?",
    page5_title1: "Offizieller und sicherer Instagram-Partner",
    page5_title2: "Integriertes Ökosystem, intelligente Einsparungen",
    page5_title3: "Professionelle intelligente Interaktion",
    page5_title4: "Erweiterte und intelligente Dashboard",
    page5_title5: "Intelligentes Verkaufs- und Logistiksystem",
    page5_title6: "Individuelle intelligente Website",
    page5_explain1: "Intelligente Steuerung ohne sensible Daten – sicher & Instagram-konform.",
    page5_explain2: "Alle Tools vereint – 70 % Kosten-, 85 % Zeitersparnis.",
    page5_explain3: "KI-Antworten – 40 % mehr Rückmeldungen, 95 % Kundenbindung.",
    page5_explain4: "Schnelle UI, Live-Analysen, Admins, Planung & Reports.",
    page5_explain5: "Direktverkauf per DM – sichere Zahlung, Shop, Versand & Lager.",
    page5_explain6: "Website & Bio-Link – Verkauf, Buchung, SEO & Social Media.",
    page9_plantitle: "Wähle deine Follower-Anzahl, um das passende Paket zu sehen",

    page9_planheader: "Professionell starten Sie und genießen Sie die Funktionen!",
    page9_planexplain: "40 Tage kostenloser, vollständiger und unbegrenzter Zugang!",
    page9_freeplan: "Kostenlos",
    page9_basicplan: "Basis",
    page9_proplan: "Profi",
    page9_adsplan: "Werbung",
    page9_storeplan: "Shop",
    page9_monthly: "monatlich",
    page9_Compare: "Vergleichen Sie die Pläne im Detail",
    page9_content_management: "Verwaltung von Posts und Storys",
    page9_analize_management: "Erweiterte Analyse und Statistik-Tools",
    page9_message_management: "Verwaltung von Directs und Kommentaren",
    page9_biolink_management: "Intelligenter Bio-Link und eigene Website",
    page9_subadmin_management: "Rekrutierung und Verwaltung von Sub-Admins",
    page9_basicoption: "Grundfunktionen",
    page9_ticket_management: "Verkauf über Direct und Ticket",
    page9_finance_management: "Zahlungsschnittstelle und Wallet",
    page9_store_management: "Intelligente Lagerverwaltung",
    page9_logestic_management: "Automatischer Versand und Lieferung",
    page9_storeanalize_management: "Erweiterte Analytik",
    page9_calendar_management: "Werbezeitplan-Kalender",
    page9_advertise_management: "Intelligente Werbeverwaltung",
    page9_adsanalize_management: "Erweiterte Werbeanalyse",
    page9_campagin_management: "Kampagnen erstellen und teilnehmen",
    page9_adsticket_management: "Automatische Rückmeldung zu Anzeigen an Kunden senden",

    page6_Header: "Tausende aktive Unternehmen",
    page6_Explain: "Die meisten erfolgreichen Unternehmen sind der großen Brancy-Familie beigetreten",
    page10_header: "Was unsere Kunden sagen",
    page8_HelpCenter: "Hilfezentrum",
    page8_Community: "Gemeinschaft",
    page8_learn: "Lernen",
    page8_Blog: "Blog",
    page8_FAQ: "FAQ",
    Addfaq: "FAQ hinzufügen",
    addfaqexplain: "Sie können bis zu 4 häufig gestellte Fragen hinzufügen",
    faqEmptyState: "Ihre häufig gestellten Fragen werden hier angezeigt",

    page8_Support: "Support",
    support_Online: "Online-Support",
    support_EnterBlog: "Zum Blog",
    page8_CommunityExplain:
      "Treten Sie mit anderen Nutzern in Kontakt, teilen Sie Ihre Erfahrungen und profitieren Sie von kollektiven Ratschlägen für weiteres Wachstum.",
    page8_learnExplain:
      "In diesem Abschnitt lernen Sie die neuesten Strategien zur Nutzung von Instagram im Geschäft. Alles, was Sie für das Wachstum Ihres Unternehmens benötigen, finden Sie hier.",
    page8_BlogExplain:
      "Greifen Sie auf die neuesten Artikel und Bildungsinhalte zu. Aktuelle Informationen aus verschiedenen Bereichen der Geschäftswelt und des digitalen Marketings erwarten Sie.",
    page8_FAQExplain:
      "Ihre häufig gestellten Fragen werden hier beantwortet. Für weitere Informationen zu Dienstleistungen oder Produkten, wenden Sie sich bitte an diesen Abschnitt.",
    page8_SupportExplain:
      "Unser Support-Team steht bereit, Ihnen zu helfen. Wenn Sie ein Problem oder eine Frage haben, kontaktieren Sie uns einfach.",
    page8_CommunityBTN: "Lernen wir zusammen",
    page8_learnBTN: "Schnelles Lernen",
    page8_BlogBTN: "Neueste Nachrichten",
    page8_FAQBTN: "Sofortige Antworten",
    page8_SupportBTN: "Wir sind hier, um zu helfen",
    footer_Brancy: "Brancy",
    footer_AboutUs: "Über uns",
    footer_ContactUs: "Kontaktieren Sie uns",
    footer_JoinUs: "Treten Sie uns bei",
    footer_OrgChart: "Organigramm",
    footer_FollowUs: "Folgen Sie uns",
    footer_Solutions: "Lösungen",
    footer_HelpCenter: "Hilfezentrum",
    footer_Support: "Support",
    footer_FAQ: "Häufig Gestellte Fragen",
    footer_ReportAnIssue: "Ein Problem melden",
    footer_TrustLegal: "Vertrauen & Rechtliches",
    footer_TermsAndConditions: "Bedingungen",
    footer_PrivacyNotice: "Datenschutzhinweis",
    footer_CookieNotice: "Cookie-Hinweis",
    footer_Blog: "Blog",
    footer_ProductUpdates: "Neueste Updates",
    footer_Articles: "Artikel",
    footer_LatestNews: "Neueste Nachrichten",
    installPromptMessage: "Installieren Sie die Brancy Web-App",
    install: "Installieren",
    installStep1: "Tippen Sie auf die Freigabe-Schaltfläche unten.",
    installStep2: "Scrollen Sie das geöffnete Menü nach oben und wählen Sie Add to Home Screen.",
    installStep3: "Tippen Sie oben auf dem Bildschirm auf Add.",
    joinUs_subtitle: "Treten Sie Brancy Bei; Wo Innovation Und Eine Nachhaltige Zukunft Gestaltet Werden.",
    joinUs_whyWorkWithUs: "Warum Brancy?",
    joinUs_whyWorkWithUsDescription:
      "Brancy Ist Nicht Nur Ein Arbeitsplatz; Es Ist Eine Strategische Plattform Für Berufliches Und Persönliches Wachstum. Wir Glauben, Dass Führende Organisationen Durch Spitzenkräfte Geschaffen Werden. Unser Engagement Besteht Darin, Ein Dynamisches, Transparentes Und Unterstützendes Umfeld Zu Schaffen, In Dem Teammitglieder Nachhaltigen Einfluss Haben Können.",
    joinUs_openPositions: "Offene Stellen",
    joinUs_openPositionsDescription:
      "Entdecken Sie Verfügbare Möglichkeiten Und Wählen Sie Die Rolle, Die Zu Ihrer Expertise Und Ihrem Karriereweg Passt.",
    joinUs_frontendDeveloper: "Frontend-Entwickler",
    joinUs_frontendDeveloperDescription:
      "Entwerfen Und Implementieren Sie Moderne Benutzererlebnisse Mit React Und TypeScript. Spielen Sie Eine Schlüsselrolle Bei Der Verbesserung Der Qualität Und Effizienz Unserer Produkte.",
    joinUs_backendDeveloper: "Backend-Entwickler",
    joinUs_backendDeveloperDescription:
      "Entwickeln Sie Skalierbare Und Sichere Systeme Mit Node.js Und Cloud-Technologien. Erfordert Systemdenken Und Die Fähigkeit, Komplexe Probleme Zu Lösen.",
    joinUs_uiUxDesigner: "UI/UX-Designer",
    joinUs_uiUxDesignerDescription:
      "Gestalten Sie Standardisierte Oberflächen Und Intuitive Erlebnisse Für Benutzerzufriedenheit Und Loyalität. Detailgenauigkeit Und Kreativität Sind Erforderlich.",
    joinUs_productManager: "Produktmanager",
    joinUs_productManagerDescription:
      "Führen Sie Die Produktstrategie An Und Koordinieren Sie Teams, Um Wettbewerbsfähige Und Effiziente Lösungen Bereitzustellen. Geeignet Für Personen Mit Analytischem Blick Und Stakeholder-Management-Fähigkeiten.",
    joinUs_marketingSpecialist: "Marketing-Spezialist",
    joinUs_marketingSpecialistDescription:
      "Planen Und Führen Sie Digitale Kampagnen Durch Und Stärken Sie Die Markenposition. Kombination Aus Analytischen Fähigkeiten Und Kreativität.",
    joinUs_customerSupport: "Kundensupport-Spezialist",
    joinUs_customerSupportDescription:
      "Bieten Sie Professionellen Support, Lösen Sie Probleme Und Verbessern Sie Das Benutzererlebnis. Erfordert Genauigkeit, Geduld Und Kommunikationsfähigkeiten.",
    joinUs_engineering: "Ingenieurwesen",
    joinUs_design: "Design",
    joinUs_product: "Produkt",
    joinUs_marketing: "Marketing",
    joinUs_support: "Support",
    joinUs_remoteOnsite: "Remote / Vor Ort",
    joinUs_onsite: "Vor Ort",
    joinUs_remote: "Remote",
    joinUs_fullTime: "Vollzeit",
    joinUs_partTimeFullTime: "Teilzeit / Vollzeit",
    joinUs_applyNow: "Jetzt Bewerben",
    joinUs_applicationProcess: "Brancy Einstellungsprozess",
    joinUs_submitApplication: "Bewerbung Absenden",
    joinUs_submitApplicationDescription:
      "Senden Sie Ihren Lebenslauf und Ihre Fähigkeiten. Unser Team wird diese sorgfältig prüfen.",
    joinUs_initialScreening: "Erste Überprüfung",
    joinUs_initialScreeningDescription:
      "Die Personalabteilung prüft Lebensläufe innerhalb von 3–5 Arbeitstagen und kontaktiert bei Eignung.",
    joinUs_technicalInterview: "Technisches Interview",
    joinUs_technicalInterviewDescription:
      "Bewertung des technischen Wissens und der Erfahrung durch spezialisierte Interviews mit Teams.",
    joinUs_finalInterview: "Abschlussinterview",
    joinUs_finalInterviewDescription:
      "Abschlusssitzung mit Führungskräften und Schlüsselteams zur Sicherstellung der Ziel- und Werteausrichtung.",
    joinUs_welcomeAboard: "Willkommen an Bord",
    joinUs_welcomeAboardDescription:
      "Nach der Annahme beginnt ein umfassender Onboarding-Prozess, um Sie mit der Kultur und den Zielen der Organisation vertraut zu machen.",
    joinUs_readyToJoinUs: "Haben Sie die gewünschte Position nicht gefunden?",
    joinUs_readyToJoinUsDescription:
      "Wir heißen stets qualifizierte und motivierte Personen willkommen. Senden Sie Ihren Lebenslauf und beschreiben Sie Ihre Vorstellung der Zusammenarbeit mit Brancy.",
    joinUs_sendYourResume: "Lebenslauf Senden",

    aboutUs_pageTitle: "Über Brancy",
    aboutUs_metaDescription:
      "Entdecken Sie Brancy, eine umfassende und internationale Plattform zur Verwaltung sozialer Netzwerke und digitaler Unternehmen; ein Ort, an dem Innovation, Vertrauen und nachhaltiges Wachstum zusammenkommen, um die Zukunft der digitalen Wirtschaft zu gestalten.",
    aboutUs_subtitle: "Intelligentes Management der digitalen Wirtschaft mit Brancy",
    aboutUs_ourStoryTitle: "Unsere Geschichte",
    aboutUs_ourStoryPara1:
      "Brancy wurde mit dem Ziel geboren, das Management von Online-Unternehmen neu zu definieren; ein Punkt, an dem fortschrittliche Technologien auf die realen Bedürfnisse von Geschäftsinhabern treffen. Wir bieten nicht nur ein Werkzeug, sondern haben eine Plattform geschaffen, auf der Unternehmen wie eine große, professionelle Organisation agieren können.",
    aboutUs_ourStoryPara2:
      "Dieser Weg entstand aus dem Glauben: Technologie soll das Wachstum von Mensch und Geschäft erleichtern und kein Hindernis sein.",
    aboutUs_innovationTitle: "Innovation als Fundamentaler Vorteil",
    aboutUs_innovationPara1:
      "Brancy nutzt KI, Big Data und moderne Webtechnologien, um eine nahtlose, sichere und effiziente Nutzererfahrung zu schaffen. Jede Funktion ist mit Fokus auf Einfachheit und maximale Produktivität gestaltet.",
    aboutUs_innovationPara2:
      "Für uns beschränkt sich Innovation nicht nur auf Technologie; es ist ein strategischer Ansatz, verwurzelt in unserer Unternehmenskultur und unserer Zukunftsvision.",
    aboutUs_coreValuesTitle: "Unsere Grundwerte",
    aboutUs_innovationFirstTitle: "Vorreiter in Innovation",
    aboutUs_innovationFirstDesc:
      "Wir suchen stets nach Lösungen, die den zukünftigen Bedürfnissen digitaler Unternehmen gerecht werden.",
    aboutUs_trustSecurityTitle: "Vertrauen & Sicherheit",
    aboutUs_trustSecurityDesc:
      "Datensicherheit und Prozess-Transparenz haben für uns Priorität, damit Nutzer mit vollem Vertrauen wachsen können.",
    aboutUs_globalCommunityTitle: "Eine Globale Gemeinschaft",
    aboutUs_globalCommunityDesc:
      "Brancy geht über geografische Grenzen hinaus und verbindet ein globales Ökosystem von Unternehmen und Fachleuten.",
    aboutUs_sustainableGrowthTitle: "Nachhaltiges Wachstum",
    aboutUs_sustainableGrowthDesc:
      "Wir verpflichten uns zu intelligentem und nachhaltigem Wachstum, das mit ethischen Prinzipien und sozialer Verantwortung im Einklang steht.",
    aboutUs_userEmpowermentTitle: "Nutzerermächtigung",
    aboutUs_userEmpowermentDesc:
      "Unsere intuitiven Werkzeuge und Bildungsressourcen gewährleisten allen den gleichen Zugang zu digitalen Chancen.",
    aboutUs_continuousEvolutionTitle: "Ständige Weiterentwicklung",
    aboutUs_continuousEvolutionDesc:
      "In einer dynamischen Welt ist Veränderung Teil unseres Weges. Wir gehen stets mit Lernen und kontinuierlicher Verbesserung voran.",
    aboutUs_globalImpactTitle: "Globaler Einfluss",
    aboutUs_globalImpactPara:
      "Heute ist Brancy eine Plattform, die Millionen von Unternehmern und Unternehmen stärkt; eine Brücke zwischen digitalen Chancen und einer grenzenlosen Zukunft.",
    aboutUs_activeUsers: "Aktive Nutzer",
    aboutUs_countries: "Abgedeckte Länder",
    aboutUs_uptime: "Systemverfügbarkeit",
    aboutUs_support: "Dedizierter Support",
    aboutUs_teamTitle: "Brancy Team",
    aboutUs_teamPara1:
      "Unser Team vereint Technologen, Strategen und Kreative aus aller Welt mit der gemeinsamen Mission, die digitale Wirtschaft weiterzuentwickeln.",
    aboutUs_teamPara2:
      "Von der Erfahrung der Branchenpioniere bis zur Energie junger Talente – bei Brancy führen wir eine globale Bewegung an, die eine neue Generation des digitalen Handels gestaltet.",

    // #region  landing page
    Dashboard: "Instrumententafel",
    greeting1: "Die Sonne ist mit dir aufgewacht,",
    greeting2: "Einen energiegeladenen Morgen wünsche ich dir,",
    greeting3: "Einen schönen Tag wünsche ich dir,",
    greeting4: "Einen schönen Nachmittag wünsche ich dir,",
    greeting5: "Einen goldenen Abend wünsche ich dir,",
    greeting6: "Die Nacht ist nahe",
    greeting7: "Gute Nacht, ruhige Nacht,",
    greetingtext1: "Der frühe Morgen ist wirklich magisch🌅",
    greetingtext2: "Die Welt wartet auf deine Schritte 💪",
    greetingtext3: "Zeit für einen Tee und ein Lächeln ☕😊",
    greetingtext4: "Genieße dein leckeres Essen 🍽️",
    greetingtext5: "Die Sonne ist noch am Himmel, geh weiter 🌟",
    greetingtext6: "Schaffe ein cooles Ende 🌇",
    greetingtext7: "Träume groß und fang morgen an🌙",
    userpanel_yourorders: "Ihre Bestellungen",
    userpanel_SavedProducts: "Gespeicherte Produkte",
    userpanel_NoSavedProducts: "Keine gespeicherten Produkte verfügbar.",
    userpanel_Startexplore: "Beginnen Sie, Millionen zu erkunden",
    userpanel_Startexploreexplain: "Märkte, Produkte und Seiten",
    userpanel_TicketSupportExplain: "Bestellung verfolgen, mit dem Verkäufer chatten",
    userpanel_TicketSupport: "Über ein Ticket kommunizieren",

    userpanel_UseInstagram: "Verwalten Sie Instagram wie ein Profi.",
    userpanel_FreeProPanel: "Kostenloses ProPanel",
    userpanel_Premiumaccount: "Premium-Konto",
    userpanel_daysFreePremium: "40 Tage kostenloses Premium",
    userpanel_LimitedOffer: "Begrenztes Angebot!",
    // #region 0️⃣ General Section
    //0️⃣ General -> sidebar
    color: "Farbe",
    button: "Taste",
    Liter: "Liter",
    FrontFace: "Vorderseite",
    SideFace: "Seitenfläche",
    TopFace: "Oberfläche",
    Area: "Fläche",
    Perimeter: "Umfang",
    Volume: "Volumen",
    inSystem: "Im System",
    sending: "Senden",
    uploadsRemaining: "Verbleibende Uploads",
    logoutExplain: "Sie versuchen, sich von Brancy abzumelden",
    welcomeToBrancy: "Willkommen bei Brancy!",
    notloginexplain: "Um die Dienste von Brancy zu nutzen, verbinden Sie bitte Ihr Instagram-Konto.",
    welcomeToBrancyExplain: "Geben Sie Ihre Instagram-ID ein, um Ihr ultimatives Verwaltungs-Panel einzurichten.",
    welcomeToBrancyExplainPhone: "Geben Sie Ihre Telefonnummer ein, um Ihr ultimatives Verwaltungs-Panel einzurichten.",
    loginWithGoogle: "Google Login",
    loginWithMobile: "SMS Login",

    or: "oder",
    InstagramID: "Instagram-Benutzername (ID)",
    EmptyNotification: "Es gibt noch keine Benachrichtigung",
    Notification_NewMessage: "Sie haben eine neue Nachricht von {{sender}}",
    Notification_NewOrder: "Sie haben eine neue Bestellung von {{sender}}",
    Notification_ImagesCreatedBy: "Ihre Bilder wurden erfolgreich vom Modell {{version}} erstellt.",
    Notification_VideoCreatedBy: "Ihr Video wurde erfolgreich vom Modell {{version}} erstellt.",
    Notification_MediaCreationFailed: "Ihre Medien konnten vom Modell {{version}} nicht erstellt werden: {{metadata}}",
    Notification_VideoCreationFailed: "Ihr Video konnte vom Modell {{version}} nicht erstellt werden: {{metadata}}",
    Notification_NewPost: "Neuer Beitrag",
    Notification_UploadPostFailed: "Beitrag konnte nicht hochgeladen werden",
    Notification_NewStory: "Neue Story",
    Notification_UploadStoryFailed: "Story konnte nicht hochgeladen werden",
    Notification_NewVideo: "Neues Video",
    Notification_VideoCreationFailedTitle: "Video konnte nicht erstellt werden",
    Notification_YouHaveNewMessage: "Sie haben eine neue Nachricht",
    Notification_AccountDeauthorized: "Instagram-Konto nicht mehr autorisiert",
    EnterYourText: "Geben Sie Ihren Text ein",
    EnterYourphonenumber: "Geben Sie Ihre Telefonnummer ein",
    CopyText: "Text kopieren",
    successfulCopy: "Kopiert",
    download: "Herunterladen",
    automatic: "Automatisch",
    manual: "Manuell",
    phonenumber: "Telefonnummer",
    SendVerificationCode: "Code Senden",
    ShowUserDashboard: "Zum Dashboard Gehen",
    VerificationCode: "Verifizierungscode",
    VerificationCodeExplain: "Bitte geben Sie den an Ihr Telefon gesendeten Verifizierungscode ein.",
    remainingTime: "Verbleibende Zeit",
    createtime: "Erstellungszeit",
    ResendVerificationCode: "Verifizierungscode Erneut Senden",
    VerifyCode: "Code Überprüfen",
    Verify: "Bestätigen",
    VerifyAddress: "Adresse bestätigen",
    Continue: "Fortsetzen",
    metaRedirect_aiAnalysisNotice:
      "Bitte beachten Sie, dass die Analyse Ihrer Seite mit künstlicher Intelligenz mehrere Stunden dauern kann.",
    Efficiency: "Effizienz",
    max: "MAX",
    logout: "Abmelden",
    notallowed: "Nicht erlaubt",
    notallowedExplain: "Sie dürfen auf diese Funktion nicht zugreifen",
    notallowedExplainPage: "Sie dürfen auf diese Seite nicht zugreifen",
    CreateAutomationFlow: "Automatisierungsablauf erstellen",
    CreateAutomationFlowExplain: "Automatisiere Instagram-Interaktionen mit einem visuellen Workflow-Builder.",
    CreateAutomationAI: "KI-Automatisierung erstellen",
    CreateAutomationAIExplain: "Automatisiere Instagram-Interaktionen mit KI-gesteuerten Antworten.",
    flowProperties_notworking_privateReply:
      "⚠️ Hinweis: Dieser Flow funktioniert nicht in privaten Chats mit Freunden und wird nur für automatische Antworten auf Kommentare und Direct-Nachrichten verwendet",
    flowProperties_privateReply_requiresFollower:
      "Dieser Flow kann nicht für private Antworten verwendet werden. Aktivieren Sie zur Freischaltung in den Einstellungen die Option „Der Benutzer muss der Seite folgen“.",

    needPass: "Verifizierung und Aktivierung",
    needPassExplain: "Für den vollen Zugriff auf diese Funktion wird das Passwort des Instagram-Kontos benötigt",
    soon: "Bald verfügbar",
    soonExplain: "Diese Funktion wird in Kürze verfügbar sein",
    underdevelop: "In Entwicklung",
    reject: "Ablehnen",
    rejected: "Ablehnen",
    approved: "Genehmigt",
    ExpirationTime: "Ablaufzeit",
    send: "Senden",
    accept: "Akzeptieren",
    selectall: "Alles auswählen",
    General: "Allgemein",
    Business: "Geschäft",
    total: "Gesamtsumme",
    Unknown: "Unbekannt",
    undo: "Rückgängig machen",
    redo: "Wiederholen",
    close: "Schließen",
    closed: "Geschlossen",
    admin: "Administrator",
    user: "Benutzer",
    stop: "Stopp",
    save: "Speichern",
    discard: "Verwerfen",
    all: "Alle",
    update: "Aktualisieren",
    like: "like",
    dislike: "Dislike",
    next: "weiter",
    cancel: "abbrechen",
    canceled: "Abgebrochen",
    comment: "Kommentar",
    mention: "erwähnen",
    add: "Hinzufügen",
    icon: "Symbol",
    copylist: "Liste Kopieren",
    reply: "Antworten",
    replies: "Antworten",
    PrivateReply: "Private Antwort",
    copy: "Kopieren",
    everywhere: "Überall",
    UnHide: "Anzeigen",
    show: "Anzeigen",
    Hide: "Ausblenden",
    pageSummary: "Seitenübersicht",
    summaryGeneralIntro: "Allgemeine Seitenübersicht",
    summaryUserEngagement: "Analyse der Nutzerinteraktion",
    summaryContentStrategy: "Überprüfung der Content-Strategie",
    summaryPostingSchedule: "Bewertung des Veröffentlichungsplans",
    summaryImprovementSuggestions: "Verbesserungs- und Wachstumsvorschläge",
    Ignore: "Ignorieren",
    Orange: "Orange",
    Purple: "Lila",
    Green: "Grün",
    White: "Weiß",
    DarkGray: "Dunkelgrau",
    Blue: "Blau",
    LightGray: "Hellgrau",
    Brown: "Braun",
    Pink: "Rosa",
    Yellow: "Gelb",
    Silver: "Silber",
    Black: "Schwarz",
    Red: "Rot",
    select: "auswählen",
    back: "Zurück",
    start: "Start",
    country: "Land",
    device: "Gerät",
    yourdevice: "Ihr Gerät",
    otherdevice: "Anderes Gerät",
    SessionID: "Session-ID",
    header: "Überschrift",
    upload: "Hochladen",
    active: "Aktiv",
    activate: "Aktivieren",
    activateAll: "Alle Aktivieren",
    signout: "Abmelden",
    switchaccount: "Konto wechseln",
    instagramConnect: "Instagram-Konto verbinden",
    upgrade: "Upgrade",
    Renew_Subscription: "Abonnement verlängern",
    DeactivateAll: "Alle Deaktivieren",
    deactive: "Inaktiv",
    Deactivate: "Deaktivieren",
    done: "Erledigt",
    abort: "Abbrechen",
    Pending: "Ausstehend",
    Preparing: "Vorbereitung",
    Finished: "Fertig",
    finish: "Fertigstellen",
    exportJPG: "JPG exportieren",
    exportPDF: "PDF exportieren",
    exportXlxs: "XLSX exportieren",
    dismiss: "Schließen",
    empty: "Leer",
    searching: "Suche ...",
    searchMessage: "Personen oder Schlüsselwort suchen",
    searchKeyword: "Schlüsselwort suchen",
    Recommended: "Empfohlen",
    VERFIED: "Verifiziert",
    SuccessADS: "Erfolgreiche Werbung",
    SuccessSALES: "Erfolgreicher Verkauf",
    StartOrder: "Bestellung Starten",
    Startshoping: "Einkauf Starten",
    question: "Frage",
    Answer: "Antwort",
    shareStory: "Story teilen",
    search: "Suche",
    searchLocation: "Standort suchen",
    searchPeople: "Personen suchen",
    edit: "Bearbeiten",
    delete: "Löschen",
    deletecover: "Cover löschen",
    details: "Details",
    Insights: "Einblicke",
    new: "Neu",
    CollaboratorExplain: "Post oder Reels Gemeinsam Zwischen Mehreren Instagram-Seiten Teilen",

    comments: "Kommentare",
    nocomment: "Keine Kommentare",
    SimilarProducts: "Ähnliche Produkte",
    QandA: "Fragen",
    caption: "Beschriftung",
    collaborator: "Mitarbeiterseite",
    sidebar_Home: "Zuhause",
    sidebar_Page: "Seite verwalten",
    sidebar_Message: "Nachrichten",
    sidebar_Wallet: "Brieftasche",
    sidebar_biolink: "Bio-Link",
    sidebar_Advertise: "Werbungen",
    sidebar_Store: "Geschäft",
    sidebar_Stores: "Geschäfte",
    sidebar_Business: "Unternehmen",
    sidebar_Setting: "Einstellungen",
    //0️⃣ General -> navbar
    navbar_Post: "Beitrag",
    navbar_Live: "Live",
    navbar_Story: "Geschichte",
    navbar_Feed: "Feed",
    navbar_Reels: "Reels",
    navbar_Statistics: "Statistiken",
    navbarTools: "Werkzeuge",
    navbar_Direct: "Direkt",
    navbar_Comments: "Kommentare",
    navbar_Ticket: "Tickets",
    navbar_AI: "KI",
    navbar_ContentCreator: "Inhaltsersteller",
    navbar_Properties: "Eigenschaften",
    navbar_AIAndFlow: "KI & Agent",
    navbar_Payment: "Zahlungen",
    navbar_Title: "Titel",
    navbar_Home: "Startseite",
    navbar_Biolink: "Mein Link",
    navbar_Calendar: "Kalender",
    navbar_AdList: "Anzeigenliste",
    navbar_General: "Allgemein",
    navbar_SubAdmin: "Unter-Admins",
    navbar_HelpCenter: "Hilfe & Support",

    addnewaccount: "Konto hinzufügen",
    addedaccounts: "Hinzugefügte Konten",
    SwitchtoAccountexplain: "Alle Ihre in Brancy hinzugefügten Konten werden hier aufgelistet",
    subadmininvitation: "Kooperationseinladung",
    subadmininvitationexplain: "Einladung zur Instagram-Verwaltung als stellvertretender Admin",

    SwitchtoAccount: "Zum Konto wechseln",
    accountmanagement: "Kontoverwaltung",
    navbar_Products: "Produkte",
    navbar_Orders: "Bestellungen",
    navbar_totalOrders: "Gesamtbestellungen",
    //0️⃣ countdown
    countdown_Days: "Tag",
    countdown_Hours: "Stunde",
    countdown_Minutes: "Minute",
    Expired: "Abgelaufen",
    justnow: "Gerade jetzt",
    LessThanAMinute: "Weniger als eine Minute",
    ExpiresIn: "Läuft ab in",

    ExportPDF: "PDF Exportieren",
    ExportJPG: "JPG Exportieren",
    ShareTo: "Teilen mit",
    Expand: "Erweitern",
    // #endregion General Section
    // #region 1️⃣home Section
    // 1️⃣ Home -> cards
    home_FollowRequest: "Folgeanfragen",
    home_UnreadNewComments: "Ungelesene Neue Kommentare",
    home_Last24H: "Letzte 24 Stunden",
    home_Last30Days: "In den letzten 30 Tagen",
    home_LastLikes: "Neue Likes",
    home_LastPost: "Letzter Beitrag",
    home_Followings: "Gefolgte",
    home_Followers: "Follower",
    AudienceLocation: "Standort der aktiven Zielgruppe",
    AudienceGender: "Geschlecht der aktiven Zielgruppe",
    AudienceAge: "Alter der aktiven Zielgruppe",

    AudienceGenderStats:
      "Sie haben {{female}} weibliche, {{male}} männliche und {{unknown}} nicht spezifizierte Follower",

    AudienceAgeStats:
      "Die meisten Ihrer Zuschauer sind aus der Altersgruppe {{ageRange}} ({{percentage}}%), daher sollte der Inhalt für {{ageCategory}} Publikum attraktiv und geeignet sein.",

    AgeCategoryYoung: "junge",
    AgeCategoryMiddleAged: "mittleren Alters",
    AgeCategoryOlder: "ältere",

    AudienceLocationStats:
      "Die meisten Ihrer aktiven Follower kommen aus dem Land {{country}} mit {{countryCount, number}} Personen und aus der Stadt {{city}} mit {{cityCount, number}} Personen",

    // 1️⃣ Home -> last like
    lastLike: "Letzte Likes",
    // 1️⃣ Home -> last message
    lastMessage: "Letzte Nachrichten",
    lastOrder: "Letzte Bestellungen",
    lastTransaction: "Letzte Transaktionen",
    // 1️⃣ Home -> last follower
    LastFollowers: "Letzte Follower",
    // #endregion home Section
    // #region 2️⃣page Section
    // 2️⃣ Page -> Post
    CreateNewPost: "Neuen Beitrag erstellen",
    Postnotvisible: "Post wird nicht angezeigt?",
    Storynotvisible: "Story wird nicht angezeigt?",
    SmartPageAnalysis: "Intelligente Seitenanalyse",
    EducationAndGuidance: "Schulung und Anleitung",
    HowToUseBrancy: "So verwendest du Brancy",
    BrancyKnowsYou: "Brancy kennt Sie",
    BrancyKnowsYouExplain:
      "Brancy analysiert Ihre Seite umfassend, um ein vollständiges Bild Ihrer digitalen Identität zu erstellen – von Ihrer Persönlichkeit, Ihrem Unternehmen und Ihren Aktivitäten bis hin zu Ihrem Kommunikationsstil und -ton, der Art Ihrer Inhalte, der Präsentation Ihrer Beiträge, Ihren Veröffentlichungszeiten und Ihrer Art, mit Ihrer Zielgruppe zu interagieren.\n\nDie Analyse berücksichtigt außerdem Ihre Aktivitäten an allen Kommunikationspunkten Ihrer Seite – von Antworten auf Kommentare und Direct-Nachrichten bis hin zu Ihrem Schreibstil, Ihrem Umgang mit Ihrer Zielgruppe und Ihrer Reaktion auf unterschiedliche Situationen.\n\nOhne manuelles Training, eine Anpassung des Tons oder die Eingabe zusätzlicher Informationen kennt Brancy Sie und richtet die KI an Ihrer tatsächlichen Identität und Ihrem persönlichen Stil aus.",
    CreateYourDigitalVersion: "Erstellen Sie Ihre digitale Version",
    CreateNewStrory: "Neue Geschichte erstellen",
    PostDraft: "Beitragsentwurf",
    StoryDraft: "Geschichtsentwurf",
    publishError: "Fehler beim Veröffentlichen",
    DeletedPost: "Gelöschter Beitrag",
    errorDraft_title: "Ein Fehler ist beim Veröffentlichen des Posts aufgetreten",
    errorDraft_configFailed: "Die Post-Veröffentlichungseinstellungen sind falsch, bitte überprüfen und korrigieren.",
    errorDraft_invalidTags: "Ungültige Tags: ",
    errorDraft_unknown: "Unbekannter Fehler! Bitte versuchen Sie es erneut.",
    errorDraft_uploadError: "Das Hochladen des Bildes ist fehlgeschlagen, bitte versuchen Sie es erneut.",
    errorDraft_userCancel: "Die Veröffentlichung des Posts wurde von Ihnen abgebrochen.",
    InvalidAspectRatio: "Ungültiges Seitenverhältnis",
    SizeLimitExceed: "Dateigröße überschreitet das Limit",
    UnSupportMediaType: "Nicht unterstützter Medientyp",
    NotPublishedAtTheTime: "Beitrag wurde zum gewählten Zeitpunkt nicht veröffentlicht",
    NotSuccessLogin: "Anmeldung fehlgeschlagen",

    NewScheduledPost: "Neuer Geplanter Beitrag",
    thereAreNoPost: "Sie haben noch keinen geplanten Post erstellt",
    ScheduledPost: "Geplanter Beitrag",
    // 2️⃣ Page -> story
    pageStory_CreateNewStory: "Neue Story Erstellen (Bald)",
    pageStory_CreateNewStories: "Neue Geplante Story (Bald)",
    pageStory_thereAreNoStories: "Sie haben noch keine geplante Story erstellt",
    pageStory_ScheduledStories: "Geplante Story",
    // 2️⃣ Page -> highlight
    pageStory_highlightManagement: "Highlight-Verwaltung",
    pageStory_thereAreNoHighlight: "Es gibt keine Highlights",
    pageStory_HighlightTitle: "Highlights / Ordner",
    // 2️⃣ Page -> statistic
    pageStatistics_YourBestFollowers: "Ihre Besten Follower",
    pageStatistics_YourBestFollowersExplain:
      "Berechnet auf Basis des gesamten Interaktionswertes der Seite (einschließlich Likes, Kommentare und Shares).",
    pageStatistics_LoadMore: "Mehr Laden",
    pageStatistics_UnFollowers: "Abmeldungen",
    pageStatistics_Followers: "Follower",
    pageStatistics_NewFollowers: "Neue Follower",
    pageStatistics_ActiveFollowers: "Aktive Follower",
    pageStatistics_MediaFollows: "Medien Follows",
    pageStatistics_Reach: "Reichweite",
    pageStatistics_ProfileVisit: "Profilbesuche",
    pageStatistics_30Days: "30 Tage",
    pageStatistics_60Days: "60 Tage",
    pageStatistics_90Days: "90 Tage",
    pageStatistics_120Days: "120 Tage",
    pageStatistics_WorstTime: "Schlechteste Zeit",
    pageStatistics_BestTime: "Beste Zeit",
    pageStatistics_likes: "Likes",
    pageStatistics_Engagements: "Engagements",
    pageStatistics_Impression: "Impressionen",
    pageStatistics_Views: "Aufrufe",
    pageStatistics_RePosts: "Wiederholungen",
    pageStatistics_followerViews: "Besuchende Follower",
    pageStatistics_ghostViewers: "Geheime Zuschauer",
    pageStatistics_Comments: "Kommentare",
    pageStatistics_Shares: "Teilen",
    pageStatistics_summary: "Zusammenfassung",
    collaboratorpost: "Mitarbeiterbeitrag",
    pageStatistics_EmptyList: "Es sind noch keine Daten vorhanden!",
    pageStatistics_from: "Im Vergleich zu",
    pageStatistics_post: "Beiträge",
    pageStatistics_stories: "Stories",
    pageStatistics_MaxView: "Maximale Reichweite",
    pageStatistics_MinView: "Minimale Reichweite",
    pageStatistics_MaxCommentLike: "Max. Kommentare & Likes",
    pageStatistics_MinCommentLike: "Min. Kommentare & Likes",
    pageStatistics_PostTimeAnalysis: "Analyse der Veröffentlichungszeiten",
    pageStatistics_Rate: "Rate",
    pageStatistics_RateExplain: "Basierend auf der höchsten Anzahl an erhaltenen Kommentaren auf der gesamten Seite",

    pageStatistics_24HourHeatmap: "24-Stunden-Heatmap",
    pageStatistics_Low: "Niedrig",
    pageStatistics_High: "Hoch",
    pageStatistics_TopHour: "Top-Stunde",
    pageStatistics_WeakHour: "Schwache Stunde",
    pageStatistics_AverageHour: "Durchschnittliche Stunde",
    pageStatistics_TopMinute: "Top-Minute",
    pageStatistics_WeakMinute: "Schwache Minute",
    pageStatistics_AverageMinute: "Durchschnittliche Minute",
    pageStatistics_HourExcellentLevel:
      "Diese Stunde hat ein ausgezeichnetes Engagement-Niveau (über 80% Kapazität). Das Engagement liegt {{percentage}}% über dem Durchschnitt und eignet sich ideal für wichtige Inhalte.",
    pageStatistics_HourGoodLevel:
      "Diese Stunde hat ein gutes Engagement-Niveau (60–80% Kapazität). Das Engagement liegt {{percentage}}% über dem Durchschnitt und eignet sich für gewöhnliche Inhalte.",
    pageStatistics_HourAverageLevel:
      "Diese Stunde hat ein durchschnittliches Engagement-Niveau (40–60% Kapazität). Für bessere Ergebnisse probieren Sie Stunden mit höherer Intensität (grün). Unterschied zur besten Zeit: {{difference}}%.",
    pageStatistics_HourWeakLevel:
      "Diese Stunde hat ein schwaches Engagement-Niveau (20–40% Kapazität). Es wird empfohlen, während intensiveren Stunden zu posten.",
    pageStatistics_HourVeryWeakLevel:
      "Diese Stunde hat ein sehr schwaches Engagement-Niveau (unter 20% Kapazität). Das Engagement ist geringer als erwartet und Postings werden nicht empfohlen.",
    pageStatistics_MinuteTopDescription:
      "Diese Minute gehört zu den Top 10 Minuten der Stunde {{hour}}:00. Für maximales Engagement wird empfohlen, genau zu diesem Zeitpunkt zu posten. Unterschied zur schwächsten Minute: {{difference}}%.",
    pageStatistics_MinuteWeakDescription:
      "Das Engagement in dieser Minute ist niedrig. Postings zu Beginn oder in der Mitte der Stunde können bessere Ergebnisse liefern. Unterschied zur besten Minute: {{difference}}%.",
    pageStatistics_MinuteAverageDescription:
      "Das Engagement ist durchschnittlich. Für weitere Optimierung prüfen Sie die höher bewerteten Minuten dieser Stunde.",
    pageStatistics_PeakEngagement: "Maximale Interaktion",
    pageStatistics_StableGrowth: "Stabiles Wachstum",
    pageStatistics_HighEngagementProbability: "Hohe Interaktionswahrscheinlichkeit",
    pageStatistics_LowestEngagement: "Niedrigste Momentaninteraktion",
    pageStatistics_SustainedLowPeriod: "Anhaltende Niedrigphase",
    pageStatistics_LowEngagementProbability: "Niedrige Interaktionswahrscheinlichkeit",
    pageStatistics_BestTimes: "Beste Zeiten",
    pageStatistics_WorstTimes: "Schlechteste Zeiten",
    pageStatistics_EngagementPrediction: "Interaktionsvorhersage",
    pageStatistics_PeakTimeDescription:
      "In diesem Moment liegt die höchste Interaktion vor. Für maximale Reichweite empfohlen.",
    pageStatistics_StableTimeDescription:
      "Ab diesem Zeitpunkt steigt die Interaktion und bleibt über dem Durchschnitt. Für stabile Interaktion geeignet.",
    pageStatistics_SecondaryTimeDescription: "Das Posten zu dieser Zeit kann gute Ergebnisse bringen.",
    pageStatistics_LowestTimeDescription:
      "Dies ist der Zeitpunkt mit der niedrigsten Momentaninteraktion. Das Posten führt zu einem Verlust von {{percentage}}% potenzieller Interaktion.",
    pageStatistics_SustainedLowTimeDescription:
      "Ab diesem Zeitpunkt sinkt die Interaktion und bleibt eine Weile niedrig. Nicht zum Posten empfohlen.",
    pageStatistics_SecondaryLowTimeDescription:
      "Ein weiterer schwacher Moment mit geringer Interaktionswahrscheinlichkeit. Nicht empfohlen.",
    pageStatistics_HourEngagementTooltip: "{{hour}}:00 - {{count}} Interaktion ({{percentage}}%)",
    pageStatistics_MinuteEngagementTooltip: "{{hour}}:{{minute}} - {{count}} Interaktion",

    // statistics suggestions box
    Statistics_UnFollowers_up_title: "Rückgang der Unfollowers 💡Zeit, deine Retention-Strategie zu stärken",
    Statistics_UnFollowers_up_summary:
      "Der Rückgang hat abgenommen – dein letzter Content hat gewirkt. Mach auf diesem Weg genauer weiter.",
    Statistics_UnFollowers_up_action1: "Analysiere die letzten drei Posts bezüglich Cover, erster Zeile und CTA.",
    Statistics_UnFollowers_up_action2:
      "Erstelle einen Wochenplan basierend auf diesen Formaten und dokumentiere die Veränderungen.",
    Statistics_UnFollowers_up_action3:
      "Erstelle eine Willkommens-Story und einen ordentlichen Highlight für neue Followers.",
    Statistics_UnFollowers_up_urgency: "Mittel",

    Statistics_UnFollowers_neutral_title: "Stabiler Rückgang 💡Sammle zuerst Nutzerdaten vor Änderungen",
    Statistics_UnFollowers_neutral_summary:
      "Das Verhalten des Publikums hat sich nicht verändert; du musst ihre Meinung direkt einholen und kurze Tests durchführen.",
    Statistics_UnFollowers_neutral_action1: "Starte eine Story-Umfrage, was sie ansprechender finden.",
    Statistics_UnFollowers_neutral_action2:
      "Veröffentliche jede Woche einen Post im festen Format und vergleiche die Ergebnisse.",
    Statistics_UnFollowers_neutral_action3:
      "Sammle die drei häufigsten Probleme aus den Comments und erstelle für jedes einen Lösungs-Post.",
    Statistics_UnFollowers_neutral_urgency: "Niedrig",

    Statistics_UnFollowers_down_title: "Anstieg der Unfollows 💡Du musst schnell reagieren",
    Statistics_UnFollowers_down_summary:
      "Ein Anstieg der Unfollows bedeutet ein negatives Signal im Content oder Posting-Rhythmus; du brauchst schnelle Tests und Reaktionen.",
    Statistics_UnFollowers_down_action1:
      "Prüfe die Daten der letzten 7 Tage und identifiziere die zwei Posts mit den meisten Unfollows.",
    Statistics_UnFollowers_down_action2:
      "Veröffentliche einen ehrlichen oder Behind-the-Scenes Post und frage dein Publikum direkt nach dem Grund.",
    Statistics_UnFollowers_down_action3:
      "Poste eine Story mit offener Frage: „Warum hast du entfolgt?“ und kategorisiere die Antworten.",
    Statistics_UnFollowers_down_urgency: "Hoch",

    Statistics_UnFollowers_zero_title: "Keine Aktivität 💡keine Daten zur Analyse",
    Statistics_UnFollowers_zero_summary:
      "Durch fehlende Aktivität entstehen keine Signale zur Analyse; starte zuerst deinen Veröffentlichungsrhythmus neu.",
    Statistics_UnFollowers_zero_action1:
      "Veröffentliche einen wertorientierten Post, um das erste Verhalten-Signal zu erzeugen.",
    Statistics_UnFollowers_zero_action2:
      "Poste zwei interaktive Stories (Poll oder Question), um erste Reaktionen zu erhalten.",
    Statistics_UnFollowers_zero_action3:
      "Veröffentliche einen kurzen Vorstellungs- oder Update-Post, um organische Reichweite zu starten.",
    Statistics_UnFollowers_zero_urgency: "Hoch",

    Statistics_Followers_up_title: "Anstieg der Follower 💡Begrüße neue Besucher richtig",
    Statistics_Followers_up_summary:
      "Das Wachstum steigt; von ihrem ersten Moment an solltest du ihnen ein positives Erlebnis bieten, damit sie aktive Followers werden.",
    Statistics_Followers_up_action1:
      "Erstelle ein Willkommens-Highlight im Format „Was du findest & wie es dir hilft“.",
    Statistics_Followers_up_action2:
      "Plane zwei leichte Kooperationen oder Mentions, um kontinuierliches und hochwertiges Wachstum zu sichern.",
    Statistics_Followers_up_action3: "Prüfe die Qualität der Followers über Kampagnenstatistiken und Reels-Einstiege.",
    Statistics_Followers_up_urgency: "Mittel",

    Statistics_Followers_neutral_title: "Stetiges Wachstum 💡Zeit für kurze Tests",
    Statistics_Followers_neutral_summary:
      "Das Seitenwachstum ist stabil; du brauchst 7-Tage-Tests, um herauszufinden, was die Reichweite beeinflusst.",
    Statistics_Followers_neutral_action1:
      "Führe einen 7-Tage-Test zu Hashtags, Veröffentlichungszeiten und verschiedenen Covern durch.",
    Statistics_Followers_neutral_action2:
      "Dokumentiere die Ergebnisse und mache aus der besten Kombination ein festes Format.",
    Statistics_Followers_neutral_action3:
      "Veröffentliche ein kurzes Einführungsvideo, damit neue Besucher schnell verstehen, was sie erwartet.",
    Statistics_Followers_neutral_urgency: "Mittel",

    Statistics_Followers_down_title: "Rückgang der Reichweite 💡Dein aktueller Content passt wohl nicht zur Persona",
    Statistics_Followers_down_summary:
      "Ein Rückgang der Anziehung bedeutet ein Signal für eine Diskrepanz zwischen deinem aktuellen Content und deiner Zielgruppe.",
    Statistics_Followers_down_action1:
      "Finde drei Unterschiede zwischen Persona und deinem aktuellen Content und korrigiere sie.",
    Statistics_Followers_down_action2: "Schreibe Bio, CTA und die Cover der letzten Posts schnell neu und teste sie.",
    Statistics_Followers_down_action3:
      "Starte eine kleine Kooperation- oder UGC-Kampagne, um das Seitenbild wieder zu aktivieren.",
    Statistics_Followers_down_urgency: "Hoch",

    Statistics_Followers_zero_title: "Keine aktuelle Aktivität 💡Keine Daten zur Anziehung",
    Statistics_Followers_zero_summary:
      "Durch fehlende Posts oder Maßnahmen gibt es keine Signale zur Analyse; du musst den Anziehungs-Zyklus neu starten.",
    Statistics_Followers_zero_action1:
      "Veröffentliche fünf kurze Reels mit einem 3-Sekunden-Hook, um die ersten Zugänge zu erzeugen.",
    Statistics_Followers_zero_action2:
      "Veröffentliche einen Intro- oder Update-Post, um die natürliche Reichweite zu starten.",
    Statistics_Followers_zero_action3:
      "Starte eine kleine Anziehungskampagne (auch lokal möglich), um das Wachstum wieder anzuschieben.",
    Statistics_Followers_zero_urgency: "Hoch",

    Statistics_MediaFollows_up_title: "Explore-Traffic Gestiegen 💡Seriencontent Ist Die Beste Strategie",
    Statistics_MediaFollows_up_summary:
      "Du erhältst externe Zugriffe; verwandle deine erfolgreichen Formate in eine regelmäßige Serie.",
    Statistics_MediaFollows_up_action1: "Teile das erfolgreiche Format in 3 bis 5 Episoden mit einem gemeinsamen CTA.",
    Statistics_MediaFollows_up_action2:
      "Wähle ein festes Cover und einen regelmäßigen Zeitplan, damit das Publikum der Serie folgt.",
    Statistics_MediaFollows_up_action3:
      "Beobachte die Verteilung der ersten Tage und konzentriere dich auf die Quelle, die am schnellsten Reichweite bringt.",
    Statistics_MediaFollows_up_urgency: "Mittel",

    Statistics_MediaFollows_neutral_title: "Mittlerer Referral 💡Zeit Für A/B-Test von Cover und Quelle",
    Statistics_MediaFollows_neutral_summary:
      "Um den Explore-Eingang zu erhöhen, müssen Cover und Referral-Quelle optimiert werden.",
    Statistics_MediaFollows_neutral_action1:
      "Veröffentliche zwei A/B-Cover und vergleiche ihre 48-Stunden-Performance.",
    Statistics_MediaFollows_neutral_action2:
      "Liste die Quellen, die den meisten Traffic gebracht haben, und targetiere sie erneut.",
    Statistics_MediaFollows_neutral_action3:
      "Erstelle eine Sammlung erfolgreicher Formate, um Wiederholungen zu erleichtern.",
    Statistics_MediaFollows_neutral_urgency: "Niedrig",

    Statistics_MediaFollows_down_title: "Explore-Reichweite ist gesunken 💡Ansprechenderer Content wird benötigt",
    Statistics_MediaFollows_down_summary:
      "Für mehr Reichweite über Explore funktionieren praktischere oder herunterladbare Inhalte besser.",
    Statistics_MediaFollows_down_action1:
      "Erstelle ein herunterladbares PDF oder eine Checkliste und teile einen Link für einfacheres Weiterleiten.",
    Statistics_MediaFollows_down_action2: "Veröffentliche kurze Lerninhalte und teste gezielte Werbung.",
    Statistics_MediaFollows_down_action3:
      "Überprüfe alle Links und Weiterleitungswege technisch, um sicherzugehen, dass nichts defekt ist.",
    Statistics_MediaFollows_down_urgency: "Hoch",

    Statistics_MediaFollows_zero_title: "Keine Aktivität 💡Kein Explore-Signal aufgebaut",
    Statistics_MediaFollows_zero_summary:
      "Ohne Veröffentlichungen oder Wachstumsaktionen gibt es keine Daten; zuerst muss der Content-Kreislauf aktiviert werden.",
    Statistics_MediaFollows_zero_action1:
      "Beginne konsequent damit, ansprechenden Content zu erstellen und zu veröffentlichen.",
    Statistics_MediaFollows_zero_action2:
      "Veröffentliche täglich fünf kurze Inhalte, um die ersten Weiterleitungssignale zu erzeugen.",
    Statistics_MediaFollows_zero_action3:
      "Veröffentliche am ersten Tag einen verstärkten Post, um den ersten Traffic zu erzeugen.",
    Statistics_MediaFollows_zero_urgency: "Hoch",

    Statistics_Reach_up_title: "Reach gewachsen 💡Zeit zu skalieren",
    Statistics_Reach_up_summary:
      "Die Reichweite ist gestiegen; wiederholen Sie Ihre besten Formate, um die Wachstumwelle aufrechtzuerhalten.",
    Statistics_Reach_up_action_1: "Veröffentlichen Sie zwei der höchsten Reach-Formate erneut zu Spitzenzeiten.",
    Statistics_Reach_up_action_2: "Fixieren Sie effektive Hashtags und setzen Sie sie immer in die Caption.",
    Statistics_Reach_up_action_3: "Erstellen Sie Posts mit hoher Teilbarkeit, um den organischen Reach zu steigern.",
    Statistics_Reach_up_urgency: "Mittel",

    Statistics_Reach_neutral_title: "Reach stabil 💡Tests erforderlich",
    Statistics_Reach_neutral_summary:
      "Um die Stagnation zu überwinden, ist leichte Zusammenarbeit oder Hashtag-Testing der beste Ansatz.",
    Statistics_Reach_neutral_action_1: "Koordinieren Sie einen cross-Post mit einer ähnlichen Seite.",
    Statistics_Reach_neutral_action_2:
      "Veröffentlichen Sie zwei edukative oder unterhaltsame Reels und werten Sie das Feedback aus.",
    Statistics_Reach_neutral_action_3:
      "Überprüfen Sie Ihre wöchentliche Hashtag-Liste und finden Sie die beste Kombination.",
    Statistics_Reach_neutral_urgency: "Niedrig",

    Statistics_Reach_down_title: "Reach gefallen 💡Sofort handeln",
    Statistics_Reach_down_summary: "Die Reichweite ist gesunken; teilbarer Inhalt und Kurzzeittests haben Priorität.",
    Statistics_Reach_down_action_1: "Führen Sie einen 7-tägigen Test auf Reels mit hohem Potenzial durch.",
    Statistics_Reach_down_action_2: "Erstellen Sie shareable Posts und verstärken Sie diese mit einer kurzen Anzeige.",
    Statistics_Reach_down_action_3: "Titel, Cover und Hashtags neu schreiben und Post erneut veröffentlichen.",
    Statistics_Reach_down_urgency: "Hoch",

    Statistics_Reach_zero_title: "Reach nicht erfasst 💡Wenig Aktivität",
    Statistics_Reach_zero_summary:
      "Aufgrund fehlender Posts oder ausreichender Signale gibt es keine Reach-Daten; der Content-Zyklus muss aktiviert werden.",
    Statistics_Reach_zero_action_1: "Überprüfen Sie die Datensammlung (API/logs) auf korrekte Funktion.",
    Statistics_Reach_zero_action_2: "Veröffentlichen Sie 5 trendige Reels und verstärken Sie eine ab dem zweiten Tag.",
    Statistics_Reach_zero_action_3: "Testen Sie das Veröffentlichungssystem und setzen Sie es bei Bedarf zurück.",
    Statistics_Reach_zero_urgency: "Hoch",

    Statistics_ProfileVisit_up_title: "Profilbesuche Hoch 💡Fokus auf Conversion",
    Statistics_ProfileVisit_up_summary:
      "Guter eingehender Traffic; Bio und CTA müssen schnell optimiert werden, damit Besuche in Follows und Clicks umgewandelt werden.",
    Statistics_ProfileVisit_up_action_1: "Bio mit klarem Wertversprechen und direktem CTA neu schreiben.",
    Statistics_ProfileVisit_up_action_2:
      "Erstellen Sie wichtige Highlights, damit der Nutzer versteht, was er gesehen hat und was ihn erwartet.",
    Statistics_ProfileVisit_up_action_3:
      "Veröffentlichen Sie einen Post mit einem Spezialangebot, um die Klickrate auf den Link zu erhöhen.",
    Statistics_ProfileVisit_up_urgency: "Hoch",

    Statistics_ProfileVisit_neutral_title: "Besuche Vorhanden, Conversion Niedrig 💡Leads Generieren",
    Statistics_ProfileVisit_neutral_summary:
      "Traffic ist vorhanden, aber Conversion niedrig; ein attraktiver Lead kann den Fluss ändern.",
    Statistics_ProfileVisit_neutral_action_1: "Fügen Sie eine kostenlose Datei oder Checkliste in Highlights hinzu.",
    Statistics_ProfileVisit_neutral_action_2: "Verstärken Sie Captions mit CTA, die mit dem Profil zusammenhängen.",
    Statistics_ProfileVisit_neutral_action_3: "Erhöhen Sie einladende und profilführende Stories.",
    Statistics_ProfileVisit_neutral_urgency: "Mittel",

    Statistics_ProfileVisit_down_title: "Profilbesuche Gesunken 💡Stärkerer Hook Nötig",
    Statistics_ProfileVisit_down_summary:
      "Neugierde ist gesunken; Beginn der Captions und CTA sollten ansprechender und klarer sein.",
    Statistics_ProfileVisit_down_action_1: "Captions mit einem 3–5 Wörter Hook neu schreiben.",
    Statistics_ProfileVisit_down_action_2: "Leitende Stories hinzufügen und den Link fett markieren.",
    Statistics_ProfileVisit_down_action_3:
      "Veröffentlichen Sie einen einladenden Post, der Benutzer zur Profilbesuch animiert.",
    Statistics_ProfileVisit_down_urgency: "Hoch",

    Statistics_ProfileVisit_zero_title: "Keine Profilbesuche 💡Aktivität Unzureichend",
    Statistics_ProfileVisit_zero_summary:
      "Aufgrund fehlender Posts oder Signale wurden keine Profilbesuche erfasst; der Engagement-Zyklus muss reaktiviert werden.",
    Statistics_ProfileVisit_zero_action_1: "Kontostatus überprüfen, damit er public ist.",
    Statistics_ProfileVisit_zero_action_2: "Veröffentlichen Sie einen einladenden Post mit klarem CTA.",
    Statistics_ProfileVisit_zero_action_3: "Wichtige Highlights aktualisieren, um das erste Besuchssignal zu erzeugen.",
    Statistics_ProfileVisit_zero_urgency: "Hoch",

    Statistics_Likes_up_title: "Likes Sind Gut 💡Gewohnheit Aufbauen",
    Statistics_Likes_up_summary: "Benutzer liken; jetzt das Verhalten in eine konstante Gewohnheit verwandeln.",
    Statistics_Likes_up_action_1: "Erfolgreiche Formate dokumentieren (cover, template, Länge).",
    Statistics_Likes_up_action_2:
      "Am Ende des Post einen einfachen CTA für Likes hinzufügen (z. B. 'Wenn du zustimmst ❤').",
    Statistics_Likes_up_action_3: "Kleinen A/B-Test für Cover und die ersten 3 Sekunden durchführen.",
    Statistics_Likes_up_urgency: "Mittel",

    Statistics_Likes_neutral_title: "Likes Können Steigen 💡Hook & Cover Verbessern",
    Statistics_Likes_neutral_summary:
      "Es gibt Potenzial; durch Änderung von Cover und Hook kann die Like-Rate erhöht werden.",
    Statistics_Likes_neutral_action_1: "Cover und die ersten 3 Sekunden optimieren und testen.",
    Statistics_Likes_neutral_action_2: "Emotionale oder fragebasierte CTA für Likes verwenden.",
    Statistics_Likes_neutral_action_3:
      "Kleine Umfrage durchführen, um visuelle Präferenzen des Publikums zu verstehen.",
    Statistics_Likes_neutral_urgency: "Niedrig",

    Statistics_Likes_down_title: "Likes Gesunken 💡Visuelle Identität Überarbeiten",
    Statistics_Likes_down_summary:
      "Die Nachricht oder das Bild ist möglicherweise nicht stark; konzentrieren Sie sich auf den ersten Moment des Inhalts.",
    Statistics_Likes_down_action_1: "Cover und die erste Zeile des caption neu schreiben.",
    Statistics_Likes_down_action_2: "Führen Sie einen A/B-Test für Farbe/Design des cover durch.",
    Statistics_Likes_down_action_3: "Veröffentlichen Sie starke und relevante visuelle Posts.",
    Statistics_Likes_down_urgency: "Hoch",

    Statistics_Likes_zero_title: "Null Likes 💡Entweder Keine Daten oder Kein Inhalt",
    Statistics_Likes_zero_summary:
      "Wenn Inhalte vorhanden sind, aber keine Likes registriert wurden, überprüfen Sie die Daten; andernfalls beginnen Sie mit der Produktion.",
    Statistics_Likes_zero_action_1: "Überprüfen Sie die Genauigkeit der Datenerfassung.",
    Statistics_Likes_zero_action_2:
      "Wenn kein Inhalt vorhanden ist, veröffentlichen Sie mehrere Posts mit starken cover.",
    Statistics_Likes_zero_action_3: "Verwenden Sie Partnernetzwerke, um Feedback zu sammeln.",
    Statistics_Likes_zero_urgency: "Hoch",

    Statistics_Comments_up_title: "Kommentare Zunehmen 💡Gespräche Ernst Nehmen",
    Statistics_Comments_up_summary:
      "Die Leute reden; nutzen Sie dies, indem Sie antworten und Kommentare in Inhalte umwandeln.",
    Statistics_Comments_up_action1: "Antworten Sie auf Kommentare und verwandeln Sie die Top-3-Ideen in einen Post.",
    Statistics_Comments_up_action2: "Heben Sie die besten Kommentare hervor oder zeigen Sie sie in einer Story.",
    Statistics_Comments_up_action3: "Fügen Sie im caption eine Frage hinzu, die die Leute zum Antworten anregt.",
    Statistics_Comments_up_urgency: "Mittel",

    Statistics_Comments_neutral_title: "Kommentare Niedrig 💡Reiz Hinzufügen",
    Statistics_Comments_neutral_summary: "Um Konversation zu erzeugen, stellen Sie einfache und direkte Fragen.",
    Statistics_Comments_neutral_action1: "Lassen Sie am Ende des Posts eine offene Frage.",
    Statistics_Comments_neutral_action2: "Antworten Sie schnell auf die ersten 5 Kommentare, um andere zu motivieren.",
    Statistics_Comments_neutral_action3: "Führen Sie eine kurze Challenge oder Umfrage durch.",
    Statistics_Comments_neutral_urgency: "Niedrig",

    Statistics_Comments_down_title: "Kommentare Abgenommen 💡Setze Klare Anreize",
    Statistics_Comments_down_summary: "Du brauchst direkte CTAs und Einladungen, um Gespräche zu starten.",
    Statistics_Comments_down_action1: "Veröffentliche eine Challenge oder fordere persönliche Erfahrungen an.",
    Statistics_Comments_down_action2:
      "Füge einen klaren CTA für Kommentare in das caption ein (z. B.: 'Was denkst du?').",
    Statistics_Comments_down_action3: "Reagiere schnell auf erste Kommentare.",
    Statistics_Comments_down_urgency: "Hoch",

    Statistics_Comments_zero_title: "Keine Kommentare 💡Sei Einladend",
    Statistics_Comments_zero_summary: "Der Inhalt motiviert nicht zum Kommentieren; mache die Formate einladender.",
    Statistics_Comments_zero_action1: "Gestalte einfache und ansprechende Fragen (z. B. Wahl zwischen zwei Optionen).",
    Statistics_Comments_zero_action2: "Antworte schnell auf die ersten Kommentare, um andere zu ermutigen.",
    Statistics_Comments_zero_action3: "Verwende direkte CTAs, um Kommentare einzuladen.",
    Statistics_Comments_zero_urgency: "Hoch",

    Statistics_Views_up_title: "Views Gestiegen 💡Nutze den Traffic",
    Statistics_Views_up_summary:
      "Videoaufrufe sind gut; nutze das Ende des Videos, um Traffic zu lenken (Profil/Speichern).",
    Statistics_Views_up_action1: "Füge am Ende des Videos einen klaren CTA hinzu (z. B.: 'Für mehr speichern').",
    Statistics_Views_up_action2: "Platziere einen Link zu ergänzendem Inhalt in Bio oder Highlights.",
    Statistics_Views_up_action3: "Erstelle und veröffentliche eine kürzere Version oder einen Teaser.",
    Statistics_Views_up_urgency: "Mittel",

    Statistics_Views_neutral_title: "Views Stabil 💡Stärkung von Hook und Cover",
    Statistics_Views_neutral_summary: "Arbeite an den ersten 3 Sekunden und dem Cover, um die View-Rate zu verbessern.",
    Statistics_Views_neutral_action1: "Schreibe den Einstiegshook und das Cover neu.",
    Statistics_Views_neutral_action2: "Veröffentliche eine kürzere Version zum Testen.",
    Statistics_Views_neutral_action3: "Sammle visuelles Feedback vom Publikum.",
    Statistics_Views_neutral_urgency: "Niedrig",

    Statistics_Views_down_title: "Views Gesunken 💡Stärkung des Hooks",
    Statistics_Views_down_summary:
      "Der Anfang des Videos ist schwach; starte Tests mit kürzeren, ansprechenden Versionen.",
    Statistics_Views_down_action1: "Erstelle 5 starke 15-Sekunden-Videos mit einem Hook.",
    Statistics_Views_down_action2: "Schreibe den Videostart neu und führe A/B-Tests durch.",
    Statistics_Views_down_action3: "Erhöhe die Schnittgeschwindigkeit, um Aufmerksamkeit zu halten.",
    Statistics_Views_down_urgency: "Hoch",

    Statistics_Views_zero_title: "Null Views? 💡Inhalte sofort veröffentlichen",
    Statistics_Views_zero_summary: "Beginne so schnell wie möglich mit der Inhaltserstellung.",
    Statistics_Views_zero_action1: "Starte nur mit der Analyse des Seitenablaufs.",
    Statistics_Views_zero_action2: "Wenn keine Videos veröffentlicht wurden, erstelle 3 kurze Reels.",
    Statistics_Views_zero_action3: "Führe einen Booster-Post aus, um erste Impressionen zu erzeugen.",
    Statistics_Views_zero_urgency: "Hoch",

    Statistics_FollowerViews_up_title: "Follower sehen 💡Baue internes Engagement auf",
    Statistics_FollowerViews_up_summary: "Follower sind aktiv; nutze sie für internes Engagement (AMA, Umfragen).",
    Statistics_FollowerViews_up_action1: "Stelle in Stories Fragen oder führe Umfragen für Follower durch.",
    Statistics_FollowerViews_up_action2: "Veröffentliche exklusive Inhalte für Follower (z. B. AMA).",
    Statistics_FollowerViews_up_action3:
      "Überprüfe Formate anhand von Personas, um genauer auf ihre Vorlieben einzugehen.",
    Statistics_FollowerViews_up_urgency: "Mittel",

    Statistics_FollowerViews_neutral_title: "Follower-Views sind durchschnittlich 💡Teste Timing & Format",
    Statistics_FollowerViews_neutral_summary:
      "Veröffentlichungszeit oder Inhaltstyp könnte angepasst werden müssen; führe einfache Tests durch.",
    Statistics_FollowerViews_neutral_action1: "Verschiebe die Veröffentlichungszeit und tracke die Auswirkungen.",
    Statistics_FollowerViews_neutral_action2: "Teste ein neues Format speziell für Follower.",
    Statistics_FollowerViews_neutral_action3: "Personalisiere Inhalte basierend auf früherem Nutzerverhalten.",
    Statistics_FollowerViews_neutral_urgency: "Niedrig",

    Statistics_FollowerViews_down_title: "Follower-Views gesunken 💡Feedback einholen",
    Statistics_FollowerViews_down_summary:
      "Möglicher Abstand zur Persona; Feedback sammeln und 3 schnelle Änderungen umsetzen.",
    Statistics_FollowerViews_down_action1:
      "Sammeln Sie aktuelles Feedback und führen Sie drei schnelle Änderungen durch.",
    Statistics_FollowerViews_down_action2: "Posten Sie ansprechende Stories, um das Publikum wieder zu aktivieren.",
    Statistics_FollowerViews_down_action3: "Testen Sie personalisierte Content-Versionen.",
    Statistics_FollowerViews_down_urgency: "Hoch",

    Statistics_FollowerViews_zero_title: "Follower-Views null 💡Stellen Sie zunächst aktive Follower sicher",
    Statistics_FollowerViews_zero_summary:
      "Möglicherweise haben Sie wenige aktive Follower; wecken Sie sie zuerst auf, dann interagieren.",
    Statistics_FollowerViews_zero_action1:
      "Veröffentlichen Sie mehrere Stories und Posts, um das Publikum zu aktivieren.",
    Statistics_FollowerViews_zero_action2: "Interagieren Sie direkt mit 10 aktiven Followern.",
    Statistics_FollowerViews_zero_action3: "Erstellen Sie Inhalte basierend auf vorherigen Interessen.",
    Statistics_FollowerViews_zero_urgency: "Hoch",

    Statistics_NonFollowerViews_up_title: "Nicht-Follower-Views gestiegen 💡Neue Wachstumschance",
    Statistics_NonFollowerViews_up_summary:
      "Personen außerhalb Ihrer Follower sehen zu; jeder Beitrag benötigt einen starken Grund zum Folgen.",
    Statistics_NonFollowerViews_up_action1:
      "Fügen Sie im Caption einen starken Follow-Grund hinzu (z. B. Serieninhalt oder Schritt-für-Schritt-Tutorials).",
    Statistics_NonFollowerViews_up_action2:
      "Erstellen Sie trendige, ansprechende Reels, um Nicht-Follower zu Interaktionen zu bewegen.",
    Statistics_NonFollowerViews_up_action3: "Verwenden Sie zielgerichtete Hashtags und relevante Kooperationen.",
    Statistics_NonFollowerViews_up_urgency: "Mittel",

    Statistics_NonFollowerViews_neutral_title: "Nicht-Follower-Views stabil 💡Hashtags und Verteilung optimieren",
    Statistics_NonFollowerViews_neutral_summary:
      "Die Optimierung von Hashtags und teilbarem Content kann den Nicht-Follower-Traffic erhöhen.",
    Statistics_NonFollowerViews_neutral_action1: "Effektive Hashtags identifizieren und einige konstant halten.",
    Statistics_NonFollowerViews_neutral_action2: "Mehr teilbaren Content erstellen.",
    Statistics_NonFollowerViews_neutral_action3: "Eine kurze Zusammenarbeit mit themenrelevanten Seiten durchführen.",
    Statistics_NonFollowerViews_neutral_urgency: "Niedrig",

    Statistics_NonFollowerViews_down_title: "Nicht-Follower-Views gesunken 💡Zusammenarbeit & Promo nötig",
    Statistics_NonFollowerViews_down_summary:
      "Explore-Reichweite ist gesunken; bring den Traffic mit Zusammenarbeit oder leichter Promotion zurück.",
    Statistics_NonFollowerViews_down_action1: "Richte eine schnelle Zusammenarbeit mit einer relevanten Seite ein.",
    Statistics_NonFollowerViews_down_action2: "Erstelle mehr teilbare Posts und veröffentliche einen Boost-Post.",
    Statistics_NonFollowerViews_down_action3:
      "Starte eine kleine, zielgerichtete Anzeige, um den Traffic zurückzubringen.",
    Statistics_NonFollowerViews_down_urgency: "Hoch",

    Statistics_NonFollowerViews_zero_title: "Nicht-Follower-Views null 💡Baue Explore-Signale auf",
    Statistics_NonFollowerViews_zero_summary:
      "Für den ersten Traffic sind trendige Reels und Zusammenarbeit der beste Start.",
    Statistics_NonFollowerViews_zero_action1: "Produziere 3 trendbasierte Reels.",
    Statistics_NonFollowerViews_zero_action2: "Veröffentliche einen Boost-Post, um ersten Traffic zu generieren.",
    Statistics_NonFollowerViews_zero_action3: "Starte eine schnelle Zusammenarbeit mit einer relevanten Seite.",
    Statistics_NonFollowerViews_zero_urgency: "Hoch",

    Statistics_Shares_up_title: "Shares hoch 💡Dein Content ist teilenswert",
    Statistics_Shares_up_summary: "Leute teilen deine Posts; der Content hat sofortigen Wert und kann konvertieren.",
    Statistics_Shares_up_action1: "Analysiere Share-Feedback und finde Muster.",
    Statistics_Shares_up_action2: "Füge im Caption einen klaren Grund zum Teilen hinzu ('An deinen Freund senden').",
    Statistics_Shares_up_action3: "Gestalte eine teilbare Bildung-Serie.",
    Statistics_Shares_up_urgency: "Mittel",

    Statistics_Shares_neutral_title: "Shares niedrig oder stabil 💡nur ein simpler Auslöser nötig",
    Statistics_Shares_neutral_summary: "Manchmal reicht ein kurzer CTA, um Shares zu erhöhen.",
    Statistics_Shares_neutral_action1: "Füge am Ende des Posts einen sehr kurzen CTA zum Teilen hinzu.",
    Statistics_Shares_neutral_action2: "Erstelle mehr speicherbaren und teilbaren Content.",
    Statistics_Shares_neutral_action3: "Teste eine Vorlage 'An deinen Freund senden'.",
    Statistics_Shares_neutral_urgency: "Niedrig",

    Statistics_Shares_down_title: "Shares gesunken 💡Praktischere Inhalte nötig",
    Statistics_Shares_down_summary:
      "Der Inhalt ist weniger teilbar; erstelle etwas, das die Leute tatsächlich weitergeben wollen.",
    Statistics_Shares_down_action1: "Erstelle Checklisten oder Schritt-für-Schritt-Inhalte.",
    Statistics_Shares_down_action2: "Veröffentliche kurze und prägnante Tutorials.",
    Statistics_Shares_down_action3: "Füge einen klaren CTA für das Teilen hinzu.",
    Statistics_Shares_down_urgency: "Hoch",

    Statistics_Shares_zero_title: "Keine Shares 💡Du brauchst einen Startpunkt",
    Statistics_Shares_zero_summary:
      "Entweder gibt es keine Daten oder der Inhalt ist nicht teilbar; erstelle schnell einen Verteilungsplan.",
    Statistics_Shares_zero_action1: "Produziere mehrere 5-Tipps- oder Checklisten-Inhalte.",
    Statistics_Shares_zero_action2: "Starte ein kleines Boosting, um das erste Signal zu bekommen.",
    Statistics_Shares_zero_action3: "Schreibe einen klaren Grund zum Teilen in die Caption.",
    Statistics_Shares_zero_urgency: "Hoch",

    Statistics_Engagement_up_title: "Engagement steigt 💡Formel sichern",
    Statistics_Engagement_up_summary: "Du hast ein erfolgreiches Muster gefunden; jetzt wiederholen und ausbauen.",
    Statistics_Engagement_up_action1: "Erfolgreiche Formate und Zeiten genau dokumentieren.",
    Statistics_Engagement_up_action2: "Engagement-fördernde Formate in den Content-Kalender aufnehmen.",
    Statistics_Engagement_up_action3: "Wöchentlich ein neues Format zur Bindung testen.",
    Statistics_Engagement_up_urgency: "Mittel",

    Statistics_Engagement_neutral_title: "Engagement durchschnittlich 💡frischer Impuls nötig",
    Statistics_Engagement_neutral_summary:
      "Für Wachstum neue Impulse einführen, z.B. Fragen, Challenges oder Kommentaraufrufe.",
    Statistics_Engagement_neutral_action1: "Wöchentlich einen Post zur Kommentarinvitation veröffentlichen.",
    Statistics_Engagement_neutral_action2: "Engagement kanalisieren und Ergebnisse verschiedener Formate vergleichen.",
    Statistics_Engagement_neutral_action3: "Einige schnelle Interaktionsvorlagen erstellen.",
    Statistics_Engagement_neutral_urgency: "Niedrig",

    Statistics_Engagement_down_title: "Engagement fällt 💡schnelle Neugestaltung nötig",
    Statistics_Engagement_down_summary:
      "Neue Tests müssen sofort gestartet werden; ein 14-Tage-Plan ist der beste Anfang.",
    Statistics_Engagement_down_action1: "Führe einen 14-Tage-Plan mit 3 verschiedenen Formaten durch.",
    Statistics_Engagement_down_action2: "Erfasse täglich die Daten und pivotiere schnell.",
    Statistics_Engagement_down_action3: "Frage dein Publikum direkt, welcher Inhalt spannend ist.",
    Statistics_Engagement_down_urgency: "Hoch",

    Statistics_Engagement_zero_title: "Null Engagement 💡7-tägiger Intensivplan nötig",
    Statistics_Engagement_zero_summary:
      "Du musst schnell Engagement-Signale erzeugen; poste täglich interaktive Inhalte und verfolge die Daten.",
    Statistics_Engagement_zero_action1: "Veröffentliche Umfragen, offene Fragen und kleine Challenges.",
    Statistics_Engagement_zero_action2: "Teste jedes Format für 3 Tage.",
    Statistics_Engagement_zero_action3: "Antworte schnell auf Kommentare und Nachrichten.",
    Statistics_Engagement_zero_urgency: "Hoch",

    Statistics_Replies_up_title: "Viele Story-Antworten 💡Hol Content daraus",
    Statistics_Replies_up_summary:
      "Die Leute schreiben dir; sie wollen mit dir interagieren. Das ist perfekte Content-Rohstoff.",
    Statistics_Replies_up_action_1: "Wähle 3 der besten Antworten und verwandle sie in einen Post oder Reel.",
    Statistics_Replies_up_action_2: "Erstelle ein Q&A oder FAQ mit den häufigsten Antworten.",
    Statistics_Replies_up_action_3: "Zeige in der nächsten Story ein paar Antworten, damit andere motiviert werden.",
    Statistics_Replies_up_urgency: "Mittel",

    Statistics_Replies_neutral_title: "Wenige Antworten 💡Setze einen Anreiz",
    Statistics_Replies_neutral_summary: "Um mehr Antworten zu bekommen, reicht manchmal schon eine einfache Frage.",
    Statistics_Replies_neutral_action_1: "Füge einen Frage-Sticker, Poll oder Quiz hinzu.",
    Statistics_Replies_neutral_action_2: "Stelle kurze und spannende Fragen.",
    Statistics_Replies_neutral_action_3: "Reagiere schnell auf Antworten, um das Interaktionsgefühl zu steigern.",
    Statistics_Replies_neutral_urgency: "Gering",

    Statistics_Replies_down_title: "Antworten sind gesunken 💡Erhöhe die Nähe",
    Statistics_Replies_down_summary:
      "Die Zuschauer scheinen sich entfernt zu haben; nähere dich ihnen mit persönlicherem Content.",
    Statistics_Replies_down_action_1: "Poste ein paar persönlichere, erfahrungsbasierte oder emotionale Stories.",
    Statistics_Replies_down_action_2: "Stelle Fragen, die persönliche Erfahrungen erfordern.",
    Statistics_Replies_down_action_3: "Achte besonders auf die ersten Antworten und reagiere oder antworte darauf.",
    Statistics_Replies_down_urgency: "Hoch",

    Statistics_Replies_zero_title: "Null Antworten 💡Direkte Einladung nötig",
    Statistics_Replies_zero_summary: "Wenn es keine Antworten gibt, musst du verführerisch und direkt fragen.",
    Statistics_Replies_zero_action_1: "Stelle sehr einfache und spannende Fragen (z. B. Wahl zwischen zwei Optionen).",
    Statistics_Replies_zero_action_2: "Heb die Antworten hervor, die du bekommst, damit andere motiviert werden.",
    Statistics_Replies_zero_action_3: "Führe jeden Tag eine leichte interaktive Story durch.",
    Statistics_Replies_zero_urgency: "Hoch",

    Statistics_TotalTime_up_title: "Sehzeit gestiegen 💡Biete tiefere Inhalte",
    Statistics_TotalTime_up_summary: "Das Publikum investiert Zeit; bereit für längere, kapitelartige Inhalte.",
    Statistics_TotalTime_up_action_1: "Erstelle längere Videos mit Struktur: Einführung/Mittelteil/Schluss.",
    Statistics_TotalTime_up_action_2: "Füge Links zu ergänzendem Inhalt in Bio oder Highlights ein.",
    Statistics_TotalTime_up_action_3: "Segmentiere das Video klar, um die Retention zu erhöhen.",
    Statistics_TotalTime_up_urgency: "Mittel",

    Statistics_TotalTime_neutral_title: "Sehzeit normal 💡Struktur stärken",
    Statistics_TotalTime_neutral_summary:
      "Das Publikum bleibt, aber ist nicht vollständig gebunden; verbessere die Struktur zur besseren Bindung.",
    Statistics_TotalTime_neutral_action_1: "Implementiere eine dreischichtige Struktur für Videos.",
    Statistics_TotalTime_neutral_action_2: "Hebe Schlüsselstellen hervor, damit Zuschauer wissen, was sie erwartet.",
    Statistics_TotalTime_neutral_action_3: "Erstelle eine Kurzversion zum Testen und Vergleichen.",
    Statistics_TotalTime_neutral_urgency: "Niedrig",

    Statistics_TotalTime_down_title: "Sehzeit gefallen 💡Schwacher erster Hook",
    Statistics_TotalTime_down_summary: "Die ersten 3 Sekunden müssen packen; schneller, prägnanter und stärker.",
    Statistics_TotalTime_down_action_1: "Die ersten 3 Sekunden neu schreiben und mehrere Versionen testen.",
    Statistics_TotalTime_down_action_2: "Sehr kurze Versionen von 15–30 Sekunden erstellen.",
    Statistics_TotalTime_down_action_3: "Schnitt-Rhythmus, Cuts und Musik schärfen.",
    Statistics_TotalTime_down_urgency: "Hoch",

    Statistics_TotalTime_zero_title: "Sehzeit Null 💡Noch nichts veröffentlicht?",
    Statistics_TotalTime_zero_summary:
      "Wenn das Video existiert, aber keine Zeit registriert wird, prüfe zuerst technische Probleme.",
    Statistics_TotalTime_zero_action_1: "Stelle sicher, dass der Inhalt veröffentlicht ist.",
    Statistics_TotalTime_zero_action_2: "Wenn nicht veröffentlicht, 3 kurze Reels hintereinander posten.",
    Statistics_TotalTime_zero_action_3: "Boost oder Erstanzeige ausführen, um Daten zu sammeln.",
    Statistics_TotalTime_zero_urgency: "Hoch",

    Statistics_ReachMonth_up_title: "Monatliche Reichweite gestiegen 💡Muster fixieren",
    Statistics_ReachMonth_up_summary:
      "Erfolgreiche Monate sind klar; notieren Sie die Muster und planen Sie für den nächsten Monat.",
    Statistics_ReachMonth_up_action_1: "Analysieren Sie ertragreiche Monate und dokumentieren Sie die Muster.",
    Statistics_ReachMonth_up_action_2: "Aktualisieren Sie den Content-Kalender mit diesen Mustern.",
    Statistics_ReachMonth_up_action_3: "Veröffentlichen Sie erfolgreiche Formate erneut für den nächsten Monat.",
    Statistics_ReachMonth_up_urgency: "Mittel",

    Statistics_ReachMonth_neutral_title: "Monatliche Reichweite stabil 💡Zeit für Test & Wachstum",
    Statistics_ReachMonth_neutral_summary:
      "Um die monatliche Reichweite zu steigern, starten Sie eine kurze Kampagne oder eine begrenzte Werbung.",
    Statistics_ReachMonth_neutral_action_1: "Starten Sie eine gemeinsame Kampagne oder begrenzte Werbung.",
    Statistics_ReachMonth_neutral_action_2: "Ergebnisse aufzeichnen, vergleichen und optimieren.",
    Statistics_ReachMonth_neutral_action_3: "Vorherige erfolgreiche Posts erneut pushen.",
    Statistics_ReachMonth_neutral_urgency: "Niedrig",

    Statistics_ReachMonth_down_title: "Monatliche Reichweite gefallen 💡Inhalte neu erstellen",
    Statistics_ReachMonth_down_summary:
      "Um die Reichweite wiederherzustellen, Schlüsselposts erneut veröffentlichen oder neu gestalten.",
    Statistics_ReachMonth_down_action_1: "Schlüsselposts erneut veröffentlichen oder neu erstellen.",
    Statistics_ReachMonth_down_action_2:
      "Führen Sie eine 14-tägige Kampagne zur Inhaltsproduktion und -förderung durch.",
    Statistics_ReachMonth_down_action_3: "Überprüfen Sie Hashtags und Tags erneut.",
    Statistics_ReachMonth_down_urgency: "Hoch",

    Statistics_ReachMonth_zero_title: "Monatliche Reichweite Null 💡Überprüfen Sie zuerst die Daten",
    Statistics_ReachMonth_zero_summary:
      "Keine oder unvollständige Daten; überprüfen Sie zuerst technische Probleme, dann starten Sie einen 14-tägigen Plan.",
    Statistics_ReachMonth_zero_action_1: "Überprüfen Sie Datenverbindungen und -registrierungen.",
    Statistics_ReachMonth_zero_action_2: "Führen Sie einen 14-tägigen Inhaltsproduktionsplan durch.",
    Statistics_ReachMonth_zero_action_3: "Verfolgen Sie die täglichen Ergebnisse.",
    Statistics_ReachMonth_zero_urgency: "Hoch",

    Statistics_MonthEngagement_up_title: "Monatliches Engagement Steigt 💡Skalieren",
    Statistics_MonthEngagement_up_summary: "Positive monatliche Muster aufzeichnen und wiederholen.",
    Statistics_MonthEngagement_up_action_1: "Erfolgreiche Vorlagen und Formate dokumentieren.",
    Statistics_MonthEngagement_up_action_2: "Klare KPIs und Pläne für den nächsten Monat festlegen.",
    Statistics_MonthEngagement_up_action_3: "Kleine wöchentliche Tests zur Verbesserung des Engagements durchführen.",
    Statistics_MonthEngagement_up_urgency: "Mittel",

    Statistics_MonthEngagement_neutral_title: "Monatliches Engagement Normal 💡Füge ein Herausforderungs-Element hinzu",
    Statistics_MonthEngagement_neutral_summary:
      "Eine wöchentliche Herausforderung oder Frage kann das Engagement steigern.",
    Statistics_MonthEngagement_neutral_action_1:
      "Veröffentlichen Sie wöchentlich einen herausfordernden oder fragebasierten Inhalt.",
    Statistics_MonthEngagement_neutral_action_2: "Ergebnisse aufzeichnen und vergleichen.",
    Statistics_MonthEngagement_neutral_action_3: "Erstellen Sie eine wöchentliche Engagement-Serie.",
    Statistics_MonthEngagement_neutral_urgency: "Niedrig",

    Statistics_MonthEngagement_down_title: "Monatliches Engagement gesunken 💡14-Tage-Plan starten",
    Statistics_MonthEngagement_down_summary: "Formate überprüfen und einen 14-Tage-Plan umsetzen.",
    Statistics_MonthEngagement_down_action_1: "14-Tage-Plan mit 3 verschiedenen Formaten durchführen.",
    Statistics_MonthEngagement_down_action_2: "Ergebnisse täglich analysieren.",
    Statistics_MonthEngagement_down_action_3: "Direktes Feedback vom Publikum einholen.",
    Statistics_MonthEngagement_down_urgency: "Hoch",

    Statistics_MonthEngagement_zero_title: "Monatliches Engagement Null 💡Sofortiges 7-Tage-Programm",
    Statistics_MonthEngagement_zero_summary:
      "Veröffentlichen Sie 7 schnelle interaktive Beiträge und überwachen Sie täglich.",
    Statistics_MonthEngagement_zero_action_1: "Erstellen Sie 7 interaktive Beiträge.",
    Statistics_MonthEngagement_zero_action_2: "Ergebnisse täglich überprüfen.",
    Statistics_MonthEngagement_zero_action_3: "Interagieren Sie mit dem Publikum über DMs und Kommentare.",
    Statistics_MonthEngagement_zero_urgency: "Hoch",

    Statistics_MonthView_up_title: "Monatliche Aufrufe gestiegen 💡Struktur sichern",
    Statistics_MonthView_up_summary: "Video-Strategie funktioniert; diese Formate konsistent veröffentlichen.",
    Statistics_MonthView_up_action_1: "Dokumentiere deine Video-Strategie.",
    Statistics_MonthView_up_action_2: "Regelmäßige Produktion in ein Standardformat umwandeln.",
    Statistics_MonthView_up_action_3: "Schlüsselkennzahlen jedes Monats überprüfen und aufzeichnen.",
    Statistics_MonthView_up_urgency: "Mittel",

    Statistics_MonthView_neutral_title: "Monatliche Aufrufe stabil 💡Formatmix ausprobieren",
    Statistics_MonthView_neutral_summary: "Mix aus Reels und Stories kann neue Traffic-Kanäle erzeugen.",
    Statistics_MonthView_neutral_action_1: "Gemischten Reels+Stories Content erstellen.",
    Statistics_MonthView_neutral_action_2: "Leistung aufzeichnen und vergleichen.",
    Statistics_MonthView_neutral_action_3: "Captions hinzufügen, die auf das Video verweisen.",
    Statistics_MonthView_neutral_urgency: "Niedrig",

    Statistics_MonthView_down_title: "Monatliche Aufrufe gesunken 💡Fokus auf Reels",
    Statistics_MonthView_down_summary:
      "Kurze Reels mit auffälligen Covern sind der schnellste Weg, um Views zurückzugewinnen.",
    Statistics_MonthView_down_action_1: "Erstellen Sie 15–30 Sekunden lange Reels.",
    Statistics_MonthView_down_action_2: "Gestalten Sie attraktive Cover.",
    Statistics_MonthView_down_action_3: "Führen Sie Timing-Tests durch.",
    Statistics_MonthView_down_urgency: "Hoch",

    Statistics_MonthView_zero_title: "Monatliche Aufrufe Null 💡Prüfen Sie zuerst technische Probleme",
    Statistics_MonthView_zero_summary:
      "Daten oder Veröffentlichung könnten Probleme haben; zuerst Technik prüfen, dann einen 14-Tage-Plan starten.",
    Statistics_MonthView_zero_action_1: "Video-Daten technisch prüfen.",
    Statistics_MonthView_zero_action_2: "14-Tage-Content-Plan umsetzen.",
    Statistics_MonthView_zero_action_3: "Ergebnisse täglich überwachen.",
    Statistics_MonthView_zero_urgency: "Hoch",
    Statistics_RePosts_up_title: "Reposts Nehmen Zu 💡 Nutzen Sie Es",
    Statistics_RePosts_up_summary:
      "Ihr Publikum teilt Ihre Posts – das zeigt, dass Ihr Content weitergegeben werden sollte.",
    Statistics_RePosts_up_action_1: "Fügen Sie der Caption einen klaren Repost-Grund hinzu („An einen Freund senden“).",
    Statistics_RePosts_up_action_2: "Entwerfen Sie eine gut teilbare Lernserie.",
    Statistics_RePosts_up_action_3: "Analysieren Sie Repost-Feedback und erkennen Sie Muster.",
    Statistics_RePosts_up_urgency: "Mittel",
    Statistics_RePosts_neutral_title: "Reposts Sind Niedrig oder Stabil 💡 Es Braucht Nur Einen Einfachen Impuls",
    Statistics_RePosts_neutral_summary: "Manchmal reicht ein kurzer CTA, um Reposts zu steigern.",
    Statistics_RePosts_neutral_action_1: "Fügen Sie am Ende des Post einen sehr kurzen Repost-CTA hinzu.",
    Statistics_RePosts_neutral_action_2: "Erstellen Sie mehr speicherbaren und teilbaren Content.",
    Statistics_RePosts_neutral_action_3: "Testen Sie ein Format wie „An einen Freund senden“.",
    Statistics_RePosts_neutral_urgency: "Niedrig",
    Statistics_RePosts_down_title: "Reposts Sind Rückläufig 💡 Sie Brauchen Nutzbringenderen Content",
    Statistics_RePosts_down_summary:
      "Der Content ist weniger teilbar geworden; Sie müssen etwas erstellen, das andere weiterleiten möchten.",
    Statistics_RePosts_down_action_1: "Erstellen Sie eine Checkliste oder schrittweisen Content.",
    Statistics_RePosts_down_action_2: "Veröffentlichen Sie kurze und kompakte Tutorials.",
    Statistics_RePosts_down_action_3: "Fügen Sie einen klaren Repost-CTA hinzu.",
    Statistics_RePosts_down_urgency: "Hoch",
    Statistics_RePosts_zero_title: "Keine Reposts Erfasst 💡 Sie Müssen Einen Startpunkt Schaffen",
    Statistics_RePosts_zero_summary:
      "Entweder fehlen Daten oder der Content ist nicht repostfähig; entwickeln Sie schnell einen Distributionsplan.",
    Statistics_RePosts_zero_action_1: "Erstellen Sie mehrere Inhalte mit 5 Punkten oder im Checklisten-Format.",
    Statistics_RePosts_zero_action_2: "Starten Sie einen kleinen Boost, um das erste Signal zu erhalten.",
    Statistics_RePosts_zero_action_3: "Schreiben Sie eine klare Repost-Begründung in die Caption.",
    Statistics_RePosts_zero_urgency: "Hoch",

    // statistics suggestions box

    pageTools_hashtags: "Hashtags",
    pageTools_MyList: "Hashtags-Liste",
    pageTools_CreateNewListexplain: "Erstellen Sie Ihre # Liste und verwenden Sie sie für die Erstellung von Posts",
    Analyzer: "Analysator (AI)",
    pageTools_CreateNewList: "Neue Liste Erstellen",
    pageTools_CustomFont: "Benutzerdefinierte Schriftart",
    pageTools_CustomFontExplain: "Verwenden Sie benutzerdefinierte Schriftarten für Ihre Instagram-Beiträge!",
    pageToolspopup_CreateNewListexplain:
      "Drücken Sie <Enter> oder <Space>, um einen neuen Hashtag zu erstellen. Klicken Sie auf einen Hashtag, um ihn zu löschen.",
    pageToolspopup_Listname: "Listenname",
    pageToolspopup_hashtags: "Hashtags",
    pageToolspopup_typehere: "Hier eingeben",
    pageTools_hashtagList: "Hashtag-Liste",
    pageTools_CreateNewListpic: "Neuer Bildanalysator",
    pageTools_CreateNewListpicexplain: "Hashtags für das Bild generieren",
    pageTools_CreateNewListpage: "Neuer Seitenanalysator",
    pageTools_CreateNewListpageexplain: "Hashtags für die Instagram-Seiten-URL generieren",
    pageToolspopup_pageURL: "Instagram-ID",
    pageToolspopup_HideLikeandViewCounts: "Likes & Aufrufzahlen verbergen",
    pageToolspopup_TurnoffCommenting: "Kommentare deaktivieren",
    pageToolspopup_TurnoffCommentingExplain: "Das Kommentieren für diesen Post wird deaktiviert",
    pageToolspopup_TurnoffCommentingexplainforlottery:
      "Das Kommentieren für diesen Post wird während der Lottery deaktiviert",

    pageToolspopup_TopHashtag: "Top-Hashtag",
    pageToolspopup_TopHashtagexplain: "Dies ist, wie oft Sie diesen Hashtag auf der Seite verwendet haben.",
    pageToolspopup_allRepliedcomments: "Alle beantworteten Kommentare",
    noresult: "Kein Ergebnis",
    viewreplies: "Antworten anzeigen",
    allRepliedcomments: "Alle beantworteten Kommentare",
    Followers: "Follower",
    NonFollowers: "Nicht-Follower",
    pageToolspopup_ViewersLikes: "Zuschauer und Likes",
    supportedformat: "Unterstütztes Format",
    limitsize: "Größenlimit",
    TagMention: "Tag & Erwähnung",
    cover: "Cover",
    Pleaseselect: "Bitte wählen Sie",
    replace: "Ersetzen",
    Album: "Album",
    SavedHashtagList: "Gespeicherte Hashtag-Liste",
    SavedHashtagListexplain: "Wählen Sie einen Hashtag aus, um ihn am Ende der Bildunterschrift hinzuzufügen",
    FirstComment: "Erster Kommentar",
    PinFirstComment: "Ersten Kommentar anheften",
    areyousure: "Sind Sie sicher !?",
    shouldFollower: "Der Benutzer muss der Seite folgen",
    draftexplain: "Sie versuchen, als Entwurf zu speichern",
    deletedraftexplain: "Sie versuchen, den Entwurf zu löschen",
    deleteorderexplain: "Sie versuchen, eine Bestellung zu löschen",

    Addpeopleexplain: "*Nach dem Markieren von Personen, Markierung anpassen oder Doppelklicken zum Entfernen",
    AdvanceSettings: "Erweiterte Einstellungen",
    sharepreviewtofeed: "Vorschau im Feed teilen",
    Videocopyrightbypass: "Video-Copyright-Umgehung",
    SetScheduledPost: "Beitrag Planen",
    SetScheduledPostexplain: "Dieser Beitrag wird zur angegebenen Zeit veröffentlicht",
    SetScheduledStoryexplain: "Diese Geschichte wird zur angegebenen Zeit veröffentlicht",
    addtoproduct: "Zu Produkten Hinzufügen",
    addtoproductexplain: "Dieser Beitrag wird als Produkt zu Ihrer Produktliste hinzugefügt",
    TurnoffCommentingexplain: "Das Kommentieren für diesen Beitrag wird deaktiviert",
    RecommendedDateTime: "Empfohlenes Datum und Uhrzeit",
    RecommendedDateTimeexplain: "Diese Zeiten basieren auf der Analyse Ihrer Seite",
    publish: "Veröffentlichen",
    pageTools_global: "Global",
    pageTools_FA_AR: "Farsi / Arabisch",
    pageTools_Overall: "Gesamt",
    pageTools_year: "Jahr",
    pageTools_Month: "Monat",
    pageTools_Week: "Woche",
    pageTools_Day: "Tag",
    pageTools_hashtag: "Hashtag",
    pageTools_USED: "Verwendet",
    pageTools_SearchedHashtag: "Gesuchter Hashtag",
    pageTools_TrendHashtags: "Trend-Hashtags",
    pageTools_AutoInterAction: "Auto Interaktion mit Followern",
    pageTools_AcceptPendingRequests: "Folgeanfragen Automatisch Akzeptieren",
    pageTools_LikeAllNewComments: "Neue Kommentare Liken",
    pageTools_LikeNewFollowersPosts: "Neueste Beiträge neuer Follower Liken",
    pageTools_RemoveAllFollowings: "Alle Folgenden Entfernen",
    pageTools_WinnerPicker: "Lotterie (Gewinnerauswahl)",
    pageTools_DayEvents: "Tagesereignisse",
    pageTools_EventDateRange: "Datumsbereich",
    pageTools_EventLanguage: "Sprache",
    pageTools_EventSelectDate: "Datumsbereich Auswählen",
    pageTools_EventSearch: "Ereignisse Suchen",
    pageTools_EventEmpty: "Keine Ereignisse für den ausgewählten Bereich gefunden",
    pageTools_EventReligious: "Religiös",
    pageTools_EventIdeas: "Ereignisideen",
    pageTools_IdeaCreate: "Ereignisideen Generieren",
    pageTools_IdeaExplain:
      "Erhalten Sie KI-gestützte Content-Ideen basierend auf bevorstehenden Ereignissen und Anlässen",
    pageTools_CreateEventIdea: "Ereignisideen Generieren",
    pageTools_CreateEventIdeaPrompt: "Thema / Eingabe",
    pageTools_CreateEventIdeaPromptPlaceholder: "z.B. Schuhe, Fitness, Reisen... (leer lassen für alle Themen)",
    pageTools_CreateEventIdeaOptional: "optional",
    pageTools_CreateEventIdeaSubmit: "Generieren",
    pageTools_CreateEventIdeaCancel: "Abbrechen",
    pageTools_EventIdeasLanguage: "Sprache",
    pageTools_EventIdeasFetch: "Ideen Laden",
    pageTools_EventIdeasEmpty: "Keine Ereignisideen gefunden",
    pageTools_EventIdeasLoadMore: "Mehr",
    pageTools_EventIdeasIdea: "Idee",
    pageTools_EventIdeasCountry: "Land",
    pageTools_EventIdeasPrompt: "Thema",
    pageTools_EventIdeasCreatedTime: "Erstellt Am",
    pageTools_CustomEvent: "Benutzerdefiniertes Ereignis",
    pageTools_exportcomments:
      "Alle Kommentare werden als Excel-Datei exportiert und können heruntergeladen und geteilt werden",

    pageTools_Lottery: "Punkte-Lotterie Erstellen",
    pageTools_emptylotteryList: "Du hast noch keine Lotterie erstellt",

    pageTools_LotteryExplain: "Basierend auf den Benutzerpunkten in einem Beitrag",
    pageTools_fromFollowers: "Von Followern",
    pageTools_FromFollowersExplain: "Zufällig aus allen Followern",
    pageTools_Result: "Ergebnis",
    pageTools_ResultExplain: "Status der vorherigen Lotterie",
    pageTools_popup_detail: "Details",
    pageTools_popup_history: "Verlauf",
    pageTools_LikeAllNewCommentsExplain:
      "Wenn einer Ihrer Follower einen Kommentar zu einem Beitrag hinterlässt, wird dieser automatisch geliket.",
    pageTools_AcceptType: "Aktivierungstyp",
    pageTools_popup_AlwaysActive: "Immer Aktiv",
    pageTools_popup_JustOnce: "Nur Einmal",
    pageTools_AcceptPendingRequestsexplain: "Automatisch alle Follow-Anfragen von Personen akzeptieren.",
    pageTools_onlyprivate: "*Funktioniert nur mit privaten Seiten.",
    pageTools_MaxLike: "Anzahl der Posts, die geliked werden",
    pageTools_Reacceptfollower: "Erneutes Folgen nach Entfolgen",
    pageTools_Reacceptfollowerexplain:
      "Wenn jemand zuvor gefolgt ist, dann entfolgt und erneut eine Follow-Anfrage stellt, wird das System dies akzeptieren.",
    waitday: "Wartezeit",
    waitdayexplain:
      "Wenn eine Person von Ihnen oder dem System gefolgt wird, wird sie nach der angegebenen Wartezeit entfernt.",
    waitdayexplain2: "Die Wartezahl ist in Tagen. Wenn diese Zahl 0 ist, wird die Aktion sofort ausgeführt.",
    pageTools_LikeNewFollowersPostsexplain:
      "Wenn jemand Neues dir folgt, wird sein neuester Beitrag automatisch geliket.",
    pageTools_RemoveAllFollowingsexplain: "Diese Option entfernt automatisch alle deine Followings von der Seite.",
    pageTools_progress: "Dieser Prozess kann je nach Anzahl deiner Follower mehrere Tage dauern.",
    pageTools_JustUnfollowwho: "Nur von denen entfolgen, die mir nicht zurückgefolgt sind",
    pageTools_AllmyFollowings: "Alle meine Followings",
    pageTools_pageanAnalyzer: "Seitenanalysator",
    pageTools_pictureanAnalyzer: "Bildanalysator",
    pageTools_StartAnalysis: "Analyse starten",
    pageLottery_Step: "Schritt",
    pageLottery_Specifications: "Spezifikationen",
    pageLottery_SelectaPost: "Wähle einen Beitrag aus",
    pageLottery_SetDateTime: "Datum und Uhrzeit einstellen",
    pageLottery_WinnersTasks: "Aufgaben der Gewinner",
    pageLottery_WinnersTasksexplain:
      "Die Aufgaben, die jeder Teilnehmer erfüllen muss, um an der Lotterie teilzunehmen.",
    pageLottery_NumberofWinners: "Anzahl der Gewinner",
    pageLottery_SetScoreForLottery: "Personen Erwähnen",
    pageLottery_SetScoreForLotteryexplain: "Benutzer müssen andere erwähnen, um an der Lotterie teilzunehmen",

    pageLottery_MinimumMention: "Minimale Erwähnung",
    pageLottery_MinimumMentionexplain: "Die Anzahl der Personen, die erwähnt werden müssen",
    pageLottery_FollowedPage: "Gefolgte Seite",
    pageLottery_FollowedPageexplain:
      "Menschen müssen Ihrer Seite und/oder den von Ihnen ausgewählten Seiten folgen, um an der Verlosung teilzunehmen",
    pageLottery_FollowmyPage: "Folge meiner Seite",
    pageLottery_FollowalternativePages: "Folge alternativen Seiten",
    pageLottery_Termsconditions: "Geschäftsbedingungen",
    pageLottery_publishTermsconditions: "Geschäftsbedingungen veröffentlichen",
    pageLottery_previewTermsconditionsexplain: "Diese Story wird den Teilnehmern als Story angezeigt.",
    pageLottery_Termsconditionsbanner: "Banner für Geschäftsbedingungen",
    pageLottery_Termsconditionsbannerexplain:
      "Wählen Sie ein Banner aus, um die Bedingungen für die Gewinnerauswahl Ihren Followern mitzuteilen.",
    pageLottery_model: "Modell",
    pageLottery_Solid: "Voll",
    pageLottery_Radial: "Radial",
    pageLottery_Linear: "Linear",
    pageLottery_Background: "Hintergrund",
    pageLottery_Color: "Farbe",
    pageLottery_Position: "Position",
    pageLottery_Degree: "Grad",
    pageLottery_TextBox: "Textfeld",
    pageLottery_Opacity: "Deckkraft",
    pageLottery_Blur: "Unschärfe",
    pageLottery_Font: "Schriftart",
    pageLottery_Winnerannouncement: "Gewinnerbekanntgabe",
    pageLottery_participants1: "🎉 von 999,999 Teilnehmern 🎉",
    pageLottery_participants2: "🥳 hier sind die Glücklichen: 🥳",
    pageLottery_participantsexplain:
      "*Das System passt automatisch die Anzahl der Teilnehmer und Gewinner an und weist deren IDs nach jedem @ Zeichen zu.",
    pageLottery_Addtocaption: "Nach der Beendigung der Lotterie zur Bildunterschrift hinzufügen",
    pageLottery_Publishasstory: "Veröffentlichen Sie die Gewinnerliste als Story",
    pageLottery_deleteexplain: "Das wird die Lotterie dauerhaft löschen, und es kann nicht rückgängig gemacht werden.",
    pageLottery_Winnerpickersstatus: "Lottery-Status",
    pageLottery_scoreLotteryWinners: "Gewinner der Lotterie",
    pageLottery_NoWinners: "Keine Gewinner gefunden",
    pageLottery_RandomFollowersWinners: "Zufällige Follower-Gewinner",
    pageLottery_specifickeywordexplain:
      "Benutzer müssen ein bestimmtes Schlüsselwort in ihrem Kommentar schreiben, um an der Lottery teilzunehmen",
    pageLottery_FollowmyPageexplain: "Benutzer müssen die Seite Follow haben, um an der Lottery teilzunehmen",

    pageLottery_ShareRemainingTime: "Verbleibende Zeit teilen",
    ShareTermsAndCondition: "Nutzungsbedingungen teilen",
    pageLottery_LotteryRemainingTime: "Verbleibende Zeit der Lottery",
    pageLottery_Winnerpickerisrunning: "Lottery läuft",
    pageLottery_ViewandEditDetails: "Details ansehen & bearbeiten",
    pageLottery_ActiveWinnerpickers: "Aktive Lottery",
    pageTools_WinnerPickertooltip24hour: "Die Verlosung kann alle 24 Stunden einmal durchgeführt werden",
    specifickeywordstooltip: "Das System erkennt automatisch Emojis sowie persische, arabische und englische Zahlen",
    pageLottery_FilterKeywords:
      "Das System wählt zufällig Kommentare aus, die Ihr gewünschtes Schlüsselwort enthalten, und zeigt sie an",
    pageLottery_NumberofWinnersexplain:
      "Legen Sie die Anzahl der Gewinner der Verlosung fest. Die maximale Anzahl beträgt 100",
    pageLottery_permanentlinktooltip:
      "Dieser Link ist dauerhaft, wird jedoch gelöscht, wenn eine neue Verlosung durchgeführt wird",
    pageLottery_permanentlinkexplain:
      "Sie können diesen Link mit den Nutzern teilen, um die Echtheit und Fairness der Verlosung zu überprüfen",
    pageTools_randomly: "Zufällig",
    pageTools_BestEngagement: "Bestes Engagement",
    pageTools_BestEngagementexplain: "Wählen Sie aus den Followern aus, die die meisten Likes und Kommentare hatten",
    // #endregion page Section
    // #region 3️⃣ Message Section
    message_youareattemptingto: "Sie versuchen zu",
    message_blockexplain:
      "Sie werden Ihr Profil, Ihre Beiträge oder Storys auf Instagram nicht finden können. Instagram wird ihnen nicht mitteilen, dass Sie sie blockiert haben.",
    message_deleteexplain: "Es wird den Chat dauerhaft löschen, und dies kann nicht rückgängig gemacht werden.",
    message_block: "Blockieren",
    notactivemessage:
      "Dieser Chat wurde vorübergehend deaktiviert. Bitte senden Sie Ihre Antwort über die Instagram-App.",
    notactivemessageexplain:
      "Bitte beachten Sie, dass der Chat nach 24 Stunden ohne Antwort nicht mehr zugänglich ist. Um ihn wieder zu aktivieren, können Sie entweder über die Instagram-App antworten oder warten, bis die andere Person Ihnen eine neue Nachricht sendet.",
    waitingforconnection: "Warten auf Verbindung...",
    message_unblock: "Entblocken",
    messagesetting_goodbye: "Auf Wiedersehen",
    messagesetting_welcome: "Willkommen",
    messagesetting_welcomingmessage: "Begrüßungsnachricht",
    messagesetting_Activewelcomemessageexplain:
      "Diese Nachricht wird als <Begrüßungsnachricht> über Instagram Direct an Personen gesendet, die dir folgen.",
    messagesetting_Sentmessages: "Gesendete Nachricht",
    message: "Nachricht",
    messagesetting_Activewelcomingmessage: "Begrüßungsnachricht",
    receivedmessage: "Die empfangene Nachricht",
    Messageresponse: "Antwort auf Nachricht",
    receivedcomment: "Erhaltener Kommentar",
    commentresponse: "Kommentarantwort",
    Likethereceivedcomment: "Erhaltenen Kommentar liken",
    unreadmessage: "Ungelesene Nachricht",
    specifickeywords: "Spezifische Schlüsselwörter",
    unreadcomment: "Ungelesene Kommentare",
    hiddencommenttooltip:
      "Dieser Kommentar wurde ausgeblendet. Nur Administratoren können ausgeblendete Kommentare sehen.",
    vanishmode: "Verborgener Modus",
    vanishmodeexplain:
      "Im verborgenen Modus werden Nachrichten, die unbeantwortet geblieben und weder ignoriert noch ausgeblendet wurden, angezeigt.",
    totalcomments: "Gesamtanzahl Kommentare",
    unansweredcomments: "Unbeantwortete Kommentare",
    totalcommenters: "Gesamtanzahl Kommentatoren",
    commentmanagement: "Willkommen im Kommentar-Management",
    ticketmanagement: "Willkommen im Kunden-Ticket-Management-Bereich",
    flowmanagement: "Erstellen Sie einen Flow und machen Sie Ihre Instagram-Antworten smart und automatisch",

    Sendresponseifthepageisfollowed: "Antwort senden, wenn die Seite gefolgt wird",
    Likethereceivedmessage: "Erhaltene Nachricht liken",
    QuickReplyexplain: "Alle erhaltenen Kommentare werden automatisch beantwortet.",
    autocommentReply: "Automatische Kommentarantwort",
    messagesetting_welcometext:
      "Hallo! 🌟\nWillkommen in unserer Welt! 🎉 Wir freuen uns sehr, dass du Teil unserer Community geworden bist. Wir sind uns sicher, dass wir gemeinsam wunderbare Momente erleben werden. 🤗\n\nWir hoffen, dass dir der Inhalt dieser Seite gefallen und nützlich sein wird, und dass du uns treu bleibst. Solltest du Fragen oder Anregungen haben, stehen wir dir gerne zur Verfügung. 😊\n\nVielen Dank, dass du unsere Seite gewählt hast und mit uns bist. Wir können es kaum erwarten, dich in unserer wunderbaren Welt willkommen zu heißen.✨\n\nMit Respekt und Wertschätzung 💫",
    messagesetting_goodbyetext:
      "Hallo! 👋\nEs tut uns leid, dass du unsere Seite verlassen hast. 😢 Wir schätzen jeden einzelnen unserer Follower, und dein Feedback und deine Vorschläge sind uns sehr wichtig.\n\nWenn es einen bestimmten Grund für diese Entscheidung gab, würden wir uns freuen, wenn du uns diesen mitteilen würdest. Wir sind bereit, dir zuzuhören und deine Vorschläge anzunehmen, um das Erlebnis für unsere Follower zu verbessern. 🫡\n\nIn jedem Fall wünschen wir dir alles Gute und hoffen, dass du in Zukunft wieder zu uns zurückkehren wirst. 💫",
    messagesetting_ActiveFarewellmessage: "Abschiedsnachricht",
    messagesetting_ActiveFarewellmessageexplain:
      "Diese Nachricht wird in Instagram Direct als <Abschiedsnachricht> an Personen gesendet, die dir nicht mehr folgen.",
    messagesetting_businessmessagefilter: "Filter für Geschäfts-Nachrichten",
    messagesetting_businessmessagefiltering: "Filtern von Geschäfts-Nachrichten",
    messagesetting_businessmessagefilteringexplain:
      "Der gewünschte Chat wird automatisch in den Abschnitt <Geschäftsnachrichten> im Direct-Tab gesendet.",
    messagesetting_specificwords: "benutzerdefinierte Wörter",
    messagesetting_autofiltering: "automatische Filterung (KI)",
    messagesetting_selectedwords: "Ausgewählte Elemente",
    autocommentReplyExplain: "Wenn ein Kommentar oder eine Nachricht empfangen wird, antwortet das System automatisch.",
    selectnewmessage: "Um eine Antwort zu senden, wählen Sie bitte eine Nachricht aus.",
    sendreplyticket: "Antworten Senden",
    emptyticketdirect: "Keine Tickets über Direct-Nachrichten Ihrer Seite erhalten",
    emptysystemticket: "Keine Tickets von Kunden des Brancy-Systems erhalten",
    emptycomment: "Noch keine Kommentare zum Anzeigen vorhanden",
    emptydirect: "Noch keine Direct-Nachrichten zum Anzeigen vorhanden",

    respondToAllComments: "Auf Alle Kommentare Antworten",
    sensitiveToSpecificKeywords: "Empfindlich auf Bestimmte Schlüsselwörter",
    sensitiveToSpecificKeywordsExplain:
      "Wenn diese Schlüsselwörter irgendwo im Kommentartext vorkommen, antwortet das System automatisch",
    contain: "Schlüsselwort enthalten",
    containExplain:
      "Wenn aktiviert, wird geantwortet, sobald das Schlüsselwort im Kommentar vorkommt. Wenn deaktiviert, wird nur geantwortet, wenn der gesamte Kommentar genau dem Schlüsselwort entspricht.",
    replyMethod: "Antwortmethode",
    respondInSameComment: "Im Selben Kommentar Antworten",
    respondDirectly: "Direkt Antworten",
    ticketID: "Ticket-ID",
    noNewAnsweredTickets: "Sie haben keine neu beantworteten Tickets",
    noNewPendingTickets: "Sie haben keine neuen Tickets in Bearbeitung",
    noNewClosedTickets: "Sie haben keine geschlossenen Tickets",

    Ticketclosedby: "Ticket geschlossen von",
    waitingforuserresponse: "Warten auf Benutzerantwort",
    inactiveticketexpired: "Dieses Ticket wurde aufgrund von Inaktivität in den letzten 24 Stunden deaktiviert.",
    messagesetting_specificwordsexplain:
      "Sie können mehrere Wörter eingeben, trennen Sie jedes Wort mit der <Enter>-Taste.",
    messagesetting_Createanewsupportticket: "Ein Support-Ticket Erstellen",
    messagesetting_CreateanewsupportticketExplain:
      "Benutzer können diese Option verwenden, um ein Support-Ticket in ihrem Direct zu erstellen. Sie können auch über das Brancy-Panel oder direkt in Direct darauf antworten.",
    messagesetting_Changeapplicationlanguage: "Sprache der Direct-Optionen Ändern",
    messagesetting_ChangeapplicationlanguageExplain:
      "Durch Aktivieren dieser Option können Benutzer alle Funktionen von Direct in sieben Sprachen (Englisch, Persisch, Arabisch, Französisch, Russisch, Türkisch und Deutsch) anzeigen. Das System wird die erforderlichen Übersetzungen intelligent durchführen.",
    messagesetting_ViewStoreandproducts: "Shop und Produkte Anzeigen",
    messagesetting_ViewStoreandproductsExplain:
      "Mit dieser Option können Benutzer Ihren Produktkatalog in Listen- oder Albumformat mit Details wie Verfügbarkeit, Preis und weiteren Spezifikationen anzeigen.",
    messagesetting_Visityourwebsite: "Webseite Anzeigen",
    messagesetting_VisityourwebsiteExplain:
      "Benutzer können über diese Option die Adresse und eine kurze Zusammenfassung Ihrer Webseite anzeigen und bei Bedarf direkt darauf zugreifen. (Die Ladegeschwindigkeit der Seite wird sehr hoch sein.)",
    messagesetting_Viewuserrolesandpermissions: "Geschäftsregeln und Vorschriften",
    messagesetting_ViewuserrolesandpermissionsExplain:
      "Durch Aktivieren dieser Option können Benutzer die von Ihnen in den Brancy-Einstellungen festgelegten Regeln, Vorschriften und Einschränkungen Ihres Unternehmens anzeigen.",
    messagesetting_Viewbusinesshourschart: "Geschäftszeiten Anzeigen",
    messagesetting_ViewbusinesshourschartExplain:
      "Benutzer können diese Option nutzen, um Ihre Geschäftszeiten zu sehen. Diese Funktion hilft dabei, Nachrichten außerhalb der Arbeitszeiten zu reduzieren.",
    messagesetting_Viewpricinginformation: "Preise für Werbedienstleistungen",
    messagesetting_ViewpricinginformationExplain:
      "Durch Aktivieren dieser Option können Benutzer die aktuellen Preise für jede Ihrer Werbedienstleistungen sehen. Diese Funktion hilft, wiederholte Anfragen zu reduzieren.",
    messagesetting_Searchforproducts: "Produkte Suchen",
    messagesetting_SearchforproductsExplain:
      "Benutzer können den Produktnamen, die Post-Nummer oder einen Teil der Bildunterschrift senden, um vollständige Produktinformationen zu erhalten und bei Interesse direkt einen Kauf abzuschließen. Diese Funktion wirkt sich positiv auf das Umsatzwachstum aus.",
    messagesetting_addautomaticreplysystemsystem: "Eine einheitliche Systemantwort für alle Bereiche der Seite",
    messagesetting_HideRobotReply: "Automatische Nachrichten und Bot-Nachrichten ausblenden",
    messagesetting_HideRobotReplyExplain:
      "Automatische Bot-Nachrichten werden ausgeblendet und im Direct werden nur echte Nachrichten angezeigt",
    messagesetting_LikeRobotReply: "Story-Kommentare automatisch liken",
    messagesetting_HideRobotReplytooltip:
      "Nachrichten werden nicht gelöscht, sondern nur ausgeblendet, um die Direct-Verwaltung zu vereinfachen",
    messagesetting_LikeRobotReplyExplain:
      "Story-Kommentare werden automatisch gelikt, um die Interaktion schneller zu erhöhen",
    messagesetting_automaticreplysystem: "Automatische Antworten verwalten",
    messagesetting_automaticreplysystemforallpost:
      "Automatische Kommentarantworten für alle Post aktivieren oder deaktivieren",
    messagesetting_automaticreplysystemforallposttooltip:
      "Wenn Sie automatische Kommentarantworten für verschiedene Post eingerichtet haben, können Sie diese mit dieser Option alle gleichzeitig aktivieren oder deaktivieren. Um Antworten anzupassen, müssen Sie die Seite jedes Post einzeln öffnen",

    messagesetting_messagePanellanguage: "Standard-Direktsprache",
    messagesetting_messagePanellanguageExplain:
      "Die Standardsprache des Direct-Bots für die Beantwortung von Nachrichten.",
    messagesetting_AutoReplyPerFollow: "Individuelle Follow-up-Vorlage",
    messagesetting_AutoReplyPerFollowExplain:
      "Verwenden Sie diese Vorlage, wenn Sie einen Benutzer auffordern, der Seite zu folgen.",
    messagesetting_AutoReplyPerFollowtooltip:
      "Benutzer, die Ihnen noch nicht follow, erhalten zunächst eine Follow-Aufforderung. Nach dem Follow wird die automatische Nachricht gesendet",
    messagesetting_AutoReplyPerFollowtitle: "Nachrichtentext",
    messagesetting_AutoReplyPerFollowtitlesample:
      "Beispiel: Follow Sie zuerst unserer Seite, um die Nachricht zu erhalten",
    messagesetting_AutoReplyPerFollowbtn: "Button-Text",
    messagesetting_AutoReplyPerFollowbtnsample: "Beispiel: Ich habe Follow, Nachricht senden",
    messagesetting_automaticreplysystemexplain:
      "Das System antwortet automatisch mit einer voreingestellten Nachricht, wenn eine Nachricht oder ein Kommentar in einem beliebigen Bereich der Seite (Feed, Story, Reels, Live usw.) empfangen wird.",

    messagesetting_KeywordSensitive: "Wortempfindlich",
    messagesetting_KeywordsSensitive: "Wörterempfindlich",
    sendreplydirectedsuccessfully: "Bestätigungsnachricht im Comment nach dem Direct gesendet",

    autoReplyFor: "Automatische Antwort in",
    automaticreply: "Automatische Antwort",
    autodirectexplain:
      "Wenn ein bestimmtes Schlüsselwort in der Direktnachricht empfangen wird, wird Ihre vordefinierte Antwort automatisch in der Direktnachricht gesendet",
    adddirectexplain: "automatische Antworten in der Direktnachricht hinzufügen",
    autocommentexplain:
      "Wenn ein bestimmtes Schlüsselwort in einem Kommentar empfangen wird, wird Ihre vordefinierte Antwort automatisch im selben Kommentar gesendet",
    addcommentexplain: "Fügen Sie  automatische Antworten hinzu",
    messagesetting_icebreaker: "Schnellstart-Schaltfläche für Chats",
    messagesetting_addNewButton: "Neue Schaltfläche hinzufügen",
    messagesetting_icebreakerexplain:
      "Wenn der Benutzer Direct zum ersten Mal betritt, werden vier Schaltflächen angezeigt, und durch die Auswahl einer davon wird die entsprechende Antwort gesendet.",
    messagesetting_addicebreakerexplain: "Fügen Sie bis zu 4 Schnellstart-Schaltflächen für Chats hinzu",
    messagesetting_PersistentMenu: "Permanentes Direktmenü",
    messagesetting_PersistentMenuexplain:
      "Ein stets verfügbares Menü, das die Interaktion der Kunden mit Ihrer Marke schnell, bequem und ohne Tippen ermöglicht.",
    messagesetting_addPersistentMenuexplain: "Fügen Sie bis zu 3 permanente Menüschaltflächen hinzu",
    Welcometodirectmessages: "Willkommen bei den Instagram-Direktnachrichten!",
    messagesetting_UseSystemButtonsExplain:
      "Verwenden Sie vorgefertigte Systembuttons, um Standardinformationen wie Shop anzeigen, Support-Ticket und Sprachwechsel bereitzustellen",
    messagesetting_UseAIPromptsExplain:
      "Nutzen Sie KI-Prompts, um intelligente und personalisierte Antworten im eigenen Ton und Stil an Benutzer zu senden",
    messagesetting_ButtonTitle: "Button-Titel",
    messagesetting_NoPromptsFound:
      "Keine Prompts gefunden. Sie werden zur Erstellungsseite weitergeleitet, um einen neuen Prompt zu erstellen.",
    messagesetting_CreateNewPrompt: "Neuen Prompt erstellen",
    messagesetting_SelectYourPrompt: "Prompt auswählen",
    messagesetting_DefineCustomResponseExplain:
      "Definieren Sie Ihren individuellen Antworttext, damit dieser automatisch an Benutzer gesendet wird",
    messagesetting_SelectPredefinedFlowExplain:
      "Wählen Sie einen vordefinierten Flow, um eine intelligente und automatische Konversation mit dem Benutzer zu starten",
    messagesetting_NoFlowsFound:
      "Keine Flows gefunden. Sie werden zur Erstellungsseite weitergeleitet, um einen neuen Flow zu erstellen.",
    messagesetting_CreateNewFlow: "Neuen Flow erstellen",
    messagesetting_SelectFlow: "Flow auswählen",
    messagesetting_ViewFlow: "Flow anzeigen",
    messagesetting_UseGeneralAIExplain:
      "Allgemeine KI für eine freie und uneingeschränkte Interaktion mit Benutzern verwenden",
    tool_token_usage_guide: "Geschätzter Token-Verbrauch bei der Ausführung dieses Tools",
    tool_how_use: "So verwenden Sie das Tool",
    tool_how_work: "So funktioniert das Tool",
    send_sms_ir_code_description: "SMS an Benutzer über die SMS.ir Plattform senden",
    send_sms_ir_code_completeDescription:
      "Dieses Tool dient zum Senden von SMS wie Bestätigungscodes, Registrierung oder Benachrichtigungen. Telefonnummern können genutzt werden.",
    send_sms_ir_code_howUse: `1- ApiKey von SMS.ir erhalten und eingeben.
2- SMS Template im TemplateId-Feld eintragen.
3- {CODE} wird automatisch durch OTP ersetzt.
`,
    send_sms_ir_code_howWork: `1- Nutzer sendet seine Telefonnummer im Direct.
2- SMS wird gesendet. {CODE} wird durch OTP ersetzt.
3- Nutzer sendet Code an die KI.
4- KI prüft den Code und bestätigt die Nummer.
`,

    send_to_telegram_description: "Nachricht über Bot an Telegram senden",
    send_to_telegram_completeDescription:
      "Dieses Tool sendet Nachrichten über einen Telegram Bot Token an einen Chat oder Kanal für Benachrichtigungen.",
    send_to_telegram_howUse: "1- Bot Token eingeben.\n2- Chat-ID oder Kanal-ID eingeben.\n3- Tool ausführen.",
    send_to_telegram_howWork:
      "1- Nutzer gibt Token und Channel ein.\n2- System erstellt Telegram API Anfrage.\n3- Nachricht wird gesendet.",

    sender_username_description: "Benutzernamen des Absenders im Prompt verwenden",
    sender_username_completeDescription:
      "Dieses Tool ersetzt {SENDER_USERNAME} automatisch durch den Benutzernamen des Absenders im AI Prompt.",
    sender_username_howUse: "1- {SENDER_USERNAME} im Prompt verwenden.\n2- Wird automatisch ersetzt.",
    sender_username_howWork:
      "1- Nutzer setzt {SENDER_USERNAME}.\n2- System ersetzt es durch Benutzername.\n3- AI erstellt Antwort.",
    // #endregion Message Section
    // #region 5️⃣market Section
    // 5️⃣ Market -> home
    filter_most_expensive: "Teuerste",
    filter_cheapest: "Günstigste",
    filter_newest: "Neueste",
    filter_highest_discount: "Höchster Rabatt",
    filter_all_products: "Alle Produkte",
    filter_only_available: "Nur Verfügbare Produkte",
    filter_reset: "Zurücksetzen",
    filter_sortby: "Sortieren nach",
    filter_category: "Kategorie",
    filter_price: "Preis",
    Pricerange: "Preisspanne",
    from: "Von",
    to: "Bis",
    filter_rating: "Bewertung",
    filter_followers: "Follower",
    default: "Standard",
    lowtohigh: "Niedrig bis Hoch",
    hightolow: "Hoch bis Niedrig",

    biolinkHomerating: "Bewerten",
    biolinkHomefollower: "Follower",
    biolinkHomepost: "Post",
    biolinkHomeAllMarkets: "Alle",
    biolinkHomeAdvertise: "Werbetreibender",
    biolinkHomeStore: "Geschäft",
    biolinkStatisticsAllLinkclicks: "Alle Link-Klicks",
    biolinkStatisticsMarketviews: "Marktansichten",
    biolinkStatisticsmostview: "meist gesehen",
    biolinkStatisticscouponcodeused: "Gutscheincode verwendet",
    biolinkStatisticslastupdate: "letztes Update",
    biolinkStatisticsAllsearches: "Alle Suchanfragen",
    biolinkStatisticsfeatures: "Funktionen",
    biolinkStatisticsVisits: "Besuche",
    biolinkStatisticsClicksAndInteractions: "Klicks und Interaktionen",
    biolinkStatisticsVisitsConverted: "In Klicks umgewandelte Besuche",
    biolinkStatisticsQuickUserExitAfterEntry: "Schneller Nutzerabgang nach dem Eintritt",
    biolinkStatisticsNoInteractionExit: "Abgang ohne Interaktion",
    biolinkStatisticsMaxClicksPerVisit: "Die meisten Klicks eines Nutzers in einem Besuch",
    biolinkStatisticsAvgClicksAndInteractionsPerVisitor: "Durchschnittliche Klicks und Interaktionen pro Besucher",
    biolinkStatisticsTotalVisitTime: "Gesamte Besuchszeit",
    biolinkStatisticsAvgVisitTime: "Durchschnittliche Verweildauer",
    biolinkStatisticsVideoPlatformsComparison: "Vergleich der Videoplattformen",
    biolinkStatisticsYoutube: "YouTube",
    biolinkStatisticsAparat: "Aparat",
    biolinkStatisticsTwitch: "Twitch",
    biolinkStatisticsPlatformEntry: "Plattformeintritt",
    biolinkStatisticsRedirectEvent: "Weiterleitungsereignis",
    biolinkStatisticsPlayVideo: "Videowiedergabe",
    biolinkStatisticsPlayEvent: "Wiedergabeereignis",
    biolinkStatisticsUniqueVisit: "Einzigartiger Besuch",
    biolinkStatisticsDedicatedLinkVisits: "Besuche des speziellen Links",
    biolinkStatisticsCombinedLinkVisits: "Kombiniertes Link-Besuchsdiagramm",
    // 5️⃣ Market -> Properties
    biolinkPropertiesfeatures: "Funktionen",
    biolinkPropertiesProfileInfoBanner: "Profilinfo & Banner",
    biolinkPropertiesFeaturebox: "Funktionsbox",
    biolinkPropertiesTermsAndActiveTime: "Bedingungen und Geschäftszeiten",
    biolinkPropertiesFeatureboxexplain:
      "Durch das Aktivieren jeder Funktion können Sie wichtige Informationen für Besucher Ihrer Link-Seite anzeigen",
    biolinkPropertiesBanner: "Banner",
    biolinkPropertiesFeaturesBox: "Funktionsbox",
    biolinkPropertiesReviews: "Bewertungen",
    biolinkPropertiesAnnouncements: "Ankündigungen",
    biolinkPropertiesAnnouncementsexplain:
      "Sie können in diesem Bereich eine Beschreibung schreiben, um Besucher Ihrer Link-Seite über wichtige Informationen zu informieren",

    biolinkPropertiesOnlineStream: "Online-Stream",
    biolinkPropertiesOnlineStreamexplain:
      "Wenn Sie diese Option aktivieren, wird jeder Livestream, den Sie auf Ihrem Kanal starten, automatisch auf Ihrem persönlichen Link angezeigt",

    biolinkPropertiesLastVideo: "Letztes Video",
    biolinkPropertiesLastVideoexplain:
      "Wenn Sie diese Option aktivieren, wird jedes Mal, wenn Sie ein neues Video auf Ihrem Kanal veröffentlichen, das neueste Video automatisch auf Ihrem persönlichen Link angezeigt und stets aktualisiert",

    biolinkPropertiesProducts: "Produkte",
    biolinkPropertiesProduct: "Produkt",
    biolinkProperties_showLast10Products: "Letzte 10 Produkte anzeigen",
    biolinkProperties_showBestSellingProducts: "Meistverkaufte Produkte anzeigen",
    biolinkPropertiesAdsTimeline: "Werbezeitachse",
    biolinkPropertiesQandABox: "Fragen- und Antwortbox",
    biolinkPropertiesLinkShortcut: "Link-Verknüpfung",
    biolinkPropertiesContactAndMap: "Kontakt und Karte",
    biolinkPropertieslinks: "Links",
    clickonstreamvideo: "Klicken Sie auf das Video, um den Livestream anzusehen",
    livestarted: "Live-Übertragung Läuft",
    live: "Live",
    biolinkPropertiesaddnew: "Neuen Link Hinzufügen",
    biolinkProperties_DomainManager: "Domainverwaltung",
    biolinkProperties_DomainManagerexplain: "Ihre eigene Website",
    biolinkProperties_DomainManagerexplain2:
      "Sie können diesen Link in Ihrer Instagram-Bio platzieren oder mit anderen Nutzern teilen",

    biolinkProperties_explain:
      "Wenn sich der Instagram-Benutzername ändert, wird dieser Link automatisch aktualisiert.",
    biolinkProperties_rejected: "Ihre Domain wurde abgelehnt (bitte kontaktieren Sie uns)",
    customDomain_inactive_title: "Benutzerdefinierte Domain ist inaktiv",
    customDomain_inactive_desc:
      "Ihre Domain ist derzeit inaktiv. Bitte senden Sie ein Support-Ticket, um sie zu aktivieren.",
    customDomain_noPackage_title: "Benutzerdefiniertes Domain-Paket nicht gefunden",
    customDomain_noPackage_desc:
      "Ihr aktuelles Paket beinhaltet keine Unterstützung für benutzerdefinierte Domains. Bitte upgraden Sie Ihr Paket, um diese Funktion zu nutzen.",
    customDomain_rule_validChars: "Nur Buchstaben und Zahlen sind erlaubt",
    customDomain_rule_noUnderscore: "Die Zeichen (_) und (-) sind nicht erlaubt",
    customDomain_rule_noSubdomain: "Subdomains sind nicht erlaubt",
    biolinkProperties_Request: "Anfrage",
    biolinkProperties_Requested: "Angefordert",
    biolinkProperties_Checking: "Überprüfung",
    biolinkProperties_yourstore: "Store (Ihr Store-Link)",
    biolinkProperties_yourads: "Werbungsbestellungslink",
    biolinkProperties_yourlottery: "Ihre abgeschlossenen Verlosungen",
    biolinkProperties_yourtariff: "Tarif (Ihre Preisliste)",
    biolinkProperties_yourBusinesshours: "Ihre Aktiven Geschäftszeiten",
    biolinkProperties_yourBusinessTerms: "Ihre Geschäftsbedingungen",
    biolinkProperties_defaultAddress: "Standard-Domain-Adresse",
    biolinkProperties_CustomAddress: "Ihre Benutzerdefinierte Domain-Adresse",
    biolinkPropertiespopup_GeneralCustom: "Allgemein",
    biolinkPropertiespopup_socialmedia: "Soziale Medien",
    biolinkPropertiespopup_mediastream: "Medien & Stream",
    biolinkPropertiespopup_clouddrivecontent: "Cloud-Inhalte",
    biolinkPropertiespopup_Finance: "Finanzen",
    biolinkProperties_followersrate: "Follower-Anzahl",
    biolinkProperties_followersrateExplain: "Zeigt die Anzahl der Follower Ihrer Instagram-Seite",
    biolinkProperties_successRating: "Erfolgsbewertung",
    biolinkProperties_successRatingExplain: "Zeigt Ihren Erfolgswert bei der Auftragsabwicklung",
    biolinkProperties_bussinessHours: "Aktive Geschäftszeiten",
    biolinkProperties_bussinessHoursExplain: "Zeigt Ihre Geschäftsarbeitszeiten",
    biolinkProperties_Enamadverified: "E-Namad-Verifizierung",
    biolinkProperties_EnamadverifiedExplain: "Zeigt den Verifizierungsstatus Ihres E-Namad-Vertrauensabzeichens",
    biolinkProperties_BusinessTerms: "Geschäftsbedingungen",
    biolinkProperties_BusinessTermsExplain: "Zeigt Ihre Geschäftsbedingungen",
    biolinkProperties_tariff: "Tarif",
    biolinkProperties_TariffExplain: "Zeigt Ihre Dienstleistungspreise",
    biolinkProperties_StartADS: "Werbeanfrage starten",
    biolinkProperties_StartADSExplain: "Benutzer können basierend auf Ihren Preisen Werbung starten",
    biolinkProperties_StartSALES: "Kauf starten",
    biolinkProperties_StartSALESExplain: "Benutzer können basierend auf Ihren Produkten einen Kauf starten",
    biolinkProperties_NameServers: "Domain-Nameserver",
    biolinkProperties_NameServersExplain:
      "Registrieren Sie die Nameserver im Verwaltungsbereich Ihres Domain-Anbieters",
    customDomain_dnsError:
      "Die Domain-Nameserver wurden bei Ihrem Domain-Anbieter noch nicht registriert. Bitte versuchen Sie es erneut",
    customDomain_active_desc:
      "Um diese Domain zu ändern oder zu entfernen, senden Sie Ihre Anfrage über den Bereich Support-Ticket in den Einstellungen",
    biolinkProperties_NameServerstooltip:
      "Es kann bis zu 12 Stunden dauern, bis Ihre Nameserver im Internet übernommen werden und Ihre Domain aktiv wird.",
    linkURL: "Link-URL",
    searchID: "Kanal hinzufügen",
    searchIDexplain: "Geben Sie die ID oder den Namen des gewünschten Kanals ein",

    Browse: "Durchsuchen",
    biolinkPropertiespopup_yourcustomIcon: "Ihr benutzerdefiniertes Symbol",
    Boldit: "Zieh Aufmerksamkeit auf dich!",

    Scheduletime: "Auto-Entfernungszeitplan",
    biolinkPropertiespopup_ProfileInfo: "Profilinformationen",
    biolinkPropertiespopup_Banner: "Banner",
    biolinkPropertiespopup_Personal: "Persönlich",
    biolinkPropertiespopup_SameasInstagramProfile: "Wie im Instagram-Profil",
    marketpropertise_aboutus: "Diese Website wurde über die Brancy-Plattform erstellt",
    marketpropertise_copyright: "Alle Rechte an dieser Website gehören",
    marketpropertise_aboutusslogan:
      "Brancy ist die beste Wahl, um einen intelligenten Biolink zu erstellen und deine Instagram-Seite zu verwalten",
    marketpropertise_madeby: "Erstellt mit 🤍 von",

    custom: "Benutzerdefiniert",
    advertiseProperties_biography: "Biografie",
    uploadbannerexplain: "Das Hochladen mehrerer Bilder kann die Ladegeschwindigkeit beeinträchtigen.",
    Embed: "Video einbetten",
    Embedexplain:
      "Wenn Sie diese Option aktivieren, wird das Video direkt auf Ihrem persönlichen Link angezeigt und abgespielt, sodass der Nutzer es ansehen kann, ohne die Seite zu verlassen oder zu einer anderen Plattform weitergeleitet zu werden",

    notfound: "nicht gefunden",
    showsavecontactbutton: "Kontakt speichern Taste anzeigen",
    Map: "Karte",
    Contact: "Kontakt",
    Showmap: "Karte anzeigen",
    location: "Standort",
    phone: "Telefon",
    invalidphone: "Ungültige Telefonnummer",
    email: "E-Mail",
    invalidemail: "Ungültige E-Mail",
    Address: "Adresse",
    // #endregion market Section
    // #region 6️⃣advertise Section
    advertise_ADDetail: "Anzeigedetails",
    content: "Inhalt",
    advertise_orderdate: "Bestelldatum",
    advertise_duration: "Dauer",
    Remaining: "Verbleibend",
    ago: "vor",
    // advertise -> calendar
    advertisecalendar_calendar: "Kalender",
    advertisecalendar_nextday: "Nächste Anzeigen für diesen Tag",
    advertisecalendar_TODAY: "Heute",
    advertisecalendar_BookaTime: "Eine Zeit buchen",
    advertisecalendar_TIMELINEZOOM: "Zeitachse vergrößern",
    advertisecalendar_Timeline: "Zeitachse",
    // advertise -> statistics
    advertisestatistics_lasttwomonth: "Letzte zwei Monate",
    advertisestatistics_lastmonth: "Letzter Monat",
    advertisestatistics_thismonth: "Diesen Monat",
    advertisestatistics_ads: "Anzeige",
    advertisestatistics_fromlast: "% Vom letzten Monat",
    advertisestatistics_totalADSstatistics: "Gesamtwerbe-Statistiken",
    advertisestatistics_TotalAds: "Gesamtanzeigen",
    advertisestatistics_TotalIncome: "Gesamteinkommen",
    advertisestatistics_totaladsreport: "Gesamtanzeigenbericht",
    advertisestatistics_adno: "Anzeige-Nr.",
    advertisestatistics_advertiser: "Werbetreibender",
    advertisestatistics_type: "Typ",
    advertisestatistics_status: "Status",
    advertisestatistics_price: "Preis",
    advertisestatistics_date: "Datum",
    advertisestatistics_share: "Teilen",
    // advertise -> adlist
    advertiseadlist_activeAd: "Veröffentlichte",
    advertiseadlist_AwaitingApproval: "Wartende",
    advertiseadlist_AwaitingPublication: "Geplante",
    advertiseadlist_rejectedlist: "Abgelehnte",
    // advertise -> Properties
    advertiseProperties_Concurrentads: "Gleichzeitige Anzeigen",
    advertiseProperties_Concurrentadsexplain: "Anzahl der aktiven Anzeigen zu einem bestimmten Zeitpunkt",
    advertiseProperties_numberofads: "Anzahl der Anzeigenseiten",
    advertiseProperties_numberofadsexplain: "Anzahl der aktiven Anzeigen im Laufe des Tages",
    advertiseProperties_campaign: "Kampagne",
    advertiseProperties_campaignexplain: "Nehmen Sie an Werbekampagnen teil.",
    advertiseProperties_adsoptions: "Anzeigenoptionen",
    advertiseProperties_rejectreasonheader1: "Grund 1 (Unzusammenhängender Inhalt)",
    advertiseProperties_rejectreasonheader2: "Grund 2 (Ungesunder Inhalt)",
    advertiseProperties_rejectreasonheader3: "Grund 3 (Verstoß gegen Richtlinien)",
    advertiseProperties_rejectreasonheader4: "Grund 4 (Negatives Feedback)",
    advertiseProperties_rejectreason1:
      "Leider stimmt der bereitgestellte Inhalt nicht mit den Werten und Zielen unserer Seite überein, ist für unser allgemeines Publikum irrelevant oder enthält keine wesentlichen Informationen. Daher können wir diese Anzeige nicht annehmen.",
    advertiseProperties_rejectreason2:
      "Leider kann der bereitgestellte Inhalt für unser Publikum ungesund oder irreführend sein oder komplexe Informationen enthalten. Es sind umfangreiche Änderungen erforderlich, daher können wir diese Anzeige nicht annehmen.",
    advertiseProperties_rejectreason3:
      "Leider entspricht der bereitgestellte Inhalt nicht unseren Vorschriften oder den Richtlinien von Instagram und könnte als unangemessen, beleidigend, kontrovers oder kriminell angesehen werden. Daher können wir diese Anzeige nicht annehmen.",
    advertiseProperties_rejectreason4:
      "Leider können wir aufgrund der hohen Anzahl ähnlicher Anzeigen, Terminüberschneidungen, negativer Benutzerbewertungen aus früheren Erfahrungen oder der niedrigen Qualität des bereitgestellten Inhalts diese Anzeige nicht annehmen.",
    advertiseProperties_AdvertisingTerms: "Werbebedingungen",
    advertiseProperties_AdvertisingTermsexplain:
      "Werbetreibende müssen diese Regeln akzeptieren, um auf Ihrer Seite zu werben.",
    advertiseProperties_AdvertisingTerm1: "Ihre Seite Bedingung 1",
    advertiseProperties_AdvertisingTerm2: "Ihre Seite Bedingung 2",
    advertiseProperties_AdvertisingTerm3: "Ihre Seite Bedingung 3",
    advertiseProperties_AdvertisingTerm4: "Ihre Seite Bedingung 4",
    advertiseProperties_AdvertisingTermsave: "Speichern",
    advertiseProperties_businesshours: "Aktive Geschäftszeiten des Admin",
    advertiseProperties_24hours: "24 Stunden aktiv",
    advertiseProperties_close: "24 Stunden inaktiv",
    advertiseProperties_notifications: "Benachrichtigungen",
    advertiseProperties_notificationsSMS: "SMS",
    advertiseProperties_notificationsEmail: "E-Mail",
    advertiseProperties_notificationssystem: "Systembenachrichtigung",
    advertiseProperties_notificationsinstagramdirect: "Instagram Direct",
    advertiseProperties_notificationssystemticket: "Ticket",
    advertiseProperties_advertisetariff: "Werbetarif",
    advertiseProperties_onlyToday: "Nur für Heute",
    advertiseProperties_onlyTodayexplain: "Werbepreistarif nur für heute",
    advertiseProperties_tariff12hours: "12 Stunden",
    advertiseProperties_tariff24hours: "24 Stunden",
    advertiseProperties_otherdays: "Grundlegend (Andere Tage)",
    advertiseProperties_otherdaysexplain: "Werbepreistarif für andere Tage",
    advertiseProperties_Campaign: "Kampagne",
    advertiseProperties_Campaignexplain: "Werbepreistarif für Kampagnen",
    advertiseProperties_lastModified: "Zuletzt Geändert",
    advertiseProperties_userreport: "Benutzerbericht",
    advertiseProperties_userID: "Benutzer-ID",
    advertiseProperties_reportexplain: "Ihr Bericht wird an den Brancy-Support gesendet.",
    advertiseProperties_reportsubmit: "Absenden",
    Apply: "Anwenden",
    signinyouradvertise: "Werbung Aktivieren",
    signinyouradvertiseExplain: "Aktivieren Sie Ihre Werbung mit nur wenigen Klicks",

    // #endregion advertise Section
    // #region 7️⃣Store Section
    // Store -> product
    Storeproduct_activatestore: "Aktivieren Sie Ihren Shop",
    signinyourstore: "Erstellen Sie Ihren Shop",
    signinyourstoreExplain: "Erstellen Sie Ihren Shop mit nur wenigen Klicks",
    Storeproduct_needyourID: "Identitätsbestätigung",
    Storeproduct_needyourIDExplain: "Laden Sie Ihren Ausweis hoch",
    Storeproduct_successyourID: "Ihre Identität wurde erfolgreich verifiziert",
    Storeproduct_NationalCardexplain:
      "Diese Karte muss der Person gehören, die sich mit ihrer Handynummer bei Brancy registriert hat.",
    Storeproduct_addcreditnumber: "Finanzinformationen",
    Storeproduct_addcreditnumberExplain: "Geben Sie Ihre Bankkarte ein",
    Storeproduct_successnumber: "Ihre Bankinformationen wurden erfolgreich verifiziert",
    Storeproduct_shippingmethod: "Versandart",
    Storeproduct_shippingmethodExplain: "Wählen Sie Ihre bevorzugte Versandart",
    Storeproduct_shippingmethodsuccess: "Die ausgewählte Versandart wurde erfolgreich registriert",
    Storeproduct_shippingmethodtooltip:
      "Empfohlene Methoden wurden basierend auf Ihrem Standort ausgewählt. Sie können später in den Store-Einstellungen bearbeitet und geändert werden.",
    Storeproduct_uploadimagefirst: "Bitte laden Sie zuerst das Foto Ihres Personalausweises hoch",
    Storeproduct_creditcardsameidcard: "Die Bankkartennummer muss dem Inhaber des Personalausweises gehören",
    Storeproduct_postalcode: "Geschäftsadresse",
    Storeproduct_postalcodeExplain: "Postleitzahl eingeben",
    Storeproduct_postalcodesuccess: "Adresse und Standort wurden erfolgreich registriert",
    Storeproduct_postalcodeinputExplain:
      "Die Versandkosten werden basierend auf dieser Adresse berechnet, bitte geben Sie die Postleitzahl genau ein.",
    Storeproduct_TermsAndCondition: "Allgemeine Geschäftsbedingungen",
    Storeproduct_TermsAndConditionExplain: "Bitte lesen und akzeptieren Sie die Bedingungen",
    Storeproduct_TermsAndConditionesuccess: "Die Annahme der Bedingungen wurde erfolgreich registriert",
    Storeproduct_AcceptTermsAndCondition:
      "Ich habe alle Regeln und Vorschriften zur Erstellung eines Shops auf Brancy gelesen und akzeptiere sie",
    Storeproduct_notyet: "Sie haben noch keine Produkte hinzugefügt!",
    Storeproduct_addnow: "PRODUKTE JETZT HINZUFÜGEN",
    Storeproduct_addexplain: "Sie werden automatisch von Ihrer Instagram-Seite hinzugefügt.",
    Storeproduct_productlist: "Produktliste",
    Storeproduct_search: "Suche 'Produktname' oder 'PID'",
    Storeproduct_importproduct: "Produkt Importieren",
    Storeproduct_importfrominsta: "Aus Ihrem Instagram Importieren",
    Storeproduct_newproduct: "Neues Produkt",
    Storeproduct_addnewproduct: "Neues Produkt Hinzufügen",
    Storeproduct_name: "Produktname",
    Storeproduct_weight: "Gewicht",
    Storeproduct_size: "Größe",
    Storeproduct_color: "Farbe",
    Storeproduct_stock: "Lager",
    Storeproduct_price: "Preis",
    Storeproduct_active: "Aktiv",
    Storeproduct_gram: "Gramm",
    bulkProduct: {
      title: "Ausgewählte Produkte verwalten",
      selectedCount: "{{count}} Produkte ausgewählt",
      priceChange: "Preis ändern",
      valueType: "Werttyp",
      amount: "Betrag",
      increase: "Erhöhen",
      decrease: "Verringern",
      applyAll: "Gleiche Änderung auf alle anwenden",
      applyIndividual: "Jedes Produkt einzeln einstellen",
      allProducts: "Auf alle {{count}} Produkte anwenden",
      discountAllHint: "Legen Sie einen prozentualen oder festen Rabatt für alle ausgewählten Produkte fest.",
      priceAllHint: "Erhöhen oder senken Sie alle Preise prozentual oder um einen festen Betrag.",
      currentDiscount: "Aktueller Rabatt",
      saving: "Speichern...",
    },
    loadingmoreproducts: "Lade mehr Produkte...",
    noMoreProducts: "Keine weiteren Produkte gefunden",
    storestatistics_lasttwomonth: "Letzte Zwei Monate",
    storestatistics_lastmonth: "Letzter Monat",
    storestatistics_thismonth: "Dieser Monat",
    storestatistics_sales: "Verkäufe",
    storestatistics_fromlast: "% zum letzten Monat",
    storestatistics_totalSalesstatistics: "Gesamtverkaufsstatistik",
    storestatistics_TotalSales: "Gesamtverkäufe",
    storestatistics_TotalIncome: "Gesamteinnahmen",
    storestatistics_totalsalesreport: "Top-Käufer",
    storestatistics_buyer: "Käuferinformationen",
    storestatistics_totalPurchases: "Gesamtanzahl der Käufe",
    storestatistics_totalAmount: "Gesamtkaufbetrag",
    storestatistics_lastPurchase: "Letzter Kaufzeitpunkt",
    storestatistics_saleno: "Verkaufsnummer",
    storestatistics_seller: "Verkäufer",
    storestatistics_type: "Typ",
    storestatistics_status: "Status",
    storestatistics_price: "Preis",
    storestatistics_date: "Datum",
    storestatistics_share: "Teilen",
    storestatistics_couponTitle: "Rabatte",
    storestatistics_addCoupon: "Rabattcode hinzufügen",
    storestatistics_noCoupons: "Es wurden noch keine Rabattcodes erstellt.",
    storestatistics_couponCode: "Rabattcode",
    storestatistics_discountPercent: "Rabatt in Prozent",
    storestatistics_maxUses: "Maximale Verwendungen",
    storestatistics_phoneNumber: "Telefonnummer",
    storestatistics_maxDiscountOptional: "Maximaler Rabatt (optional)",
    storestatistics_couponExpiry: "Ablaufzeit (muss mindestens 1 Stunde ab jetzt betragen)",
    storestatistics_showInBio: "In der Bio anzeigen",
    storestatistics_couponDeleted: "Gelöscht",
    storestatistics_couponExpired: "Abgelaufen",
    storestatistics_couponExhausted: "Aufgebraucht",
    storestatistics_couponActive: "Aktiv",
    storestatistics_unlimited: "Unbegrenzt",
    storestatistics_couponUsage: "{{used}} von {{max}} verwendet",
    storestatistics_discountValue: "{{discount}} % Rabatt",
    storestatistics_maxDiscountValue: "Maximum: {{value}}",
    storestatistics_expiryValue: "Läuft ab: {{date}}",
    storestatistics_private: "Privat",
    storestatistics_public: "Öffentlich",
    // Store -> order
    incartcount: "Im Warenkorb",
    addtocart: "In den Warenkorb",
    AllProducts: "Alle Produkte",
    Storeproduct_inQueue: "Warten auf Genehmigung",
    Storeproduct_inprogress: "In Bearbeitung",
    Storeproduct_pickingup: "Abholen",
    Storeproduct_sent: "Versendet",
    Storeproduct_delivered: "Zugestellt",
    Storeproduct_failed: "Fehlgeschlagen",
    Storeproduct_canceledbyuser: "Vom Käufer storniert",
    Storeproduct_canceledbyadmin: "Vom Administrator storniert",

    Storeproduct_returned: "Zurückgegeben",
    Storeproduct_yourcartisempty: "Ihr Warenkorb ist leer",
    Storeproduct_noitemfounded: "Kein Artikel gefunden",
    Storeproduct_incart: "Im Warenkorb",
    ShowUnprocessedItemsOnly: "Unverarbeitete Artikel",
    pageStatistics_fromstore: "Aus dem Geschäft",
    ordernumber: "Bestellnummer",
    order_addressSubject: "Zuhause, Arbeitsplatz",
    order_addressReceiver: "Name des Empfängers an dieser Adresse",
    order_addressNote: "Adresshinweis",

    Storeorder_all: "Alle",
    Storeorder_ORDERID: "Bestell-ID",
    Storeorder_CUSTOMER: "Kunde",
    Storeorder_ITEMS: "Artikel",
    Storeorder_ITEM: "Artikel",
    Storeorder_PRICE: "Preis",
    Storeorder_OrderDATE: "Bestelldatum",
    copytrackingcode: "Sendungsverfolgungscode kopieren",
    Storeorder_SentDATE: "Versanddatum",
    Storeorder_deliverdate: "Lieferdatum",
    Storeorder_DELIVERY: "Gesendet über",
    Storeorder_bymyself: "Selbst versendet",
    Storeorder_Envelope: "Umschlag",
    Storeorder_Invoice: "Rechnung",

    Storeorder_DeliveryAmount: "Versandkosten",
    Storeorder_InsuranceAmount: "Versicherungsgebühr",
    Storeorder_Coupon: "Gutscheincode",
    Storeorder_RemoveCoupon: "Gutschein entfernen",
    Storeorder_Productsinyourshoppingcart: "Produkte in Ihrem Warenkorb",
    Storeorder_SendtotheAddress: "An die Adresse senden",
    Storeorder_changeofaddress: "Adressänderung",

    Storeorder_postparselbox: "Postfach",
    Storeorder_pocketenveloptitle: "Anzahl der Artikel pro Umschlag",
    Storeorder_pocketenveloptitleExplain:
      "Bitte geben Sie an, wie viele Stück dieses Produkts in einen Standardumschlag (oder Ihre Standardverpackung) passen.Diese Zahl hilft uns, Lager-, Verpackungs- und Versandberechnungen genauer durchzuführen.",
    Storeorder_Destination: "Ziel",
    Storeorder_STATUS: "Status",
    Storeorder_DETAILS: "Details",
    Storeorder_PickupRequest: "Abholanfrage",
    Storeorder_PrintWaybill: "Frachtbrief drucken",
    Storeorder_Waybill: "Frachtbrief",
    Storeorder_WaybillExplain:
      "Bitte drucken Sie den Frachtbrief aus und kleben Sie ihn klar, flach und fest auf die Verpackung, bevor Sie die Abholung beantragen.",
    Storeorder_noneSendExplain:
      "Da dieses Paket nicht über das Brancy-Versandsystem versendet werden konnte und Sie es persönlich auf eigene Verantwortung versendet haben, müssen Sie diesen Schritt bestätigen. Nach der Bestätigung wird der Käufer benachrichtigt, dass das Paket versendet wurde.",
    Storeorder_ManualTrackingExplain:
      "Da Sie das Paket direkt an das Versandunternehmen übergeben haben, geben Sie bitte nach Erhalt des Sendungsverfolgungscodes diesen im entsprechenden Feld ein und bestätigen Sie diesen Schritt.  Dadurch wird Brancy den Käufer automatisch über den Tracking-Code und die Versandinformationen informieren.",
    Storeorder_SendExplain: "Die Informationen in diesem Abschnitt werden automatisch aktualisiert",

    Storeorder_requestedpickup: "Abholung ausstehend",
    Storeorder_TrackingCode: "Sendungsverfolgungscode",
    Storeorder_PostMan: "Postbote",
    Storeorder_from: "Gesendet von",
    Storeorder_currentLocation: "Aktueller Standort",
    Storeorder_lastUpdateTime: "Letzte Aktualisierung",
    Storeorder_sender: "Absender",

    Storeorder_IssuingTrackingCode: "Ausgabe des Sendungsverfolgungscodes",
    Storeorder_orderDetailsStep: "Bestellinformationen",
    Storeorder_orderconfirmStep: "Paketgröße und Frachtbrief",
    Storeorder_orderlist: "Bestellliste",
    Storeorder_singleorder: "Bestellung",
    Storeorder_quantityorder: "Menge",
    Showmore: "Mehr anzeigen",
    totalprice: "Gesamtpreis",
    note: "Notiz",
    navbar_PaymentNumber: "Zahlungsverfolgungscode",
    Storeorder_receiver: "Empfänger",
    Storeorder_AcceptthisOrder: "Diese Bestellung bestätigen",
    Storeorder_ParselisConfirmed: "Ich bestätige, dass die eingegebenen Angaben korrekt sind",
    Storeorder_ParselisConfirmedExplain:
      "Ein falscher Größen- oder Gewichtseintrag kann zu Strafen und zur Rücksendung des Pakets führen",
    Storeorder_CancelOrder: "Bestellung stornieren",
    Storeorder_nextWaybill: "Weiter (Frachtbrief erhalten)",
    Storeorder_Pickedup: "Abgeholt",
    SelectProduct: "Produkt auswählen",
    SelectedPosts: "Ausgewählte Beiträge:",
    product_BasicDetail: "Grundlegende Details",
    BacktoProductList: "Zurück zur Produktliste",
    Backtocart: "Zurück zum Warenkorb",
    product_ProductID: "Produkt-ID",
    product_Producttitle: "Produkttitel",
    product_Product: "Produkte",
    product_Categories: "Kategorien",
    product_MainCategory: "Hauptkategorie",
    product_Subcategory: "Unterkategorie",
    product_Subset: "Untergruppe",
    product_Group: "Gruppe",
    product_Branch: "Zweig",
    product_Subbranch: "Unterzweig",
    product_Dependency: "Abhängigkeit",
    product_Brand: "Marke",
    product_instagramcaption: "Instagram-Beschriftung",
    product_productDescription: "Produktbeschreibung",
    product_Informationplaceholder:
      "In diesem Abschnitt können Sie die Produktbeschreibung schreiben.\n\n Diese Beschreibung kann vollständige und attraktive Informationen enthalten, wie\n Merkmale, Vorteile, wichtige Details zum Produkt oder zur Anwendung, Inhaltsstoffe\n kurz und prägnant ausgedrückt.\n\n Die Kunden werden besser mit den Produktmerkmalen vertraut und die Verkaufschancen für das Produkt steigen.",
    product_General: "Allgemein",
    product_Specifications: "Spezifikationen",
    product_Information: "Informationen",
    product_addNewTable: "Neue Tabelle hinzufügen",
    product_EditTable: "Tabelle bearbeiten",
    product_PreviewTable: "Tabelle",
    product_addtable: "Tabelle erstellen",
    product_tabletitle: "Tabellenüberschrift (optional)",
    product_tabletitleExplain: "Zum Beispiel: Größentabelle",
    product_tableheaderoption: "Erste Zeile als Kopfzeile",
    product_AddColumn: "Spalte neben dieser hinzufügen",
    product_DeleteColumn: "Diese Spalte löschen",
    product_AddRow: "Zeile unter dieser hinzufügen",
    product_DeleteRow: "Diese Zeile löschen",
    rowheader: "Kopfzeile",
    cell: "Zelle",
    product_Media: "Medien",
    Nodescriptionavailable: "Keine Beschreibung verfügbar",
    NoSpecificationsavailable: "Keine Spezifikationen verfügbar",
    product_Properties: "Eigenschaften",
    product_Setting: "Einstellungen",
    product_productdeleted: "Produkt gelöscht",
    product_SetProperties: "Eigenschaften festlegen",
    product_SetPropertiesexplain: "Sie können 1-3 Eigenschaften auswählen, eine davon kann benutzerdefiniert sein",
    product_AddNewproperty: "Neue Eigenschaft hinzufügen",
    product_Nopropertyisset: "Keine Eigenschaft festgelegt",
    product_Variation: "Variation",
    product_Discount: "Rabatt",
    product_PricewithDiscount: "Preis mit Rabatt",
    product_AddNewVariation: "Neue Variation hinzufügen",
    product_Definenew: "Neu definieren (Benutzerdefiniert)",
    product_systemlist: "Intelligente Standardliste",
    product_itemlist: "Elementliste",
    product_Available: "Verfügbar",
    product_supplying: "In Versorgung",
    product_OutOfStock: "Nicht Auf Lager",
    product_Stoppedsale: "Verkauf Gestoppt",
    product_draft: "Entwurf",
    product_Amount: "Menge",
    product_NUMBEROFUSES: "Anzahl der Anwendungen",
    product_UNLIMITED: "Unbegrenzt",
    product_LIMITED: "Begrenzt",
    product_USINGTIMES: "Nutzungsdauer",
    product_UNLIMITEDTIME: "Unbegrenzte Zeit",
    permanent: "Dauerhaft",
    product_LIMITEDTIME: "Begrenzte Zeit",
    product_mediatitle: "Bilder und Videos des Produkts verwalten",
    product_clicktoupload: "Zum Hochladen klicken",
    product_SuggestedImages: "Vorgeschlagene Bilder",
    product_SuggestedImagesExplain:
      "Verbessern Sie Ihre Produktgalerie mit vorgeschlagenen Bildern oder laden Sie Ihre gewünschten Bilder hoch",
    product_ordragdrop: "oder ziehen und ablegen",
    product_productspecifications: "Produktmerkmale",
    product_choosesystemlist: "Aus der Systemliste auswählen",
    product_choosesystemlistexplain: "Suchen und wählen Sie alle benötigten Spezifikationen aus",
    product_Definenewexplain: "Wenn Sie keine Spezifikationen finden können, erstellen Sie diese",
    product_importbatch: "Batch importieren",
    product_importbatchexplain: "Fügen Sie alle Spezifikationen des vorherigen Produkts hinzu",
    Value: "Wert",
    Undefined: "Undefiniert",
    product_original: "Original",
    product_HighCopy: "Hochwertige Kopie",
    product_notoriginal: "Nicht original",
    product_Corporate: "Unternehmen",
    product_Miscellaneous: "Verschiedenes",
    product_fake: "Fälschung",
    tomorrow: "Morgen",
    NotSet: "Nicht festgelegt",
    Yes: "Ja",
    No: "Nein",
    "Video generation request sent.": "Videoerstellungsanfrage gesendet.",
    "Image generation request sent.": "Bilderstellungsanfrage gesendet.",
    ", Image generation failed.": ", Bilderstellung fehlgeschlagen.",
    "Create and manage AI-generated images and videos.": "Erstellen und verwalten Sie KI-generierte Bilder und Videos.",
    Storeproduct_OutOfStandardSize: "Außerhalb der Standardgröße",
    product_box: "Boxgröße",
    Product_Availablity: "Verfügbarkeit",
    Product_maxincart: "Max im Warenkorb",
    Product_originality: "Originalität",
    Product_preperingforship: "Versandvorbereitung",
    Product_Evat: "MwSt",
    Product_Evatcount: "MwSt-Wert",
    Product_Guarantee: "Garantie",
    Product_Guaranteelength: "Garantiezeit",
    Product_packageshipping: "Verpackung & Versand",
    Product_packageshippingexplain:
      "Durch Deaktivieren dieser Option übernehmen Sie die Verantwortung für den Produktversand und die damit verbundenen Dienstleistungen",
    Product_titleExplain:
      "Vorgeschlagene Titel werden basierend auf den Merkmalen Ihres Produkts und den durchschnittlichen Titeln auf dem Markt bereitgestellt, um dessen Sichtbarkeit in Suchanfragen und ähnlichen Produkten zu erhöhen. \n(Diese Titel können Fehler enthalten)",
    Product_Breakable: "Zerbrechlich",
    Product_Luquid: "Flüssigkeit",
    Product_sack: "Sack / Beutel",
    Product_sackExplain:
      "Wenn Ihr Produkt in einem Sack, Beutel oder einer weichen, flexiblen Verpackung versendet wird, wählen Sie diese Option. Dies hilft uns, die Anordnung, den Transport und die Verpackung besser zu organisieren.",
    Product_Productweights: "Produktgewicht",
    Product_Productweightsexplian: "Nettogewicht des Produkts ohne Verpackung",
    Product_packaging: "Verpackung",
    Product_packagingexplian:
      "Das Gewicht der Produktverpackung ohne Inhalt, einschließlich Verpackungskarton, Klebeband und Versandetikett, wird vom System berechnet",
    Product_shippingSize: "Versandgröße ",
    product_SuggestedPrice: "Preisanalyse dieses Produkts auf dem gesamten Markt",
    product_MinimumPrice: "Mindestpreis",
    product_AveragePrice: "Durchschnittspreis",
    product_MaximumPrice: "Höchstpreis",
    length: "Länge",
    width: "Breite",
    height: "Höhe",
    Weight: "Gewicht",
    finalWeight: "Endgewicht",
    product_deleteproductexplain: "Sie versuchen, dieses Produkt zu löschen.",
    // #endregion Store Section
    // #region 8️⃣Setting Section
    // Setting -> General -> System
    SettingGeneralSystemTitle: "System",
    SettingGeneralSystemlanguage: "Sprache",
    SettingGeneralSystemcalendar: "Kalender",
    SettingGeneralSystemGregorian: "Gregorianisch",
    SettingGeneralSystemshamsi: "Shamsi",
    SettingGeneralSystemHijri: "Hijri",
    SettingGeneralSystemHindi: "Hindi",
    SettingGeneralSystemStartWeek: "Wochenbeginn",
    SettingGeneralSystemsaturday: "Samstag",
    SettingGeneralSystemmonday: "Montag",
    SettingGeneralSystemtuesday: "Dienstag",
    SettingGeneralSystemwednesday: " Mittwoch",
    SettingGeneralSystemthursday: " Donnerstag",
    SettingGeneralSystemfriday: "Freitag",
    SettingGeneralSystemsunday: "Sonntag",
    SettingGeneralSystemtheme: "Thema",
    SettingGeneralSystemDarkmode: "Dunkelmodus",
    SettingGeneralSystemlightmode: "Hellmodus",
    SettingGeneralSystemPrice: "Preismodell",
    SettingGeneralSystemDollar: "Dollar",
    SettingGeneralSystemeuro: "Euro",
    SettingGeneralSystempound: "Pfund",
    SettingGeneralSystemrial: "Rial",
    SettingGeneralSystemtoman: "Toman",
    SettingGeneralAiModelsTitle: "AI-Modelle",
    SettingGeneralAiModelsTextModels: "Textmodelle",
    SettingGeneralAiModelsVoiceModels: "Sprache-zu-Text-Modelle",
    SettingGeneralAiModelsDirectVoiceSupport: "Direkte Sprachunterstützung",
    SettingGeneral_activedevice: "Aktive Geräte",
    SettingGeneral_leatestentery: "Benutzeraktivitätsverlauf",
    SettingGeneral_cantdeletesession:
      "Sitzungen, die vor weniger als 24 Stunden erstellt wurden, können nicht gelöscht werden.",
    SettingGeneral_deletesession: "Sie versuchen, diese Sitzung zu löschen.",
    SettingGeneral_addSubAdmin: "Unter-Admin hinzufügen",
    SettingGeneral_addSubAdminExplain: "Einen Unter-Admin mit eingeschränktem Zugriff hinzufügen",
    SettingGeneral_addSubAdminExplain2:
      "Einen Admin mit Begrenztem und Sicherem Zugriff einladen, ohne sich bei Instagram anzumelden.",

    SettingGeneral_addSubAdmintitleExplain:
      "Geben Sie die Nummer des neuen Admins ein, um die Einladung zu senden. Nach der Bestätigung wird der Zugriff aktiviert.",
    SettingGeneral_accesslevel: "Zugriffsebene",
    SettingGeneral_access: "Zugriff",
    SettingGeneral_partnertitle: "Titel des Mitwirkenden Admins",
    SettingGeneral_partnernumberexplain:
      "Eine Einladung wird an diese Nummer gesendet, und der Mitwirkende-Admin muss sie in seinem Panel bestätigen (der Admin muss sich bei Brancy registrieren, um die Einladung anzunehmen).",
    SettingGeneral_contentTooltip: "Beiträge, Stories, Reels, IGTV und Karussells.",
    SettingGeneral_publishTooltip:
      "Beiträge, Stories und Inhalte erstellen. Dafür ist der Inhaltszugriff erforderlich.",
    SettingGeneral_automaticsTooltip:
      "KI, Flows sowie automatisierte Prozesse und Aufgaben. Dafür ist der Inhaltszugriff erforderlich.",
    SettingGeneral_messageTooltip: "Instagram-Direktnachrichten, interne Nachrichten und zugehörige Tools.",
    SettingGeneral_commentTooltip: "Kommentare, Antworten und zugehörige Tools.",
    SettingGeneral_transactionTooltip: "Zahlungskontoverwaltung, Transaktionen, Wallet und zugehörige Tools.",
    SettingGeneral_adsTooltip: "Kalenderverwaltung, Werbeverwaltung, Anzeigenfreigabe, Preise und zugehörige Tools.",
    SettingGeneral_ordersTooltip: "Produkte, Preise, Lagerbestand, Bestellungen, Lieferscheine und zugehörige Tools.",
    SettingGeneral_bioTooltip: "Bio-Inhalte und -Anordnung, Links und Verknüpfungen zu Inhalten Dritter.",
    SettingGeneral_ticketTooltip: "CRM, Systemtickets und Support.",
    SettingGeneral_productsTooltip: "Tools zur Produktverwaltung.",

    // Setting -> General -> support
    SettingGeneral_GeneralSupport: "Allgemeine Unterstützung",
    SettingGeneral_Customerservices: "Kundendienst",
    SettingGeneral_ReportBug: "Fehler Melden",
    SettingGeneral_Advertise: "Werbung",
    SettingGeneral_Store: "Geschäft",
    SettingGeneral_biolink: "Bio-Link",
    SettingGeneral_Walletandfinance: "Brieftasche und Finanzen",
    SettingGeneral_MessageingandComment: "Nachrichten und Kommentare",
    SettingGeneral_Support: "Unterstützung",
    SettingGeneral_Department: "Abteilung",
    SettingGeneral_Title: "Titel",
    SettingGeneral_Description: "Beschreibung",
    SettingGeneral_Send: "Senden",
    // #endregion Setting Section
    userpanel_market: "Markt",
    userpanel_order: "Bestellung",
    userpanel_Messages: "Nachrichten",
    userpanel_Settings: "Einstellungen",
    userpanel_PersonalInfo: "Persönliche Informationen",
    userpanel_UploadNewPicture: "Neues Bild hochladen",
    userpanel_Instagramid: "Instagram-ID",
    userpanel_Nameandfamily: "Name und Familie",
    userpanel_NationalCode: "Nationaler Code",
    userpanel_BirthDay: "Geburtstag",
    userpanel_MobileNumber: "Handynummer",
    userpanel_Email: "E-Mail",
    userpanel_CreditNumber: "Kreditkartennummer",
    userpanel_Addresses: "Adressen",
    userpanel_AddNewAddress: "Neue Adresse hinzufügen",
    userpanel_ZipCode: "Postleitzahl",
    userpanel_Address: "Adresse",
    userpanel_EditAddress: "Adresse bearbeiten",
    userpanel_AddNewAddressexplain: "Ihr Paket wird an diese Adresse und Person geliefert",
    startbusiness: "Unternehmen gründen",
    AI: "KI",
    ExtraTokens: "Extra Tokens",
    TokenUsage: "Token-Nutzung",
    AdvancedAnalytics: "Erweiterte Analyse",
    AIResponse: "KI-IG Antworten",
    CustomSupport: "Individueller Support",
    CustomDomain: "Benutzerdefinierte Domain",
    WinnerPicker: "Gewinnerauswahl",
    WinnerPickerReserve: "Reserve-Verlosung",

    dataTable1_feature1: "Post-Verwaltung und professionelle Analysen",
    dataTable1_tooltip1:
      "Einfache Planung von Posts. Detaillierte Statistiken und Diagramme für jeden Post: (Like, Teilen, Comment, Speichern, Interaktionsrate, Reichweite, Impression, Wiedergaben, Bindung, Follow/Unfollow, Profilaktivität, verwendete Hashtags) und vieles mehr...",

    dataTable1_feature2: "Neuen Post erstellen",
    dataTable1_tooltip2:
      "Beste Zeit und Datum vorschlagen. Post planen. Hashtags speichern. Automatisch auf Comments antworten. Post als Entwurf speichern, usw.",

    dataTable1_feature3: "Story-Verwaltung und detaillierte Statistiken",
    dataTable1_tooltip3:
      "Story-Planung. Vollständige Analyse je Story: (Like, Teilen, Comment, Speichern, Interaktion, Reichweite, Impression, Wiedergaben, Bindung, Follow/Unfollow, Profilaktivität, Direct, Screenshot), usw.",

    dataTable1_feature4: "Neue Story erstellen",
    dataTable1_tooltip4:
      "Beste Zeit vorschlagen. Story-Planung. Auto-Antwort auf Comments. Story als Entwurf speichern.",

    dataTable1_feature5: "Seitenübergreifende Statistiken",
    dataTable1_tooltip5:
      "Anzahl der Posts und Stories. Sortierung nach Views, Comments, Likes. Beste/schlechteste Posting-Zeiten erkennen. Verlaufsdiagramme von Likes, Follows, Views, Comments, Ghost-Views. Beste Followers erkennen. Vergleich mit vorherigen Werten, usw.",

    dataTable1_feature6: "Hashtag-Verwaltung",
    dataTable1_tooltip6:
      "Unbegrenzte Hashtag-Listen. Intelligente Generierung über Bild-/Seitenanalyse (KI). Verwendete Hashtags einsehen. Trends (nach Tag, Woche, Monat und Sprache: Englisch, Persisch, Arabisch...) und mehr.",

    dataTable1_feature7: "Automatisches Liken neuer Comments",
    dataTable1_tooltip7: "Neue Comments von Followers automatisch liken. Historie in Diagrammen und Listen anzeigen.",

    dataTable1_feature8: "Zufällige Verlosung unter Followers",
    dataTable1_tooltip8:
      "Beste Followers nach Likes/Comments auswählen. Gewinner zufällig wählen. Ergebnisse automatisch als Story veröffentlichen. Nachverfolgung mit Code.",

    dataTable1_feature9: "Punktebasierte Verlosung unter Followers",
    dataTable1_tooltip9:
      "Aufgaben für Teilnahme festlegen (Like, Comment, Mention, Follow). Gewinneranzahl festlegen. Automatisch Story mit Bedingungen und Ergebnissen erstellen. Erinnerungen senden. Verlauf verfolgen.",
    WithStrongCallToAction: "Mit starkem Call To Action",
    WithProsAndCons: "Mit Vor- und Nachteilen",
    ForComparison: "Zum Vergleich",
    WithKeyPoints: "Mit Schlüsselpunkten",
    ForPromotionalPost: "Für Werbepost",
    WithDetailedExplanation: "Mit ausführlicher Erklärung",
    PersuasiveStyle: "Im überzeugenden Stil",
    ForProductIntroduction: "Zur Produkteinführung",
    LongText: "Als langer Text",
    Aipromptexplain:
      "Brancy analysiert den Inhalt Ihrer Seite, um Ihren Ton und Schreibstil zu verstehen; keine zusätzliche Erklärung erforderlich!",
    ImagineSomething: "Stell dir etwas vor... ✦",
    Generating: "Wird generiert...",
    AccessAndManageComments: "Zugriff und Verwaltung von Kommentaren",
    AccessAndManageMessages: "Zugriff und Verwaltung von Nachrichten",
    AccessAndPublishContent: "Zugriff und Veröffentlichung von Inhalten",
    AccessAndManageInsights: "Zugriff und Verwaltung von Statistiken und Berichten",

    AccessAndManageCommentsExplain:
      "Um Ihre Instagram-Kommentare anzuzeigen und zu verwalten, müssen Sie diese Berechtigung aktivieren.",
    AccessAndManageMessagesExplain:
      "Um auf Ihre eingehenden Instagram-Nachrichten zuzugreifen und sie zu verwalten, müssen Sie diese Berechtigung aktivieren.",
    AccessAndPublishContentExplain:
      "Um Instagram-Inhalte anzuzeigen und zu veröffentlichen, müssen Sie diese Berechtigung aktivieren.",
    AccessAndManageInsightsExplain:
      "Um Ihre Instagram-Statistiken und Analysen anzuzeigen und zu verwalten, müssen Sie diese Berechtigung aktivieren.",
    EnablePermission: "Berechtigung aktivieren",
    instagramTutorialTitle: "Instagram-Verbindungsanleitung",
    instagramTutorialStep1Title: "Schritt 1: Sicher bei Instagram anmelden",
    instagramTutorialStep1Text:
      "Klicken Sie auf «Instagram-Konto verbinden», um zu instagram.com zu gelangen und sich anzumelden. Dies sichert eine gültige Verbindung.",
    instagramTutorialStep2Title: "Schritt 2: Zugriff bestätigen",
    instagramTutorialStep2Text:
      "Nach der Anmeldung fordert Instagram Zugriff auf öffentliche Infos an. Genehmigen Sie alles für volle Funktion.",
    instagramremoveStep1Title: "Schritt 3: Zugriffe prüfen",
    instagramremoveStep1text: "Gehen Sie zu den Einstellungen, um alle aktiven Zugriffe Ihres Kontos zu sehen.",
    instagramremoveStep2Title: "Schritt 4: Zugriffe verwalten & entfernen",
    instagramremoveStep2text:
      "Brancy ist offizieller Instagram-Partner, andere Dienste sind nicht nötig. Entfernen Sie unnötige Zugriffe für mehr Sicherheit.",

    understood: "Verstanden",
    previous: "Zurück",
    connectTutorial: "Verbindungsanleitung",
    invalidcode: "Ungültiger Code",
    wearesorry: "Es tut uns leid!",
    PaymentFailed: "Zahlung fehlgeschlagen!",
    thankyou: "Danke!",
    Paymentsuccess: "Zahlung Erfolgreich!",

    TransactionNumber: "Transaktionsnummer:",
    TransactiontrackingNumber: "Transaktionsverfolgungsnummer:",
    InvoiceNumber: "Rechnungsnummer:",

    mainSubscriptionPlan: "Hauptabonnement",
    Tokens: "Tokens",
    tokenExplain:
      "Ein Token ist die Verbrauchseinheit für KI-Dienste; im Durchschnitt erfordert die Verarbeitung von 100 Anfragen etwa 1.000 Tokens.",
    ReserveToken: "Reserve-Token",
    packageTokenExplain:
      "Kostenlose Token, die mit dem Paket aktiviert werden und bis zum Ablauf des Pakets verwendet werden können; danach verfallen sie.",
    ReserveTokenExplain: "Gekaufte Reservetoken, die mit der Zeit nicht ablaufen.",

    pageTools_Months: "Monate",
    subscriptionExpired: "Ihr Abonnement ist abgelaufen, bitte erneuern",
    subscriptionExpireSoon: "Ihr Abonnement läuft bald ab",
    subscriptionManagement: "Abonnementverwaltung",
    subscription: "Abonnement",
    AIAssisment: "KI-Assistent",
    timeperiod: "Verbleibende Zeitspanne",
    domain: "Domain",
    winnerpickerexpired: "Sie können keine Lottery mehr durchführen, bitte aufladen",
    winnerpickerexpiresoon: "Ihre Lottery-Versuche gehen bald zu Ende",
    Aiexpired: "Sie haben keinen Zugriff mehr auf die KI. Bitte laden Sie Ihr Guthaben auf.",
    Aiexpiresoon: "Ihre KI-Tokens sind fast aufgebraucht.",

    followercount: "Follower-Anzahl",
    yourCurrentSubscription: "Ihr aktuelles Abonnement",
    noItemsAvailableContactSupport:
      "Dieser Bereich ist derzeit nicht verfügbar. Bitte wenden Sie sich an den Brancy-Support, indem Sie ein Ticket senden.",

    // #region AIFlow Section
    AIAssismentexplain:
      "Mit dem KI-Assistenten von Brancy können Sie intelligente Konversations-Flows erstellen, um Instagram-Nachrichten und Kommentare automatisch zu beantworten",
    livetest: "Live-Test",
    testlab: "Testlabor",
    promptmode: "Prompt-Modus",
    promptanalysis: "Prompt-Analyse",
    promptanalysisExplain:
      "Geben Sie Ihren Prompt detailliert ein; Brancy analysiert ihn anhand Ihrer Persönlichkeit, Ihres Tons und Ihres Interaktionsstils.",
    promptanalysisplaceholder: "Geben Sie mindestens 20 Zeichen für die Prompt-Analyse ein",
    reanalyze: "Erneut analysieren",
    shouldFollowerexplain: "Antworten werden nur an Benutzer gesendet, die Ihnen follow",
    RenewForThread: "Konversations-Flow erneuern",
    RenewForThreadexplain: "Bei jeder Konversation startet der Flow neu, wenn der Benutzer eine neue Nachricht sendet",
    prompt: "Prompt",
    promptanalysisexplain:
      "Brancy analysiert Ihren Prompt und schlägt die besten Einstellungen für intelligente Antworten vor",

    autosave: "Automatisches Speichern",
    Restrictorzoom: "Zoom Begrenzen",
    snapGrid: "Am Raster Ausrichten",
    PanningBoundary: "Bewegungsgrenze",
    Flow: "Flow (Fluss)",
    flowtitle: "Flow-Titel",
    AIFlow_input: "Eingabe",
    AIFlow_input_message_block: "Benutzereingabe-Nachricht",
    AIFlow_output: "Ausgabe",
    AIFlow_output_title: "Ausgabe-Titel",
    AIFlow_text: "Text",
    AIFlow_item_text: "Element",
    AIFlow_block_title_required: "Bitte geben Sie den Blocktitel ein (erforderlich)",
    AIFlow_item_title: "Elementtitel:",
    AIFlow_show_graph: "Flow-Diagramm anzeigen",
    AIFlow_connect_post: "Mit Beitrag verbinden",
    AIFlow_connect_post_access:
      "Instagram-Berechtigungen für Kommentare und Nachrichten sowie Zugriff auf Automatisierung und Kommentare sind erforderlich.",
    AIFlow_connect_post_save_first: "Speichern Sie diesen Flow, bevor Sie ihn mit einem Beitrag verbinden.",
    AIFlow_connect_post_confirm:
      "Dieser Flow ersetzt die aktuelle automatische Antwort des Beitrags und wird aktiviert. Schlüsselwörter und Abgleichseinstellungen bleiben erhalten; ohne Schlüsselwörter antwortet der Flow auf alle Kommentare.",
    AIFlow_connect_post_resume:
      "Die Flow-Verknüpfung wurde gespeichert, aber die Aktivierung ist fehlgeschlagen. Versuchen Sie die Aktivierung erneut.",
    AIFlow_connect_post_incompatible:
      "Dieser Flow ist nicht mit privaten Kommentarantworten kompatibel. Bearbeiten und speichern Sie ihn vor dem Verbinden.",
    AIFlow_retry: "Erneut versuchen",
    AIPrompt_connect_post_access:
      "Die Instagram-Kommentarberechtigung sowie Zugriff auf Automatisierung und Kommentare sind erforderlich.",
    AIPrompt_connect_post_confirm:
      "Diese KI ersetzt die aktuelle automatische Antwort des Beitrags und wird aktiviert. Schlüsselwörter und Abgleichseinstellungen bleiben erhalten; ohne Schlüsselwörter werden alle Kommentare beantwortet. Private Zustellung bleibt nur mit Nachrichtenberechtigung erhalten; andernfalls werden Antworten als Kommentare gesendet.",
    AIPrompt_connect_post_resume:
      "Die KI-Verknüpfung wurde gespeichert, aber die Aktivierung ist fehlgeschlagen. Versuchen Sie die Aktivierung erneut.",
    messagesetting_PhoneNumbers: "Telefonnummern",
    messagesetting_PhoneNumbersExplain: "Telefonnummern, die über Flows von Ihren Kunden gesammelt wurden",
    messagesetting_PhoneNumbersEmpty: "Es wurden noch keine Telefonnummern gesammelt",
    AIFlow_item_subtitle: "Element Untertitel:",
    AIFlow_option_title: "Optionstitel",
    AIFlow_option_default: "Option",
    AIFlow_quick_reply: "Schnellantwort",
    AIFlow_quick_reply_validation_error: "Alle Schnellantwort-Felder müssen ausgefüllt sein!",
    AIFlow_quick_reply_block_title_empty: "Block {label}\n Kein Titel eingegeben",
    AIFlow_quick_reply_option_title_empty: "Block {label}\n Option {index} ohne Titel",
    AIFlow_delete_image: "🗑️ Bild Löschen",
    AIFlow_delete_image_button_text: "🗑️ Bild Löschen",
    AIFlow_delete_all_block: "🗑️ Block Löschen",
    AIFlow_delete_all_blocks: "Gesamten Flow Löschen",
    AIFlow_save_all_blocks: "Gesamten Flow Speichern",
    AIFlow_delete: "🗑️ Löschen",
    AIFlow_upload_image: "📷 Bild Hochladen",
    AIFlow_image_uploaded: "Bild Hochgeladen ✓",
    AIFlow_add_image: "📷 Bild Hinzufügen",
    AIFlow_voice_recorded: "🎵 Aufgezeichnete Stimme",
    AIFlow_record_voice: "🎤 Stimme Aufnehmen",
    AIFlow_record_voice_confirm: "Bereit zur Aufnahme? (mindestens 3 Sekunden)",
    AIFlow_play_voice: "▶️ Stimme Abspielen",
    AIFlow_add_output: "Neue Ausgabe Hinzufügen",
    AIFlow_add_subtitle: "➕ Untertitel Hinzufügen",
    AIFlow_subtitle_input: "Bitte Untertitel eingeben:",
    AIFlow_link: "Link:",
    AIFlow_general_block: "Allgemeiner Block",
    AIFlow_text_block: "Textblock",
    AIFlow_image_block: "Bildblock",
    AIFlow_voice_block: "Sprachblock",
    AIFlow_quick_reply_block: "Schnellantwortblock",
    AIFlow_weblink_block: "Weblink-Block",
    AIFlow_add_text_block: "Textblock Hinzufügen",
    AIFlow_add_image_block: "Bildblock Hinzufügen",
    AIFlow_add_voice_block: "Sprachblock Hinzufügen",
    AIFlow_add_quick_reply_block: "Schnellantwort Hinzufügen",
    AIFlow_add_general_block: "Allgemeinen Block Hinzufügen",
    AIFlow_add_weblink_block: "Weblink Hinzufügen",
    AIFlow_generic_block: "Allgemeiner Unterblock",
    AutoLayout_block: "Automatisches Layout",
    AIFlow_live_test_block: "Live-Test des Flows",
    AIFlow_Deleteallblocks_alert: "Sind Sie sicher, dass Sie den gesamten Flow löschen möchten?",
    AIFlow_add_output_error_alert: "Fehler beim Hinzufügen der Ausgabe: {error}",
    AIFlow_unknown_block_type_alert: "Unbekannter Blocktyp:",
    AIFlow_multiple_flow_for_private_reply_alert: "Mehrere Flows für private Antwort gefunden",
    AIFlow_empty_title_for_flow_alert: "Flow-Titel ist leer",
    AIFlow_weblink_has_hyphen_alert: "Block {label}\n Link darf kein '-' enthalten",
    AIFlow_min_output_required: "Mindestens eine Ausgabe muss verbleiben",
    AIFlow_max_quick_reply_outputs: "Maximal 15 Ausgaben erlaubt",
    AIFlow_max_generic_outputs: "Maximal 10 Ausgaben erlaubt",
    AIFlow_generic_item_connection_only: "Dieser Block verbindet sich nur mit generischen Blöcken",
    AIFlow_weblink_generic_item_only: "Dieser Block verbindet sich nur mit generischen Unterelementen",
    AIFlow_voice_record_failed: "❌ Sprachaufnahme fehlgeschlagen (kein Ton aufgenommen)",
    AIFlow_voice_upload_failed: "✅ Aufnahme erfolgreich, aber Upload fehlgeschlagen",
    AIFlow_voice_record_empty: "❌ Sprachaufnahme ist leer",
    AIFlow_voice_record_start: "🎙️ Aufnahme gestartet...",
    AIFlow_session_invalid: "Ungültige Benutzersitzung, bitte erneut anmelden",
    AIFlow_no_on_message_node: "Kein Startnachrichtenknoten gefunden!",
    AIFlow_validation_warning: "⚠️ Validierungswarnung",
    AIFlow_generic_item_validation_error: "Bitte füllen Sie alle Felder des generischen Blocks aus",
    AIFlow_weblink_validation_error_alert: "Alle Link-Felder müssen ausgefüllt werden",
    AIFlow_generic_item_title_empty_alert: "Element {label}\n Titel ist leer",
    AIFlow_generic_item_output_title_empty_alert: "Element {label}\n Ausgabe {index} ohne Titel",
    AIFlow_weblink_empty_alert: "Block {label}\n Link ist leer",

    AIFlow_weblink_incomplete_alert: "Block {label}\n Link unvollständig (nur Protokoll eingegeben)",
    AIFlow_weblink_invalid_format_alert: "Block {label}\n Linkformat ungültig",
    AIFlow_weblink_non_english_alert: "Block {label}\n Link muss auf Englisch sein",
    AIFlow_editor_init_error: "❌ Fehler beim Initialisieren des Editors",
    AIFlow_unexpected_error: "⚠️ Unerwarteter Fehler aufgetreten",
    AIFlow_server_error: "❌ Serverfehler",
    AIFlow_connection_error: "⚠️ Verbindungsproblem",
    AIFlow_generic_connection_error: "Fehler bei der Verbindung des generischen Blocks mit Unterelement",
    AIFlow_weblink_connection_error: "Fehler beim Verbinden des Knotens",
    AIFlow_voice_fetch_error: "Fehler beim Abrufen der Audiodatei",
    AIFlow_voice_record_error: "Fehler bei der Sprachaufnahme",
    AIFlow_voice_play_error: "Fehler beim Abspielen der Stimme",
    AIFlow_media_recorder_error: "Fehler im Medienrekorder",
    AIFlow_upload_error: "❌ Upload-Fehler",
    AIFlow_add_output_error: "❌ Fehler beim Hinzufügen der Ausgabe",
    AIFlow_json_parse_error: "Fehler beim Verarbeiten von JSON",
    AIFlow_position_error: "Fehler bei der Verarbeitung der Startnachrichtenposition",
    AIFlow_node_remove_error: "Fehler beim Entfernen des Knotens",
    AIFlow_node_connection_warning: "Verbindung kann nicht hergestellt werden:",
    AIFlow_unknown_value_type: "Unbekannter Werttyp im Button",
    AIFlow_success: "✅ Vorgang erfolgreich abgeschlossen",
    AIFlow_subtitle_success: "✓ Untertitel erfolgreich hinzugefügt",
    AI_live_test: "Teste deine KI-Eingaben in Echtzeit",

    New_Flow_input_message_block: "Benutzereingabenachricht",
    New_Flow_general_block: "Allgemeiner Block",
    New_Flow_text_block: "Textblock",
    New_Flow_voice_block: "Audioblock",
    New_Flow_imageorvideo_block: "Bild / Video Block",
    New_Flow_quick_reply_block: "Schnellantwort-Block",
    New_Flow_weblink_block: "Link-Block",
    New_Flow_phonenumbergrabber_block: "Telefonnummer-Erfassung",
    New_Flow_ai_block: "KI",
    New_Flow_ai_select: "KI auswählen",
    New_Flow_ai_livetest: "Ihr KI-Block wird hier ausgeführt",
    New_Flow_masterflow_block: "Unterflow",
    New_Flow_masterflow_select: "Flow auswählen",
    New_Flow_masterflow_livetest: "Der ausgewählte Unterflow wird hier fortgesetzt",
    New_Flow_Tutorials_buttongroup_title: "Schaltflächengruppen-Block",
    New_Flow_Tutorials_buttongroup_description:
      "Dieser Block sendet eine Nachricht mit bis zu drei Schaltflächen; jede Schaltfläche hat einen eigenen Ausgang, und der Block hat zusätzlich einen normalen Ausgang, der den Flow fortsetzt.",
    New_Flow_Tutorials_buttongroup_usageType:
      "Geeignet, um wenige klare Optionen, Menüs und schnelle Navigation anzubieten und Nutzer zu Links oder zum nächsten Schritt zu führen.",
    New_Flow_Tutorials_buttongroup_feature_1: "Nachrichtentext mit bis zu 640 Zeichen",
    New_Flow_Tutorials_buttongroup_feature_2: "Bis zu 3 Schaltflächen, jede mit eigenem Ausgang",
    New_Flow_Tutorials_buttongroup_feature_3:
      "Ein normaler Ausgang setzt den Flow fort, ohne auf einen Klick zu warten",
    New_Flow_Tutorials_buttongroup_tip_1: "Formulieren Sie Nachricht und Beschriftungen klar und kurz",
    New_Flow_Tutorials_buttongroup_tip_2:
      "Verbinden Sie jede Schaltfläche mit dem Block, der auf ihre Auswahl folgen soll",
    New_Flow_Tutorials_buttongroup_tip_3:
      "Nur die Schaltflächen-Ausgänge können mit einem Weblink-Block verbunden werden",
    New_Flow_Tutorials_buttongroup_limitation_1: "Maximal 3 Schaltflächen",
    New_Flow_Tutorials_buttongroup_limitation_2: "Nachrichtentext: max. 640 Zeichen",
    New_Flow_Tutorials_buttongroup_limitation_3: "Schaltflächentitel: max. 20 Zeichen",
    New_Flow_Tutorials_buttongroup_limitation_4: "Das Löschen der letzten Schaltfläche entfernt den Block",
    New_Flow_Tutorials_ai_title: "KI-Block",
    New_Flow_Tutorials_ai_description:
      "Dieser Block übergibt das Gespräch an eine der von Ihnen erstellten KIs; wählen Sie die KI aus der Liste im Block aus.",
    New_Flow_Tutorials_ai_usageType:
      "Geeignet, um offene Kundenfragen, Support, Beratung und Verkaufsgespräche automatisch zu beantworten.",
    New_Flow_Tutorials_ai_feature_1: "Listet alle von Ihnen erstellten KIs zur Auswahl auf",
    New_Flow_Tutorials_ai_feature_2: "Die gewählte KI übernimmt das Gespräch ab dieser Stelle im Flow",
    New_Flow_Tutorials_ai_tip_1: "Erstellen und konfigurieren Sie Ihre KI zuerst, damit sie in der Liste erscheint",
    New_Flow_Tutorials_ai_tip_2: "Platzieren Sie ihn nach einem Nachrichtenblock, der das Gespräch einleitet",
    New_Flow_Tutorials_ai_limitation_1: "Hat nur einen Eingang und keinen Ausgang, beendet also den Flow",
    New_Flow_Tutorials_ai_limitation_2: "Pro Block kann nur eine KI ausgewählt werden",
    New_Flow_Tutorials_ai_limitation_3: "Kann nicht der erste Block des Flows sein",
    New_Flow_Tutorials_masterflow_title: "Unterflow-Block",
    New_Flow_Tutorials_masterflow_description:
      "Leitet das Gespräch an einen bereits erstellten Flow weiter, wenn der Nutzer auf eine Schaltfläche tippt.",
    New_Flow_Tutorials_masterflow_usageType: "Einen vorhandenen Flow als Fortsetzung einer Schaltfläche wiederverwenden",
    New_Flow_Tutorials_masterflow_feature_1: "Listet alle von Ihnen erstellten Flows zur Auswahl auf",
    New_Flow_Tutorials_masterflow_feature_2: "Der ausgewählte Flow setzt das Gespräch ab diesem Punkt fort",
    New_Flow_Tutorials_masterflow_tip_1:
      "Erstellen und speichern Sie zuerst den Ziel-Flow, damit er in der Liste erscheint",
    New_Flow_Tutorials_masterflow_tip_2: "Nutzen Sie ihn für gemeinsame Pfade (z. B. Support oder Preise) zwischen Flows",
    New_Flow_Tutorials_masterflow_limitation_1: "Hat nur einen Eingang und keinen Ausgang und beendet daher diesen Flow",
    New_Flow_Tutorials_masterflow_limitation_2:
      "Kann nur mit Schaltflächen verbunden werden, nicht mit normalen Ausgängen",
    New_Flow_Tutorials_masterflow_limitation_3: "Der gerade bearbeitete Flow kann nicht ausgewählt werden",
    New_Flow_Tutorials_masterflow_connection_1: "Schaltflächen des Schnellantwort-Blocks",
    New_Flow_Tutorials_masterflow_connection_2: "Schaltflächen des Schaltflächengruppen-Blocks",
    New_Flow_Tutorials_masterflow_connection_3: "Schaltflächen des Galerie-Unterblocks",
    New_Flow_generic_block: "Galerie-Block (Karussell)",
    New_Flow_add_general_block: "Galerieblock hinzufügen",
    New_Flow_add_text_block: "Textblock hinzufügen",
    New_Flow_add_image_block: "Bildblock hinzufügen",
    New_Flow_add_voice_block: "Audioblock hinzufügen",
    New_Flow_add_quick_reply_block: "Schnellantwort hinzufügen",
    New_Flow_add_weblink_block: "Link hinzufügen",
    New_Flow_upload_imageorvideo: "Bild oder Video hochladen",
    New_Flow_upload_image: "Bild hochladen",
    New_Flow_upload_unsupported_media: "Nicht unterstütztes Medienformat",
    New_Flow_uploadmaxsizeexceeded: "Dateigröße darf 50MB nicht überschreiten",
    New_Flow_uploadfilefailed: "Datei-Upload fehlgeschlagen, bitte erneut versuchen",
    New_Flow_unsupportedbrowser: "Ihr Browser unterstützt keine Videowiedergabe",
    New_Flow_micphoneaccessdenied: "Mikrofonzugriff aktivieren",
    New_Flow_upload_audio: "Audiodatei hochladen",
    New_Flow_record_voice: "Sprachaufnahme starten",
    New_Flow_stop_record_voice: "Aufnahme stoppen",
    New_Flow_areyoureadytorecord: "Sind Sie bereit für die Aufnahme?",
    New_Flow_voice_recording_started: "Stimme wird aufgenommen...",
    New_Flow_add_generic_sub_block: "Unterblock hinzufügen",
    New_Flow_generic_sub: "Unterblock",
    New_Flow_add_button: "Button hinzufügen",
    New_Flow_quick_reply_title_placeholder: "Titel der Schnellantwort-Option",
    New_Flow_buttongroup_block: "Schaltflächengruppen-Block",
    New_Flow_add_buttongroup_block: "Schaltflächengruppe hinzufügen",
    New_Flow_buttongroup_title_placeholder: "Nachrichtentext der Schaltflächengruppe",
    New_Flow_imagegallery_block: "Bildergalerie-Block",
    New_Flow_add_imagegallery_block: "Bildergalerie hinzufügen",
    New_Flow_imagegallery_max_reached: "Sie können diesem Block bis zu {{max}} Bilder hinzufügen",
    New_Flow_Tutorials_imagegallery_title: "Bildergalerie-Block",
    New_Flow_Tutorials_imagegallery_description:
      "Dieser Block dient zum Hochladen und Senden mehrerer Bilder (bis zu {{max}}) per Direktnachricht an Nutzer.",
    New_Flow_Tutorials_imagegallery_usageType:
      "Geeignet für die Präsentation mehrerer Produkte, Fotoalben, Vorher-Nachher-Bilder und Bildersammlungen.",
    New_Flow_Tutorials_imagegallery_feature_1: "Akzeptiert bis zu {{max}} Bilder in einem Block",
    New_Flow_Tutorials_imagegallery_limitation_1:
      "Maximal {{max}} Bilder pro Block (dieses Limit kann in Zukunft erhöht werden)",
    New_Flow_message_title: "Nachrichtentitel",
    New_Flow_message_description: "Nachrichtenbeschreibung",
    New_Flow_live_test_block: "Live-Flow-Test",
    New_Flow_delete_all_blocks: "Gesamten Flow löschen",
    New_Flow_shortcuts_explain:
      "Tastenkombinationen zur Erhöhung der Geschwindigkeit und Kontrolle bei der Verwaltung von Workflows.",
    New_Flow_Tutorials_Not_Available: "Anleitung nicht verfügbar",
    New_Flow_Tutorials_Not_Available_Description: "Für diesen Node ist keine Anleitung verfügbar.",
    New_Flow_Tutorials_Usage_Type: "Nutzungsart",
    New_Flow_Tutorials_Features: "Funktionen",
    New_Flow_Tutorials_Tips: "Praktische Tipps",
    New_Flow_Tutorials_Limitations: "Einschränkungen",
    New_Flow_Tutorials_Connections: "Verbindungen",
    New_Flow_unsavedChanges: "Sie haben ungespeicherte Änderungen",
    New_Flow_addedNodes: "Hinzugefügte Knoten",
    New_Flow_removedNodes: "Entfernte Knoten",
    New_Flow_modifiedNodes: "Geänderte Knoten",
    New_Flow_invalidFlow_explain:
      "Der Flow ist ungültig. Bitte überprüfen Sie die Knoten auf Fehler, bevor Sie speichern",
    sendsms: "SMS an den Benutzer senden",
    sendtotelegram: "Benutzer zu Telegram weiterleiten",
    senderusername: "Benutzer mit Namen ansprechen",
    addtools: "Werkzeug hinzufügen",
    generatebyai: "Von KI generieren",

    //tutorials

    New_Flow_Tutorials_onmessage_title: "Startpunkt Ihres Flows",
    New_Flow_Tutorials_onmessage_description:
      "Dieser Block ist der Startpunkt Ihres Flows. Wenn ein Nutzer eine Nachricht an Ihren Instagram-Direct sendet, wird dieser Block aktiviert und der Flow startet. Er ist immer der erste Block in jeder Automatisierung und kann nicht gelöscht werden.",
    New_Flow_Tutorials_onmessage_feature_1: "Ein Ausgang, um mit dem nächsten Block zu verbinden",
    New_Flow_Tutorials_onmessage_tip_1:
      "Verbinden Sie den Ausgang dieses Blocks mit jedem anderen Block. Der Flow startet, wenn der Nutzer eine Nachricht sendet (Text, Bild, Video, Audio usw.)",
    New_Flow_Tutorials_onmessage_connection_1: "Verbindbar mit den folgenden Blöcken:",
    New_Flow_Tutorials_onmessage_connection_2: "❌ Web-Link Block",
    New_Flow_Tutorials_onmessage_connection_3: "✅ Sprachnachrichten-Block",
    New_Flow_Tutorials_onmessage_connection_4: "✅ Textnachrichten-Block",
    New_Flow_Tutorials_onmessage_connection_5: "✅ Schnellantwort-Block",
    New_Flow_Tutorials_onmessage_connection_6: "✅ Bild & Video Block",
    New_Flow_Tutorials_onmessage_connection_7: "✅ Galerie-Block",

    New_Flow_Tutorials_text_title: "Textnachrichten-Block",
    New_Flow_Tutorials_text_description: "Dieser Block wird verwendet, um Textnachrichten an Benutzer zu senden.",
    New_Flow_Tutorials_text_usageType:
      "Geeignet für Willkommensnachrichten, Produktbeschreibungen, FAQs, Benachrichtigungen und Benutzerführung.",
    New_Flow_Tutorials_text_feature_1: "Unterstützt alle Sprachen",
    New_Flow_Tutorials_text_feature_2: "Unterstützt Emojis und Sonderzeichen",
    New_Flow_Tutorials_text_tip_1: "Halten Sie Nachrichten kurz und klar",
    New_Flow_Tutorials_text_tip_2: "Emojis in Maßen verwenden",
    New_Flow_Tutorials_text_tip_3: "Lange Texte in Abschnitte aufteilen",
    New_Flow_Tutorials_text_tip_4: "Freundlicher und zugänglicher Ton",
    New_Flow_Tutorials_text_tip_5: "Geeignete Absatzformatierung verwenden",
    New_Flow_Tutorials_text_limitation_1: "Maximal 2200 Zeichen",
    New_Flow_Tutorials_text_limitation_2: "Nur Text (keine Dateien oder Medien)",
    New_Flow_Tutorials_text_limitation_3: "Keine Formatierung (Fett, Kursiv)",
    New_Flow_Tutorials_text_connection_1: "✅ Nachrichten-Eingangsblock",
    New_Flow_Tutorials_text_connection_2: "❌ Web-Link Block",
    New_Flow_Tutorials_text_connection_3: "✅ Sprachnachrichten-Block",
    New_Flow_Tutorials_text_connection_4: "✅ Textnachrichten-Block",
    New_Flow_Tutorials_text_connection_5: "✅ Schnellantwort-Block",
    New_Flow_Tutorials_text_connection_6: "✅ Bild & Video Block",
    New_Flow_Tutorials_text_connection_7: "❌ Galerie-Block",
    New_Flow_Tutorials_text_connection_8: "✅ Galerie-Unterblock",

    New_Flow_Tutorials_image_title: "Bild- & Video-Block",
    New_Flow_Tutorials_image_description:
      "Dieser Block wird verwendet, um Bilder und Videos an Nutzer über direct zu senden.",
    New_Flow_Tutorials_image_usageType:
      "Geeignet zur Präsentation von Produkten, Bildergalerien, Logos, Werbebannern, Lehr- und Einführungsvideos.",
    New_Flow_Tutorials_image_feature_1: "Bildunterstützung: JPEG, PNG, GIF, WebP, SVG",
    New_Flow_Tutorials_image_feature_2: "Video-Unterstützung: MP4, WebM, OGG, MOV, AVI, MKV",
    New_Flow_Tutorials_image_feature_3: "Automatische Dateityp-Erkennung",
    New_Flow_Tutorials_image_tip_1: "Verwenden Sie hochwertige Bilder",
    New_Flow_Tutorials_image_tip_2: "Große Dateien vor dem Hochladen komprimieren",
    New_Flow_Tutorials_image_tip_3: "Standardgröße: 1080×1080 oder 1080×1350",
    New_Flow_Tutorials_image_tip_4: "Halten Sie Videos unter 30 Sekunden",
    New_Flow_Tutorials_image_tip_5: "JPEG für normale Bilder, PNG für transparente Hintergründe",
    New_Flow_Tutorials_image_limitation_1: "Maximale Dateigröße: 50 MB",
    New_Flow_Tutorials_image_limitation_2: "Eine Datei pro Block",
    New_Flow_Tutorials_image_limitation_3: "Ungewöhnliche Formate werden möglicherweise nicht unterstützt",
    New_Flow_Tutorials_image_connection_1: "✅ Nachrichten-Eingangsblock",
    New_Flow_Tutorials_image_connection_2: "❌ Weblink-Block",
    New_Flow_Tutorials_image_connection_3: "✅ Sprach-Nachrichtenblock",
    New_Flow_Tutorials_image_connection_4: "✅ Textnachrichtenblock",
    New_Flow_Tutorials_image_connection_5: "✅ Schnellantwort-Block",
    New_Flow_Tutorials_image_connection_6: "✅ Bild- & Video-Block",
    New_Flow_Tutorials_image_connection_7: "❌ Galerie-Block",
    New_Flow_Tutorials_image_connection_8: "✅ Unter-Galerie-Block",
    invalidFlowDetected:
      "Ungültiger Flow erkannt! Einige Blöcke haben keinen Eingang oder der Nachrichtenblock steht allein.",

    New_Flow_Tutorials_voice_title: "Sprach-Nachrichtenblock",
    New_Flow_Tutorials_voice_description:
      "Dieser Block wird verwendet, um Audiodateien hochzuladen oder Live-Aufnahmen an Nutzer zu senden.",
    New_Flow_Tutorials_voice_usageType:
      "Geeignet für persönliche Sprachnachrichten, erzählte Tutorials, kurze Podcasts und Audioanleitungen.",
    New_Flow_Tutorials_voice_feature_1: "Unterstützte Formate: MP3, M4A, WAV, OGG, AAC",
    New_Flow_Tutorials_voice_feature_2: "Direktaufnahme vom Mikrofon",
    New_Flow_Tutorials_voice_feature_3: "Hochladen von vorab aufgenommenen Audiodateien",
    New_Flow_Tutorials_voice_tip_1: "In einer ruhigen Umgebung aufnehmen",
    New_Flow_Tutorials_voice_tip_2: "Kurze Nachrichten (unter 1 Minute) sind besser",
    New_Flow_Tutorials_voice_tip_3: "Überprüfen Sie die Audioqualität vor dem Senden",
    New_Flow_Tutorials_voice_tip_4: "Bereiten Sie Ihren Text vor der Aufnahme vor",
    New_Flow_Tutorials_voice_limitation_1: "Maximale Dateigröße: 50 MB",
    New_Flow_Tutorials_voice_limitation_2: "Mikrofonzugriff für Aufnahme erforderlich",
    New_Flow_Tutorials_voice_limitation_3: "Eine Datei pro Block",
    New_Flow_Tutorials_voice_connection_1: "✅ Nachrichten-Eingangsblock",
    New_Flow_Tutorials_voice_connection_2: "❌ Weblink-Block",
    New_Flow_Tutorials_voice_connection_3: "✅ Sprach-Nachrichtenblock",
    New_Flow_Tutorials_voice_connection_4: "✅ Textnachrichtenblock",
    New_Flow_Tutorials_voice_connection_5: "✅ Schnellantwort-Block",
    New_Flow_Tutorials_voice_connection_6: "✅ Bild- & Video-Block",
    New_Flow_Tutorials_voice_connection_7: "❌ Galerie-Block",
    New_Flow_Tutorials_voice_connection_8: "✅ Unter-Galerie-Block",

    New_Flow_Tutorials_quickreply_title: "Schnellantwort-Block",
    New_Flow_Tutorials_quickreply_description:
      "Dieser Block wird verwendet, um einmalige Quick Reply Buttons für Benutzer zu erstellen, wobei jeder Button den Benutzer auf einen bestimmten Pfad im Flow leitet.",
    New_Flow_Tutorials_quickreply_usageType:
      "Geeignet für Auswahllisten, Produktkategorien, Multiple-Choice-Fragen, Umfragen und Suchfilter.",
    New_Flow_Tutorials_quickreply_feature_1: "Bis zu 10 Buttons pro Block",
    New_Flow_Tutorials_quickreply_feature_2: "Jeder Button hat einen eigenen Ausgang",
    New_Flow_Tutorials_quickreply_feature_3: "Möglichkeit zum Löschen und Bearbeiten von Buttons",
    New_Flow_Tutorials_quickreply_tip_1: "Schreiben Sie den Text der Buttons klar und praxisnah",
    New_Flow_Tutorials_quickreply_tip_2: "3–5 Buttons für bessere Erfahrung",
    New_Flow_Tutorials_quickreply_tip_3: "Labels kurz halten (unter 20 Zeichen)",
    New_Flow_Tutorials_quickreply_tip_4: "Verwenden Sie das Titelfeld zur Orientierung",
    New_Flow_Tutorials_quickreply_tip_5: "Priorisieren Sie Buttons nach Wichtigkeit",
    New_Flow_Tutorials_quickreply_limitation_1: "Maximal 10 Buttons",
    New_Flow_Tutorials_quickreply_limitation_2: "Button-Titel: Max. 40 Zeichen",
    New_Flow_Tutorials_quickreply_limitation_3: "Beschreibung: Max. 140 Zeichen",
    New_Flow_Tutorials_quickreply_limitation_4: "Mindestens ein Button erforderlich",
    New_Flow_Tutorials_quickreply_connection_1: "✅ Nachrichten-Eingabeblock",
    New_Flow_Tutorials_quickreply_connection_2: "❌ Weblink-Block",
    New_Flow_Tutorials_quickreply_connection_3: "✅ Sprachnachrichten-Block",
    New_Flow_Tutorials_quickreply_connection_4: "✅ Textnachrichten-Block",
    New_Flow_Tutorials_quickreply_connection_5: "✅ Schnellantwort-Block",
    New_Flow_Tutorials_quickreply_connection_6: "✅ Bild & Video Block",
    New_Flow_Tutorials_quickreply_connection_7: "❌ Galerie-Block",
    New_Flow_Tutorials_quickreply_connection_8: "✅ Unter-Galerie-Block",

    New_Flow_Tutorials_generic_title: "Galerie (Karussell) Block",
    New_Flow_Tutorials_generic_description:
      "Erstellen Sie eine horizontal scrollbare Galerie (Karussell) aus Elementen",
    New_Flow_Tutorials_generic_usageType:
      "Geeignet zur Anzeige von Produkten, Service-Menüs, Kategorien, Teamvorstellung, Portfolio und Vergleich von Optionen.",
    New_Flow_Tutorials_generic_tip_1: "Verwenden Sie Bilder mit gleichen Abmessungen (z. B. 1:1)",
    New_Flow_Tutorials_generic_tip_2: "Halten Sie die Anzahl der Elemente zwischen 3 und 5",
    New_Flow_Tutorials_generic_tip_3: "Schreiben Sie kurze und klare Titel",
    New_Flow_Tutorials_generic_tip_4: "Geeignet für ähnliche Produkte oder Vergleiche",
    New_Flow_Tutorials_generic_limitation_1: "Maximal 10 Elemente pro Karussell",
    New_Flow_Tutorials_generic_connection_1: "✅ Nachrichten-Eingabeblock",
    New_Flow_Tutorials_generic_connection_2: "✅ Unter-Galerie-Block",
    New_Flow_Tutorials_generic_connection_3: "❌ Weblink-Block",
    New_Flow_Tutorials_generic_connection_4: "❌ Sprachnachrichten-Block",
    New_Flow_Tutorials_generic_connection_5: "❌ Textnachrichten-Block",
    New_Flow_Tutorials_generic_connection_6: "❌ Schnellantwort-Block",
    New_Flow_Tutorials_generic_connection_7: "❌ Bild & Video Block",

    New_Flow_Tutorials_genericitem_title: "Karussell-Element",
    New_Flow_Tutorials_genericitem_description:
      "Ein Element im Karussell mit Bild, Titel, Beschreibung, Link und bis zu 3 Buttons",
    New_Flow_Tutorials_genericitem_usageType:
      "Geeignet zur Anzeige von Produktdetails, Vorstellung von Dienstleistungen, Teampräsentation, Portfolio und Preispaketen.",
    New_Flow_Tutorials_genericitem_feature_1: "Optionaler Weblink",
    New_Flow_Tutorials_genericitem_feature_2: "Optionales Bild: JPEG, PNG, GIF",
    New_Flow_Tutorials_genericitem_feature_3: "Video: MP4, WebM, OGG",
    New_Flow_Tutorials_genericitem_feature_4: "Bis zu 3 Buttons mit unabhängigen Ausgängen",
    New_Flow_Tutorials_genericitem_tip_1: "Fügen Sie jedem Element ein ansprechendes Bild hinzu",
    New_Flow_Tutorials_genericitem_tip_2: "Titel für Hauptnachricht, Beschreibung für Details",
    New_Flow_Tutorials_genericitem_tip_3: "Links vor dem Senden testen",
    New_Flow_Tutorials_genericitem_tip_4: "Buttontexte kurz und klar halten",
    New_Flow_Tutorials_genericitem_tip_5: "Verwenden Sie möglichst verkürzte Links",
    New_Flow_Tutorials_genericitem_limitation_1: "Titel: maximal 140 Zeichen",
    New_Flow_Tutorials_genericitem_limitation_2: "Beschreibung: maximal 140 Zeichen",
    New_Flow_Tutorials_genericitem_limitation_3: "Maximal 3 Buttons",
    New_Flow_Tutorials_genericitem_limitation_4: "Button-Titel: maximal 40 Zeichen",
    New_Flow_Tutorials_genericitem_limitation_5: "Dateigröße: maximal 50 MB",
    New_Flow_Tutorials_genericitem_limitation_6: "Mindestens ein Button ist erforderlich",
    New_Flow_Tutorials_genericitem_connection_1: "❌ Nachrichten-Eingabeblock",
    New_Flow_Tutorials_genericitem_connection_2: "✅ Galerie-Block",
    New_Flow_Tutorials_genericitem_connection_3: "✅ Weblink-Block",
    New_Flow_Tutorials_genericitem_connection_4: "✅ Sprachmitteilungs-Block",
    New_Flow_Tutorials_genericitem_connection_5: "✅ Textnachrichten-Block",
    New_Flow_Tutorials_genericitem_connection_6: "✅ Schnellantwort-Block",
    New_Flow_Tutorials_genericitem_connection_7: "✅ Bild- und Video-Block",

    New_Flow_Tutorials_weblink_title: "Weblink-Block",
    New_Flow_Tutorials_phonenumbergrabber_title: "Telefonnummer-Erfassungsblock",
    New_Flow_Tutorials_phonenumbergrabber_description:
      "Dieser Block wartet auf den Empfang einer Telefonnummer und speichert sie nach dem Empfang als gültige Nummer.",
    New_Flow_Tutorials_phonenumbergrabber_usageType:
      "Geeignet zum Sammeln von Kundennummern, Anmeldungen, Bestellverfolgung, Beratung und Vertriebskontakt.",
    New_Flow_Tutorials_phonenumbergrabber_feature_1:
      "Wartet auf die Antwort des Nutzers, bis eine Telefonnummer eingeht",
    New_Flow_Tutorials_phonenumbergrabber_feature_2: "Prüft und speichert die empfangene Nummer automatisch",
    New_Flow_Tutorials_phonenumbergrabber_tip_1:
      "Fragen Sie vor diesem Block mit einem Textblock nach der Telefonnummer",
    New_Flow_Tutorials_phonenumbergrabber_tip_2: "Nennen Sie das erwartete Format (z. B. mit Ländervorwahl)",
    New_Flow_Tutorials_phonenumbergrabber_tip_3: "Senden Sie nach diesem Block eine Bestätigungs- oder Dankesnachricht",
    New_Flow_Tutorials_phonenumbergrabber_limitation_1: "Kann nicht der erste Block des Flows sein",
    New_Flow_Tutorials_phonenumbergrabber_limitation_2: "Hat nur einen Eingang und einen Ausgang",
    New_Flow_Tutorials_phonenumbergrabber_limitation_3: "Nur gültige Nummern werden gespeichert",
    New_Flow_Tutorials_phonenumbergrabber_connection_3: "❌ Galerie-Unterzweig-Block",
    New_Flow_Tutorials_phonenumbergrabber_connection_2: "❌ Schnellantwort-Block",
    New_Flow_Tutorials_phonenumbergrabber_connection_1: "❌ Nachrichteneingangsblock (kann nicht der erste Block sein)",
    New_Flow_Tutorials_weblink_description: "Sendet einen klickbaren Weblink, der im Browser des Nutzers geöffnet wird",
    New_Flow_Tutorials_weblink_usageType:
      "Ideal für Websites, Produktseiten, Shops, Registrierungsformulare, Landing Pages und Artikel.",
    New_Flow_Tutorials_weblink_feature_1: "Automatische URL-Validierung",
    New_Flow_Tutorials_weblink_feature_2: "Unterstützung für Links mit/ohne WWW",
    New_Flow_Tutorials_weblink_tip_1: "Verwenden Sie möglichst verkürzte Links",
    New_Flow_Tutorials_weblink_tip_2: "Links vor dem Senden testen",
    New_Flow_Tutorials_weblink_tip_3: "Links sollten mobilfreundlich sein",
    New_Flow_Tutorials_weblink_tip_4: "Zu viele Redirects vermeiden",
    New_Flow_Tutorials_weblink_tip_5: "HTTPS bevorzugen",
    New_Flow_Tutorials_weblink_limitation_1: "Nur http:// oder https:// ist gültig",
    New_Flow_Tutorials_weblink_limitation_2: "Beschreibung kann nicht hinzugefügt werden",
    New_Flow_Tutorials_weblink_limitation_3: "Interne Links (file://) werden nicht unterstützt",
    New_Flow_Tutorials_weblink_connection_1: "⬅️ Eingang: Untergalerie-Block",
    New_Flow_Tutorials_weblink_connection_2: "❌ Keine Ausgabe (Endpunkt des Flows)",

    // #region AIFlow Section

    // #region Notification Section
    Notify_Ok: "Vorgang erfolgreich abgeschlossen",
    Notify_InternalException: "Ein Systemfehler ist aufgetreten",
    Notify_CannotSendSmsNow: "SMS kann derzeit nicht gesendet werden",
    Notify_InvalidPhoneNumber: "Die eingegebene Telefonnummer ist ungültig",
    Notify_InvalidCountryCode: "Die eingegebene Landesvorwahl ist ungültig",
    Notify_PhoneNumberNotAvailableInThisCountry: "Diese Telefonnummer kann im ausgewählten Land nicht verwendet werden",
    Notify_InstagramerIdNotExist: "Instagram-Benutzer nicht gefunden",
    Notify_EmptyProductList: "Produktliste ist leer",
    Notify_InvalidVerificationCode: "Der eingegebene Bestätigungscode ist falsch",
    Notify_LowQuality: "Inhaltsqualität ist niedrig",
    Notify_CannotEmptyChildren: "Unterelemente können nicht gelöscht werden",
    Notify_InvalidAspectRatio: "Das eingegebene Seitenverhältnis ist ungültig",
    Notify_InvalidMediaCodec: "Mediencodec wird nicht unterstützt",
    Notify_InvalidMediaType: "Medientyp wird nicht unterstützt",
    Notify_MediaUrlNotAccessible: "Media-URL ist nicht zugänglich",
    Notify_CannotCreatePrePostNow: "Vorerstellung des Posts derzeit nicht möglich",
    Notify_InvalidMediaContent: "Medieninhalt ist ungültig",
    Notify_Unexpected: "Ein unerwarteter Fehler ist aufgetreten",
    Notify_TooManyRequestForImageHashtagGenerator: "Zu viele Anfragen für die Generierung von Bild-Hashtags",
    Notify_LoginFailed: "Login fehlgeschlagen, bitte erneut versuchen",
    Notify_NullUserId: "Benutzer-ID nicht angegeben",
    Notify_RealtimeSocketNotExist: "Verbindung zum Server nicht hergestellt",
    Notify_PushSocketNotExist: "Verbindung nicht hergestellt",
    Notify_InstaApiNotFoundForConnect: "Verbindung zu Instagram-Servern nicht hergestellt",
    Notify_EmptyHashtagList: "Hashtag-Liste ist leer",
    Notify_InvalidHashtagListId: "Hashtag-Listen-ID ist ungültig",
    Notify_DeleteHashtagFail: "Hashtag-Löschen fehlgeschlagen",
    Notify_InvalidBase64Content: "Base64-Inhalt ungültig",
    Notify_InvalidTermsAndConditionSvgType: "AGB ungültig",
    Notify_InvalidLotteryAnnouncementBannerId: "ID des Lotterie-Banners ungültig",
    Notify_InvalidLotteryAnnouncementBannerStr: "Text des Lotterie-Banners ungültig",
    Notify_InvalidPostId: "Post-ID ungültig",
    Notify_TooSoonLotteryInfo: "Lotterie-Informationen zu früh gesendet",
    Notify_InvalidDirectParams: "Direct-Parameter ungültig",
    Notify_NoInstagramerExists: "Kein Instagram-Konto gefunden",
    Notify_PropertyNotFoundOrNull: "Element nicht gefunden oder leer",
    Notify_ReachNumberOfPinDirect: "Maximale Anzahl an angehefteten Nachrichten erreicht",
    Notify_InvalidStoryId: "Story-ID ungültig",
    Notify_MaxPrePostReach: "Maximale Anzahl an Pre-Posts erreicht",
    Notify_InvalidDraftId: "Entwurfs-ID ungültig",
    Notify_InvalidPrePostId: "Pre-Post-ID ungültig",
    Notify_ReachHashtagListLimit: "Maximale Anzahl an Hashtag-Listen erreicht",
    Notify_EmptyUsername: "Benutzername nicht angegeben",
    Notify_TooManyRequestForPageHashtagAnalysis: "Zu viele Anfragen für Seiten-Hashtag-Analyse",
    Notify_PasswordRequired: "Passwort erforderlich",
    Notify_PackageRequiredInThisTime: "Aktives Paket erforderlich",
    Notify_FeatureRequiredInThisTime: "Diese Funktion muss aktiviert sein",
    Notify_NoShopperExist: "Kein Verkäufer gefunden",
    Notify_FollowerLotteryTypeRandomlyWithoutLoginForVerifiedOrPrivateAccount:
      "Zufällige Follower-Lotterie ohne Login ist für private oder verifizierte Konten nicht erlaubt",
    Notify_FollowerLotteryTypeEngagmentWithoutLoginForPrivateAccount:
      "Follower-Engagement-Lotterie ohne Login ist für private Konten nicht erlaubt",
    Notify_InvalidLinkId: "Link-ID ungültig",
    Notify_ReachMaxBioLink: "Maximale Anzahl an Bio-Links erreicht",
    Notify_OnlyBusinessAccountHasThisAccess: "Dieser Zugriff ist nur für Geschäftskonten verfügbar",
    Notify_NoYoutubeChannelFound: "Kein YouTube-Kanal gefunden",
    Notify_CannotGetYoutubeRightNow: "YouTube-Informationen können gerade nicht abgerufen werden",
    Notify_AparatUsernameNotFound: "Aparat-Benutzername nicht gefunden",
    Notify_AparatChannelHasNotAnyVideo: "Aparat-Kanal enthält keine Videos",
    Notify_InvalidYoutubeChannelId: "YouTube-Kanal-ID ungültig",
    Notify_NoAparatChannelFound: "Kein Aparat-Kanal gefunden",
    Notify_CannotGetAparatRightNow: "Aparat-Informationen können gerade nicht abgerufen werden",
    Notify_NotSettedCustomDomain: "Benutzerdefinierte Domain nicht eingestellt",
    Notify_CannotStoryWithoutWinnerBanner: "Story ohne Gewinner-Banner kann nicht erstellt werden",
    Notify_ExceedMaxStoryWinnerLotteryBanner: "Anzahl der Story-Gewinner-Banner überschreitet Limit",
    Notify_LotteryOnProcessingOrEnded: "Lotterie wird verarbeitet oder ist beendet",
    Notify_CannotAbortLotteryOneHourBefore:
      "Lotterie kann nicht weniger als eine Stunde vor Ausführung abgebrochen werden",
    Notify_CannotAbortFollowerLottery: "Follower-Lotterie kann nicht abgebrochen werden",
    Notify_InvalidImageOrExceedMaxSize: "Bild ungültig oder überschreitet maximale Größe",
    Notify_ExceedLoginAttempt: "Maximale Login-Versuche überschritten",
    Notify_NotExistComment: "Kommentar nicht gefunden",
    Notify_UserNotFound: "Benutzer nicht gefunden",
    Notify_ExistInstagramerBefore: "Dieses Instagram-Konto ist bereits registriert",
    Notify_CannotChangeBusinessAccountType:
      "Änderung des Geschäftskonto-Typs ist nicht möglich, bitte kontaktieren Sie den Support über ein Ticket",
    Notify_InvalidProductId: "Die eingegebene Produkt-ID ist ungültig",
    Notify_InvalidTrendHashtagPeriod: "Der ausgewählte Zeitraum für den Trend-Hashtag ist ungültig",
    Notify_InvalidLanguageId: "Die Sprach-ID ist ungültig",
    Notify_CannotStoryWithoutTermsBanner: "Story ohne Banner der Bedingungen kann nicht erstellt werden",
    Notify_ExceedMaxStoryTermsLotteryBanner:
      "Die Anzahl der Story-Lotterie-Bedingungsbanner überschreitet das zulässige Maximum",
    Notify_LotteryTermsIsNull: "Lotteriebestimmungen wurden nicht registriert",
    Notify_CanShareTermsBefore6HoursOfStartLottery:
      "Bedingungen können nur bis 6 Stunden vor Beginn der Lotterie geteilt werden",
    Notify_CanShareTermForOnlyDefinedStatusLotteries:
      "Bedingungen teilen ist nur für Lotterien im definierten Status aktiv",
    Notify_SharedRemainingTimeBefore: "Verbleibende Zeit wurde bereits geteilt",
    Notify_ShareRemainingTimeOnlyActiveForScoreLottery:
      "Teilen der verbleibenden Zeit ist nur für Punktelotterien aktiv",
    Notify_CanShareTermsBefore1HoursOfStartLottery:
      "Bedingungen können nur bis 1 Stunde vor Beginn der Lotterie geteilt werden",
    Notify_InvalidSubProductIds: "Unterprodukt-IDs sind ungültig",
    Notify_ReachMaxProductMedia: "Maximale Anzahl an Medien für dieses Produkt erreicht",
    Notify_InvalidMediaProductId: "Medienprodukt-ID ist ungültig",
    Notify_AccountNotABusiness: "Dieses Konto ist kein Geschäftskonto",
    Notify_NotFoundProductWithThisTempId: "Kein Produkt mit dieser temporären ID gefunden",
    Notify_InvalidAvailabilityStatus: "Der eingegebene Verfügbarkeitsstatus ist ungültig",
    Notify_InvalidIbanNumber: "Die eingegebene IBAN-Nummer ist ungültig",
    Notify_ExistedIbanNumber: "Diese IBAN-Nummer ist bereits registriert",
    Notify_IbanMethodNotAvailableForNotTomanPriceUser:
      "IBAN-Methode ist für Benutzer mit Nicht-Toman-Währung nicht verfügbar",
    Notify_SearchQueryIsEmpty: "Suchanfrage ist leer",
    Notify_ExceedMaxInEachCard: "Die Anzahl der Elemente in jeder Karte überschreitet das zulässige Maximum",
    Notify_ProductNotAlbumPost: "Dieses Produkt ist nicht als Album-Post registriert",
    Notify_InvalidChildrenId: "Kinder-ID ist ungültig",
    Notify_NotAvailableProduct: "Produkt derzeit nicht verfügbar",
    Notify_ExceedStockCount: "Ausgewählte Menge überschreitet den Lagerbestand",
    Notify_CannotUnloadAnInstanceProduct: "Kann eine Instanz des Produkts nicht entladen",
    Notify_InvalidCategoryId: "Kategorie-ID ist ungültig",
    Notify_NotFoundAnyProductOnThisCategory: "In dieser Kategorie wurde kein Produkt gefunden",
    Notify_NotFoundAnyNextProduct: "Kein nächstes Produkt gefunden",
    Notify_NotFoundAnyPreviousProduct: "Kein vorheriges Produkt gefunden",
    Notify_InvalidItemId: "Artikel-ID ist ungültig",
    Notify_IpInvalid: "Eingegebene IP ist ungültig",
    Notify_InstagramRedirectInTenSeconds: "Sie werden in 10 Sekunden automatisch zu Instagram weitergeleitet",
    Notify_InstagramRedirect: "Weiterleitung zu Instagram",
    Notify_InstagramRedirectExplain: "Stellen Sie sicher, dass Ihr VPN aktiviert ist, da Ihre IP-Adresse ungültig ist",
    Notify_ThisInstagramAccountAddedBefore: "Dieses Instagram-Konto wurde bereits hinzugefügt",
    Notify_InvalidTicketId: "Ticket-ID ist ungültig",
    Notify_ExpiredSignature: "Signatur ist abgelaufen",
    Notify_Forbidden: "Unbefugter Zugriff",
    Notify_ConnectedInstagramPageNotFound: "Verbundene Instagram-Seite nicht gefunden",
    Notify_AllInstagramAccountConnectedAddedBefore: "Alle verbundenen Instagram-Konten wurden bereits hinzugefügt",
    Notify_SelectInstagramPageToConnect: "Bitte wählen Sie die Instagram-Seite zum Verbinden aus",
    Notify_InstagramRedirectRoleNotFound: "Instagram-Weiterleitungsrolle nicht gefunden",
    Notify_FacebookLoginNotFound: "Facebook-Anmeldung nicht gefunden",
    Notify_SelectedPageNotFound: "Ausgewählte Seite nicht gefunden",
    Notify_ShouldConnectInstaPageAgain: "Sie müssen die Instagram-Seite erneut verbinden",
    Notify_InvalidProductSuggestionId: "Produktvorschlags-ID ist ungültig",
    Notify_NotSavedSuggestions: "Vorschläge wurden nicht gespeichert",
    Notify_ExistedSuggestedMedia: "Dieses vorgeschlagene Medium wurde bereits registriert",
    Notify_InvalidUploadMediaUrl: "Medien-Upload-URL ist ungültig",
    Notify_SuggestedPostAutoReplyKeyNotExist: "Automatische Antwortschlüssel für vorgeschlagenes Post nicht gefunden",
    Notify_UploadingTimeIsSoSoon: "Upload-Zeit ist zu früh",
    Notify_InvalidPreStoryId: "Pre-Story-ID ist ungültig",
    Notify_NotProvidedInstagramerId: "Instagramer-ID nicht angegeben",
    Notify_InvalidInstagramerId: "Instagramer-ID ist ungültig",
    Notify_InvalidThreadId: "Thread-ID ist ungültig",
    Notify_InvalidLiveMediaId: "Live-Medien-ID ist ungültig",
    Notify_NotCreatedExportComment: "Kommentar-Export nicht erstellt",
    Notify_CreateExportAvailableWith24HourPeriod: "Export kann alle 24 Stunden erstellt werden",
    Notify_NotSetted: "Nicht eingestellt",
    Notify_ExceedGeneralAutoReplyCount: "Allgemeine Auto-Reply-Anzahl überschreitet das Limit",
    Notify_InvalidTransactionId: "Transaktions-ID ist ungültig",
    Notify_CannotRenewalPackageWith1MonthTimeExist: "1-Monats-Paket kann derzeit nicht verlängert werden",
    Notify_CannotDeleteCurrentSession: "Aktuelle Sitzung kann nicht gelöscht werden",
    Notify_InvalidSessionId: "Sitzungs-ID ist ungültig",
    Notify_CannotDeleteCurrentSessionForNewSessionFor1Day:
      "Die aktuelle Sitzung kann für 1 Tag nicht gelöscht werden, um eine neue Sitzung zu erstellen",
    Notify_UpgradedBefore: "Dieses Konto wurde bereits aktualisiert",
    Notify_PermissionNotExist: "Berechtigung existiert nicht",
    Notify_NotExistUser: "Benutzer nicht gefunden",
    Notify_UserAlreadyAsPartner: "Benutzer ist bereits als Partner-Admin registriert",
    Notify_ReachMaxPartnerCount: "Maximale Anzahl an Partner-Admins erreicht",
    Notify_InvalidPartnerRoleProvided: "Angegebene Partner-Admin-Rolle ist ungültig",
    Notify_PartnerRolesLengthIsZero: "Keine Rolle für Partner-Admin definiert",
    Notify_PartnerNotExist: "Partner-Admin nicht gefunden",
    Notify_CannotMakeYourSelfPartnerAsPartnerForYourSelf:
      "Sie können sich nicht als Partner-Admin für sich selbst auswählen",
    Notify_PartnerExpireTimeMustBeBiggerThan1HourFromNow:
      "Die Ablaufzeit des Partner-Admins muss mindestens 1 Stunde ab jetzt betragen",
    Notify_PartnerNameCannotExceed100: "Der Name des Partner-Admins darf 100 Zeichen nicht überschreiten",
    Notify_ProductIsMultiSubproducted: "Dieses Produkt enthält mehrere Unterprodukte",
    Notify_InvalidSubProductId: "Unterprodukt-ID ist ungültig",
    Notify_ProductIdOutOfStock: "Das Produkt ist nicht auf Lager",
    Notify_SubProductIdRequired: "Unterprodukt-ID ist erforderlich",
    Notify_CardIsEmpty: "Die Karte ist leer",
    Notify_InvalidAddressId: "Adress-ID ist ungültig",
    Notify_ExceedTotalCreateAddress: "Maximale Anzahl erlaubter Adressen überschritten",
    Notify_NotSupportedCountry: "Das ausgewählte Land wird nicht unterstützt",
    Notify_CannotFetchAddressInThisEndpoint: "Adresse kann an diesem Endpunkt nicht abgerufen werden",
    Notify_InvalidPostalCode: "Postleitzahl ist ungültig",
    Notify_NeedCompleteAddress: "Komplette Adresseingabe erforderlich",
    Notify_CannotBuyFromYourSelf: "Sie können nicht bei sich selbst kaufen",
    Notify_AllReadyIsBusiness: "Dieses Konto ist bereits als Geschäft registriert",
    Notify_InvalidBusinessType: "Geschäftskonto-Typ ist ungültig",
    Notify_UserAlreadyAuthorized: "Benutzer wurde bereits autorisiert",
    Notify_InstagramerNotInfluencer: "Der Instagramer ist kein Influencer",
    Notify_InstagramerNotShopper: "Der Instagramer ist kein Verkäufer",
    Notify_AuthorizedInstagramerBefore: "Dieser Instagramer wurde bereits autorisiert",
    Notify_UserNotAuthorizedYet: "Benutzer noch nicht autorisiert",
    Notify_InstagramerNotAuthorized: "Instagramer nicht autorisiert",
    Notify_InvalidBankCardNotify_InvalidBankCardNumber: "Bankkartennummer ist ungültig",
    Notify_TheOwnerOfPhoneNumberNotBlongsNationalNumber:
      "Der Besitzer der Telefonnummer stimmt nicht mit der nationalen Nummer überein",
    Notify_CouponCodeAlreadyExists: "Gutscheincode existiert bereits",
    Notify_InvalidCouponId: "Gutschein-ID ist ungültig",
    Notify_CannotChangeShowPrivateCouponInBio: "Anzeige des privaten Gutscheins im Bio kann nicht geändert werden",
    Notify_InvalidCouponCode: "Gutscheincode ist ungültig",
    Notify_CouponForAnotherPerson: "Gutschein gehört einer anderen Person",
    Notify_CouponExpired: "Gutschein ist abgelaufen",
    Notify_CouponDeleted: "Gutschein wurde gelöscht",
    Notify_CouponUsedUp: "Gutschein wurde aufgebraucht",
    Notify_InvalidUsernameSearchQuery: "Ungültige Benutzernamen-Suchanfrage",
    Notify_PreviouslyAddedShopAddress: "Diese Shop-Adresse wurde bereits hinzugefügt",
    Notify_NotSettedShopperAddress: "Adresse des Käufers nicht gesetzt",
    Notify_NotExistAnyLogesticInYourCountry: "Kein Logistiksystem in Ihrem Land vorhanden",
    Notify_InvalidLogesticIds: "Logistik-IDs sind ungültig",
    Notify_LogsticsNotSetted: "Logistik nicht gesetzt",
    Notify_NotCommpletedAllBusinessVerification: "Alle Geschäftsüberprüfungen sind nicht abgeschlossen",
    Notify_ThisParcelNotSupportedByAnySelectedAvailableLogestic:
      "Dieses Paket wird von keiner ausgewählten verfügbaren Logistik unterstützt",
    Notify_NotSupportedLogestic: "Ausgewählte Logistik wird nicht unterstützt",
    Notify_ExceedLogesticHeight: "Pakethöhe überschreitet das Logistiklimit",
    Notify_ExceedLogesticWidth: "Paketbreite überschreitet das Logistiklimit",
    Notify_ExceedLogesticLength: "Paketlänge überschreitet das Logistiklimit",
    Notify_ExceedLogesticTotalLength: "Gesamtlänge des Pakets überschreitet das Logistiklimit",
    Notify_ExceedLogesticWeight: "Paketgewicht überschreitet das Logistiklimit",
    Notify_UserAddressesIsEmptyOrNotSetDefaultAddress: "Benutzeradressen sind leer oder Standardadresse nicht gesetzt",
    Notify_NotSupportedBoxByThisDimensions: "Box mit diesen Abmessungen wird nicht unterstützt",
    Notify_CannotAvailableOutOfStackProduct: "Produkt kann nicht außerhalb des Bestands verfügbar gemacht werden",
    Notify_YouAreDeadInCivilRegistration: "Sie sind im Zivilregister als verstorben eingetragen",
    Notify_InstagramerAlreadyAuthorized: "Instagramer ist bereits autorisiert",
    Notify_ThreadShouldBeActiveForSendMessage: "Thread muss aktiv sein, um eine Nachricht zu senden",
    Notify_PreviouslyClosedTicket: "Ticket wurde zuvor geschlossen",
    Notify_NotMatchedCart: "Warenkorb stimmt nicht überein",
    Notify_PhoneNumberNotBlongsNationalNumber: "Telefonnummer stimmt nicht mit der nationalen Nummer überein",
    Notify_NotMatchedCardNumberAndIdentity: "Kartennummer und Identitätsinformationen stimmen nicht überein",
    Notify_SuspendedShop: "Dieser Shop ist gesperrt, bitte kontaktieren Sie den Support",
    Notify_LogesticIdNotSpecifiedForaPostParcel: "Logistik-ID für Postpaket nicht angegeben",
    Notify_LogesticNotInAvailableLogestics: "Ausgewählte Logistik ist nicht in der Liste verfügbarer Logistiken",
    Notify_ExceedProductReportForLast24Hour: "Produktberichtanzahl in den letzten 24 Stunden überschreitet das Limit",
    Notify_PreviouslyReportedThisProduct: "Sie haben dieses Produkt bereits gemeldet",
    Notify_InvalidOrderId: "Bestell-ID ist ungültig",
    Notify_NotPendingPayRequest: "Zahlungsanforderung ist nicht ausstehend",
    Notify_NotExistShopAddress: "Shop-Adresse nicht gefunden",
    Notify_InvalidOrderStatus: "Bestellstatus ist ungültig",
    Notify_CancelInvoiceFailed: "Rechnung konnte nicht storniert werden",
    Notify_PaymentSystemNotSupportedThisPriceType: "Zahlungssystem unterstützt diesen Preistyp nicht",
    Notify_InvalidSentOrderType: "Gesendeter Bestelltyp ist ungültig",
    Notify_InvalidParcelId: "Paket-ID ist ungültig",
    Notify_AddedParcelIdBefore: "Paket-ID wurde bereits hinzugefügt",
    Notify_InvoiceNotOnPaid: "Rechnung ist noch nicht bezahlt",
    Notify_CreatedSystemTicketOnOrderBefore: "Systemticket für diese Bestellung wurde bereits erstellt",
    Notify_PaymentServiceNotResponding: "Zahlungsdienst reagiert momentan nicht",
    Notify_YouAreNotAdmin: "Sie sind kein Admin",
    Notify_YouAreNotASubAdmin: "Sie sind kein Sub-Admin",
    Notify_InvalidFbId: "Ungültige Facebook-ID",
    Notify_InvalidFeatureId: "Ungültige Feature-ID",
    Notify_InActiveFeature: "Dieses Feature ist inaktiv",
    Notify_FeaturePaused: "Dieses Feature wurde pausiert",
    Notify_InvalidPromptInput: "Ungültige Prompt-Eingabe",
    Notify_PromptNotGenerated: "Prompt nicht generiert",
    Notify_AIGeneratorFailed: "KI-Generator ist auf einen Fehler gestoßen",
    Notify_NotExecutedPromptForCommentYet: "Prompt für Kommentar wurde noch nicht ausgeführt",

    Notify_InstagramPermissionNotExist: "Instagram-Berechtigung existiert nicht",
    Notify_InvalidTimeZone: "Ungültige Zeitzone",
    Notify_PromptCaptionExampleNotGenerated: "Prompt-Beschriftungsbeispiel wurde nicht generiert",
    Notify_InvalidMasterFlowId: "Ungültige Master-Flow-ID",
    Notify_InvalidFlowId: "Ungültige Flow-ID",
    Notify_EmptySubFlows: "Sub-Flows sind leer",
    Notify_InvalidFlowObject: "Ungültiges Flow-Objekt",
    Notify_InvalidMasterFlowTitle: "Ungültiger Master-Flow-Titel",
    Notify_InvalidPromptId: "Ungültige Prompt-ID",
    Notify_ExceedThreadTokenLimit: "Token-Limit für dieses Gespräch überschritten",
    Notify_InvalidMediaId: "Ungültige Medien-ID",
    Notify_InvalidLotteryId: "Ungültige Lotterie-ID",
    Notify_CannotAbortNonUpcomingLottery: "Kann nicht-anstehende Lotterien derzeit nicht abbrechen",
    Notify_CommentCountExceedFreeExport: "Kommentaranzahl überschreitet das erlaubte Limit für kostenlose Lotterie",
    Notify_InvalidReserveFeatureId: "Ungültige Reserve-Feature-ID",
    Notify_CannotRenewalThisFeatureNow: "Kann dieses Feature derzeit nicht erneuern",
    Notify_InvalidLotteryStatus: "Lotterie-Status ist nicht gültig für Änderung",
    Notify_PublishedLotteryBannerBefore: "Lotterie-Banner wurde zuvor veröffentlicht",
    Notify_LotteryWinnerBannerIsNull: "Lotterie-Gewinner-Banner existiert nicht",
    Notify_InvalidCustomPromptSigniture: "Ungültige benutzerdefinierte Prompt-Signatur",
    Notify_ServiceTemporarilyUnavailable: "Service ist vorübergehend nicht verfügbar",
    Notify_PageSummaryNotGenerated:
      "Brancy benötigt mehr Daten, um Ihre Seite zu analysieren.\nBitte haben Sie etwas Geduld.",
    Notify_GenerateAIFail: "KI-Generierung fehlgeschlagen",
    Notify_InvalidPageAnalysis: "Ungültige Seitenanalyse",
    Notify_InvalidCustomPrompt: "Ungültige benutzerdefinierte Eingabeaufforderung",
    Notify_AIModelNotSupportImage: "Das KI-Modell unterstützt keine Bilder",
    Notify_PromptNotSupportImage: "Die Eingabeaufforderung unterstützt keine Bilder",
    Notify_AIModelNotSupportAudio: "Das KI-Modell unterstützt kein Audio",
    Notify_PromptNotSupportVoice: "Die Eingabeaufforderung unterstützt keine Sprache",
    Notify_AIModelNotSupportVideo: "Das KI-Modell unterstützt kein Video",
    Notify_InvalidPrompt: "Ungültige Eingabeaufforderung",
    Notify_InvalidImageGeneratorInput: "Ungültige Eingabe für den Bildgenerator",
    Notify_InSuffcientNumberOfImage: "Unzureichende Anzahl von Bildern",
    Notify_CreateImageExceedLimit: "Bildgenerierungslimit überschritten",
    Notify_InvalidPromptType: "Ungültiger Eingabeaufforderungstyp",
    Notify_UnSupportedAIInputType: "Nicht unterstützter KI-Eingabetyp",
    Notify_UnSupportedOrientationType: "Nicht unterstützter Ausrichtungstyp",
    Notify_SoraFailedAiCall: "Sora KI-Aufruf fehlgeschlagen",
    Notify_AIVideoSecondNotSupported: "KI-Videodauer wird nicht unterstützt",
    Notify_FailedToTraslateDescription: "Beschreibung konnte nicht übersetzt werden",
    Notify_FailedToGenerateEmbedVector: "Einbettungsvektor konnte nicht generiert werden",
    Notify_NotGeneratedSummaryYet: "Zusammenfassung wurde noch nicht generiert",
    Notify_NoEventsFoundForTheGivenTimeRange: "Keine Ereignisse für den angegebenen Zeitraum gefunden",
    Notify_NoEventsFoundForThisPrompt: "Keine Ereignisse für diese Eingabeaufforderung gefunden",
    Notify_PageAnalysisNotExist: "Seitenanalyse existiert nicht",
    Notify_NoEventIdeaGenerated: "Es wurde keine Ereignisidee generiert",
    Notify_PhoneNumberAddedBefore: "Diese Telefonnummer wurde bereits hinzugefügt",
    Notify_WhatsAppCodeSendedBeforeAndWait1Day: "Ein WhatsApp-Code wurde bereits gesendet. Bitte warten Sie einen Tag",
    Notify_WhatsAppCodeNotRequested: "Es wurde kein WhatsApp-Bestätigungscode angefordert",
    Notify_WhatsAppCodeMaxInvalidCountReach: "Die maximale Anzahl ungültiger WhatsApp-Codeversuche wurde erreicht",
    Notify_UserWithThisPhoneNumberAlreadyExist: "Ein Benutzer mit dieser Telefonnummer existiert bereits",
    Notify_InvalidAIToolId: "Ungültige ID des KI-Werkzeugs",
    Notify_AIToolParameterRequired: "Der Parameter des KI-Werkzeugs ist erforderlich",
    Notify_AIToolParameterNotRequired: "Dieses KI-Werkzeug akzeptiert keinen Parameter",
    Notify_ExceedDailyLimit: "Das Tageslimit wurde überschritten",
    Notify_CannotGetTwitchRightNow: "Twitch-Daten können derzeit nicht abgerufen werden",
    Notify_InvalidTwitchChannelId: "Ungültige Twitch-Kanal-ID",
    Notify_PhoneNumberRequired: "Die Telefonnummer ist erforderlich",
    Notify_NotVerifiedHost: "Der Host ist nicht verifiziert",
    Notify_NotBusinesser: "Dieser Benutzer ist kein Geschäftsinhaber",
    Notify_NotFoundAnySuggestedCategory: "Es wurde keine vorgeschlagene Kategorie gefunden",
    Notify_NoInvoiceExist: "Es existiert keine Rechnung",
    Notify_InvalidMediaAiCreatorKey: "Ungültiges KI-Modell",
    Notify_InvalidMediaAiVersionKey: "Ungültige KI-Version",
    Notify_InvalidMediaAiRequestModel: "Ungültiges Anfragemodell für KI-Medien",
    Notify_MediaAIError: "Beim Erstellen der KI-Medien ist ein Fehler aufgetreten",
    Notify_TwitchChannelDoestHaveAnyVideo: "Dieser Twitch-Kanal enthält keine Videos",
    Notify_CouponAlreadyDeleted: "Dieser Gutschein wurde bereits gelöscht",
    Notify_CouponNotDeleted: "Dieser Gutschein ist nicht gelöscht",
    Notify_ExceedSubFlowCount: "Die maximale Anzahl an Unterabläufen wurde überschritten",
    Notify_ExceedFlowDepth: "Die maximale Ablauftiefe wurde überschritten",
    Notify_ExceedFlowItemCount: "Die maximale Anzahl an Ablaufelementen wurde überschritten",
    Notify_ExceedFlowMediaAudioCount: "Die maximale Anzahl an Medien- und Audioelementen im Ablauf wurde überschritten",
    Notify_OneFlowButtonHasEmptyItem: "Eine der Schaltflächen hat keinen Ablauf",
    InternalNotify_Ok: "Vorgang erfolgreich abgeschlossen",
    InternalNotify_RepetitiveHashtagInput: "Eingegebener Hashtag ist wiederholt",
    InternalNotify_NotFoundDevice: "Gerät nicht gefunden",
    InternalNotify_EmptyHashtagList: "Leere Liste kann nicht erstellt werden",
    InternalNotify_CannotCreatePrePostNow: "Pre-Post kann derzeit nicht erstellt werden",
    InternalNotify_PrivateAccountSelectedForCheckHashtag: "Privates Konto kann für Analyse nicht ausgewählt werden",
    InternalNotify_InstagramLoginRequired: "Diese Option erfordert Instagram-Login",
    InternalNotify_InstagramLoginRequiredForVerifiedAccount:
      "Diese Option erfordert Instagram-Login für verifizierte Konten",
    InternalNotify_PrivateOrVerifiedSponsor:
      "Privates oder verifiziertes Konto kann nicht als Sponsor ausgewählt werden",
    InternalNotify_StartUploadingPost: "Post wird hochgeladen",
    InternalNotify_UploadingPostError: "Fehler beim Hochladen des Posts",
    InternalNotify_PostUploaded: "Post hochgeladen, Seite zum Anzeigen aktualisieren",
    InternalNotify_ExceededMedia: "Anzahl der Medien überschreitet das Limit",
    InternalNotify_More4IceBreaker: "Sie können nicht mehr als 4 Schnellgespräche haben",
    InternalNotify_CopyLink: "Ihr Link wurde kopiert",
    InternalNotify_copy: "Informationen erfolgreich kopiert",
    InternalNotify_CopyTrackingpost: "Ihr Paket-Tracking-Code wurde kopiert",
    InternalNotify_Network: "Netzwerkverbindungsfehler",
    InternalNotify_TimeExpire: "Registrierung nicht möglich, Zeit abgelaufen",
    InternalNotify_ExceedPermittedHashtagNumber: "Anzahl der Hashtags überschreitet das erlaubte Limit",
    InternalNotify_UnexpectedError: "Ein unerwarteter Fehler ist aufgetreten",
    InternalNotify_CopyToClipboard: "Ihre Informationen wurden bereits in die Zwischenablage kopiert",
    InternalNotify_ExceedPermittedUploadMedia: "Die Anzahl der Medien überschreitet das zulässige Limit",
    InternalNotify_FillRedBorderFields: "Bitte füllen Sie die rot umrandeten Felder aus",
    InternalNotify_RepeatedVariation: "Mindestens zwei Elemente sind wiederholt",
    InternalNotify_NeedOneProduct: "Mindestens ein Produkt ist erforderlich",
    InternalNotify_UploadMedia: "Problem beim Hochladen von Medien",
    InternalNotify_TurnOnProxy: "Sie müssen eine gültige IP verwenden",
    InternalNotify_ExceedPermittedLiveTime: "Live-Zeit hat das erlaubte Limit überschritten",
    InternalNotify_CommentDisabled: "Sie können keine Aktionen ausführen, wenn Kommentare deaktiviert sind",
    InternalNotify_ExceedSelectedCollaboratorPage:
      "Anzahl der ausgewählten Mitarbeiterseiten überschreitet das erlaubte Limit",
    InternalNotify_RepetitiveCollaboratorPage: "Dieser Benutzername wurde bereits ausgewählt",
    InternalNotify_ExceedPermittedSizeOfImage: "Bildgröße überschreitet das erlaubte Limit",
    InternalNotify_ExceedPermittedAspectRatioAlbum: "Seitenverhältnis des Albumvideos überschreitet das erlaubte Limit",
    InternalNotify_ExceedPermittedSizeOfVideoAlbum: "Größe des Albumvideos überschreitet das erlaubte Limit",
    InternalNotify_ExceedPermittedDurationOfVideoAlbum: "Dauer des Albumvideos überschreitet das erlaubte Limit",
    InternalNotify_ExceedPermittedAspectRatioReels: "Seitenverhältnis der Reels überschreitet das erlaubte Limit",
    InternalNotify_ExceedPermittedSizeOfVideoReels: "Größe der Reels überschreitet das erlaubte Limit",
    InternalNotify_ExceedPermittedDurationOfVideoReels: "Dauer der Reels überschreitet das erlaubte Limit",
    InternalNotify_NotPermittedMediaType: "Medientyp ist nicht erlaubt",
    InternalNotify_InvalidMetaData: "Metadaten sind ungültig",
    InternalNotify_ExceedSelectedMaxTaggedPeople: "Anzahl der markierten Personen überschreitet das erlaubte Limit",
    InternalNotify_ExceedSelectedMaxHashtags: "Anzahl der ausgewählten Hashtags überschreitet das erlaubte Limit",
    InternalNotify_ExistedInCollaborate:
      "Dieser Benutzername existiert bereits unter den Mitarbeitern und kann nicht auf der ersten Folie sein",
    InternalNotify_ExceedPermittedAspectRatioStory: "Seitenverhältnis der Story überschreitet das erlaubte Limit",
    InternalNotify_ExceedPermittedSizeOfVideoStory: "Story-Videogröße überschreitet das erlaubte Limit",
    InternalNotify_ExceedPermittedWidthOfVideo: "Videobreite überschreitet das erlaubte Limit",
    InternalNotify_ExceedPermittedDurationOfVideoStory: "Story-Videodauer überschreitet das erlaubte Limit",
    InternalNotify_BelowMinimumDurationOfVideoStory: "Das Story-Video muss mindestens 3 Sekunden lang sein",
    InternalNotify_ExceedPermittedSpecificWordForAutoreply:
      "Anzahl der speziellen Wörter für automatische Antwort überschreitet das erlaubte Limit",
    InternalNotify_ExceedPermittedAspectRatioImage: "Seitenverhältnis des Bildes überschreitet das erlaubte Limit",
    InternalNotify_Success: "Vorgang erfolgreich abgeschlossen",
    InternalNotify_CreateExportAvailableWith24HourPeriod: "Export mit 24-Stunden-Zeitraum erstellen ist verfügbar",
    InternalNotify_SaveIceBreaker: "Erfolgreich hinzugefügt",
    InternalNotify_deleteIceBreaker: "Erfolgreich gelöscht",
    InternalNotify_SavePersistenceMenu: "Persistenzmenü erfolgreich hinzugefügt",
    InternalNotify_SelectLanguage: "Sprache erfolgreich geändert",
    InternalNotify_SaveFollowTemplate: "Follow-Vorlage erfolgreich gespeichert",
    InternalNotify_AutoReplyOn: "Automatische Antwort erfolgreich aktiviert",
    InternalNotify_AutoReplyOff: "Automatische Antwort erfolgreich deaktiviert",
    InternalNotify_AutoGeneralOn: "Allgemeine automatische Antwort erfolgreich aktiviert",
    InternalNotify_AutoGeneralOff: "Allgemeine automatische Antwort erfolgreich deaktiviert",
    InternalNotify_MaxInEachCard: "Maximal in jeder Karte",
    InternalNotify_ExceedStockCard: "Angeforderte Menge überschreitet den Kartenbestand",
    InternalNotify_DefaultAddress: "Sie können die Standardadresse nicht löschen",
    InternalNotify_FetchingYourData: "Daten werden abgerufen, bitte warten...",
    InternalNotify_EmptyTitleInQuickReply: "Titel der Schnellantwort ist leer",
    InternalNotify_EmptyTitleForOutputsInQuickReply: "Ausgabetitel in Schnellantworten sind leer",
    InternalNotify_EmptyTitleForFlow: "Flusstitel ist leer",
    InternalNotify_MultipleFlowForPrivateReply: "Sie können nicht mehrere Flows für private Antworten haben",
    InternalNotify_NotPermittedForDownload: "Sie dürfen diesen Inhalt nicht herunterladen",
    InternalNotify_NotFeature: "Dieses Feature ist in Ihrem aktuellen Plan nicht enthalten",
    InternalNotify_ExceedBasefeatureTime: "Die maximale Zeit für diese Basisfunktion wurde überschritten",
    InternalNotify_ChannelIdNotStartedWithUC: "Channel ID muss mit 'UC' beginnen",
    InternalNotify_PageAnalysisNotCompleted: "Leider wurde Ihre Seite noch nicht von der KI analysiert",
    JustCreated: "Ticket wurde registriert",
    AdminReplied: "Der Support hat geantwortet",
    UserReplied: "Der Benutzer hat geantwortet",
    AdminClosed: "Ticket wurde vom Support geschlossen",
    UserClosed: "Ticket wurde vom Benutzer geschlossen",
    TimerClosed: "Ticket wurde automatisch geschlossen",
    closethisticket: "Dieses Ticket schließen",

    Create: "Erstellen",
    image: "Bild",
    video: "Video",
    Images: "Bilder",
    Videos: "Videos",
    "Generated artwork and visuals": "Erstellte Grafiken und Visualisierungen",
    "AI motion and clips": "KI-Bewegungen und Clips",
    "Media type": "Medientyp",

    "Generated AI video preview": "Vorschau des mit KI erstellten Videos",

    Close: "Schließen",
    Prompt: "Prompt",
    Metadata: "Metadaten",
    Creator: "Ersteller",
    Version: "Version",
    Status: "Status",
    "Image ID": "Bild-ID",
    "Video ID": "Video-ID",
    "Job ID": "Aufgaben-ID",
    "Download image": "Bild herunterladen",
    "Download video": "Video herunterladen",
    "Your browser does not support video playback.": "Ihr Browser unterstützt keine Videowiedergabe.",

    Uploading: "Hochladen",
    "Add video": "Video hinzufügen",
    "Add audio": "Audio hinzufügen",
    "Add reference image": "Referenzbild hinzufügen",
    model: "Modell",
    models: "Modelle",
    "resize aspect ratio": "Seitenverhältnis ändern",
    "Video models": "Videomodelle",
    "Image models": "Bildmodelle",
    "Cost level {level}": "Kostenstufe {level}",
    "Calculating...": "Wird berechnet...",
    "Search from People or Keyword": "Personen oder Schlüsselwort suchen",
    "Create new Flow": "Neuen Flow erstellen",
    "Welcome illustration": "Willkommensillustration",
    "Untitled generation": "Unbenannte Erstellung",
    "No images yet": "Noch keine Bilder",
    "No videos yet": "Noch keine Videos",
    "Your successful image generations will appear here.": "Ihre erfolgreich erstellten Bilder erscheinen hier.",
    "Your successful video generations will appear here.": "Ihre erfolgreich erstellten Videos erscheinen hier.",
    "Create your first image": "Erstellen Sie Ihr erstes Bild",
    "Create your first video": "Erstellen Sie Ihr erstes Video",
    "Generating image": "Bild wird erstellt",
    "Generating video": "Video wird erstellt",
    "In progress": "In Bearbeitung",
    "Just now": "Gerade eben",
    "Waiting for the result": "Warten auf das Ergebnis",

    "Try again": "Erneut versuchen",

    "AI provider": "KI-Anbieter",

    "Choose a model": "Modell auswählen",

    "Describe the subject, setting, light, composition, and style...":
      "Beschreiben Sie Motiv, Umgebung, Licht, Komposition und Stil...",
    "Use at least {count} characters.": "Verwenden Sie mindestens {count} Zeichen.",

    "Video creator is unavailable": "Videoersteller ist nicht verfügbar",
    "Image creator is unavailable": "Bildersteller ist nicht verfügbar",
    "No video models found": "Keine Videomodelle gefunden",
    "No image models found": "Keine Bildmodelle gefunden",
    "There are no video generation models available for this account.":
      "Für dieses Konto sind keine Videogenerierungsmodelle verfügbar.",
    "There are no image generation models available for this account.":
      "Für dieses Konto sind keine Bildgenerierungsmodelle verfügbar.",
    "Not available": "Nicht verfügbar",
    // #endregion Notification Section
    how: "Wie",
    SharedRemainingTimeBefore: "Sie müssen 24 Stunden warten, bevor Sie erneut teilen können.",
    ConnectProduct: "Direkte Produktverknüpfung",
    messagesetting_ConnectProductResponseExplain: "Verbinden Sie Ihr Produkt mit der Story oder dem Live.",
    biolinkProperties_Connect: "Verbinden",
    economy: "Wirtschaftlich",

    text: "Text",
    Retry: "Erneut versuchen",
    media: "Video/Foto",
    ReplyStory: "Auf Story antworten",
    photo: "Foto",
    audio: "Sprachnachricht",
    Generic: "Allgemein",
    StoryMention: "Story-Erwähnung",
    FileShare: "Datei",
    voice: "Audio",
    SettingGeneralProfileTitle: "Profil",
    messagesetting_SpecifyProductResponseExplain:
      "Legen Sie ein Produkt fest, das automatisch an die Nutzer gesendet wird",
    messagesetting_ProductResponseExplain: "Verbinden Sie das aktuelle Produkt mit dem Benutzer",

    // #region wallet
    createdtime: "Erstellungszeit",
    BankCards: "Bankkarten",
    Transactions: "Transaktionen",
    Settlements: "Abrechnungen",
    AddNewBankCard: "Neue Bankkarte hinzufügen",
    RegisterANewCard: "Neue Karte registrieren",
    CardBankNumber: "Bankkartennummer",
    CardNumberExplain:
      "Geben Sie Ihre Kartennummer ein. Die Bankkarte muss auf den Namen der registrierten Person ausgestellt sein.",
    RegisterBankCard: "Bankkarte registrieren",
    CardNumber: "Kartennummer",
    DefaultBankCard: "Standard-Bankkarte",
    SetAsDefaultBankCard: "Als Standard-Bankkarte festlegen",
    Type: "Typ",
    Suspended: "Gesperrt",
    Amount: "Betrag",
    Time: "Zeit",
    Order: "Bestellung",
    User: "Benutzer",
    NotAvailable: "Nicht verfügbar",
    Unsettled: "Nicht abgerechnet",
    AwaitingSettled: "Abrechnung ausstehend",
    Settled: "Abgerechnet",
    SettlementFailed: "Abrechnung fehlgeschlagen",
    SettleRequest: "Abrechnungsanfrage",
    emptyInvoice: "Es wurden noch keine Rechnungen registriert.",
    InvoiceID: "Rechnungs-ID",
    InvoiceType: "Rechnungstyp",
    InvoiceHistory: "Rechnungshistorie",
    OrderDetails: "Bestelldetails",
    InvoiceDetails: "Rechnungsdetails",
    Paid: "Bezahlt",
    Success: "Erfolgreich",
    RefundRequest: "Rückerstattungsanfrage",
    Refunding: "Rückerstattung läuft",
    Refunded: "Erstattet",
    RefundFailed: "Rückerstattung fehlgeschlagen",
    Failed: "Fehlgeschlagen",
    Package: "Paket",
    Product: "Produkt",
    Feature: "Funktion",
    Custom: "Benutzerdefiniert",
    Invoice: "Rechnung",
    UnknownStatus: "Unbekannter Status",
    NoSettlementsRegisteredYet: "Es wurden noch keine Abrechnungen registriert.",
    LogesticPayment: "Logistikzahlung",
    ProductIncome: "Produkteinnahmen",
    BrancyFeatureIncome: "Brancy-Funktionseinnahmen",
    BrancyLogesticPayment: "Brancy-Logistikzahlung",
    BrancyPackageIncome: "Brancy-Paketeinnahmen",
    BrancyProductIncome: "Brancy-Produkteinnahmen",
    BrancyTransferPayment: "Brancy-Übertragungsgebühr",
    WalletBalance: "Wallet-Guthaben",
    TotalWithdrawn: "Insgesamt abgehoben",
    FailedTransactions: "Fehlgeschlagene Transaktionen",
    PendingSettlement: "Abrechnung ausstehend",
    OrderInProgress: "Bestellung wird bearbeitet",
    OrderPickup: "Abholung der Bestellung",
    OrderDelivery: "Lieferung der Bestellung",
    SubInvoiceHistory: "Verlauf der Unterrechnungen",
    history: "Verlauf",
    // #endregion wallet
  },
};
